const resources = {
  en: {
    translation: {
      common: {
        cancel: "Cancel",
        close: "Close",
        back: "Back",
        menu: "Menu",
        search: "Search",
        bookmarks: "Bookmarks",
        notes: "Notes",
        pages: "Pages",
        tableOfContents: "Table of Contents",
        page: "Page",
        section: "Section",
        loading: "Loading...",
        submit: "Submit",
        apply: "Apply",
        remove: "Remove",
        error: "Error",
        language: "Language",
        theme: "Theme",
        light: "Light",
        dark: "Dark",
        on: "On",
        off: "Off",
        showMore: "Show more",
        showLess: "Show less",
        undo: "Undo",
        redo: "Redo",
        underline: "Underline",
        highlight: "Highlight",
        textbox: "Text box",
        document: "Document",
        color: "Color",
      },
      toolbar: {
        expand: "Expand toolbar",
        collapse: "Collapse toolbar",
        aiAssistant: "Ask AI Assistant",
        aiAssistantComingSoon: "Ask AI Assistant (Coming soon)",
        searchNotAllowed: "Search not allowed",
        textToSpeechComingSoon: "Text-to-speech (Coming soon)",
        addBookmark: "Add bookmark",
        removeBookmark: "Remove bookmark",
        bookmarked: "Bookmarked",
        bookmarksNotAllowed: "Bookmarks not allowed",
        moreOptions: "More options",
        display: "Display",
        lightHint: "Light background with dark text",
        darkHint: "Dark background with light text",
        pageView: "Page view",
        singlePage: "Single page",
        singlePageHint: "Scroll one page at a time",
        doublePage: "Double page",
        doublePageHint: "View pages side by side",
        view: "Color Mode",
        share: "Share",
        download: "Download",
        citation: "Citation",
        print: "Print",
        displayMenu: "Display menu",
        displayMenuItems: {
          colorMode: "Color Mode",
          fontSize: "Font Size",
          fontFamily: "Font",
          lineHeight: "Line Height",
          increaseLineHeight: "Increase line height",
          decreaseLineHeight: "Decrease line height",
          layout: "Layout",
          rotate: "Rotate",
          readingDirection: "Reading Direction",
          rotateLeft: "Rotate left",
          rotateRight: "Rotate right",
          ltr: "Left to right",
          rtl: "Right to left",
          fonts: {
            original: "Original",
            sans: "Sans",
            serif: "Serif",
          },
          colors: {
            light: "Light",
            dark: "Dark",
            mint: "Mint",
            sepia: "Sepia",
          },
        },
      },
      mobile: {
        searchPlaceholder: "Search keyword...",
        cancelSearch: "Cancel search",
        faq: "FAQ",
      },
      menu: {
        close: "Close menu",
        documentPageCount: "Page {{current}} of {{total}}",
      },
      rightToolbar: {
        showToc: "Show table of contents",
        hideToc: "Hide table of contents",
        showPagesThumbnails: "Show pages thumbnails",
        hidePagesThumbnails: "Hide pages thumbnails",
        showBookmarks: "Show bookmarks",
        hideBookmarks: "Hide bookmarks",
        info: "Publication Info",
        showPublicationDetails: "Show publication details",
        hidePublicationDetails: "Hide publication details",
        askAi: "Ask AI",
        showReadingAssistant: "Show Reading Assistant",
        hideReadingAssistant: "Hide Reading Assistant",
        readingGroup: "Reading Group",
        showNotes: "Show notes",
        hideNotes: "Hide notes",
        myNotebook: "My Notebook",
        clickToEnterPage: "Click to enter page number",
        currentPageLabel: "Current page {{current}}. Click to change.",
        previousPage: "Previous page",
        nextPage: "Next page",
        zoomOut: "Zoom out",
        zoomIn: "Zoom in",
        resetZoom: "Reset zoom",
        resetZoomTitle: "Reset zoom to 100%",
        decreaseFontSize: "Decrease font size",
        increaseFontSize: "Increase font size",
        resetFontSize: "Reset font size",
        resetFontSizeTitle: "Reset font size to 100%",
        viewModeOptions: "View mode options",
        fitToWidth: "Fit to Width",
        fitToPage: "Fit to Page",
        disabledInDoublePage: "Not available in double page mode",
        enterFullscreen: "Enter Fullscreen",
        exitFullscreen: "Exit Fullscreen",
        enterPageNumber: "Enter page number",
        pageInputPlaceholder: "{{min}}-{{max}}",
        pageInputTitle: "Enter page number ({{min}}-{{max}})",
        pageInputInvalid: "Please enter a valid page number",
        pageInputOutOfRange: "Page must be between 1 and {{total}}",
      },
      floatingToolbar: {
        ariaLabel: "Floating toolbar",
        dragToMove: "Drag to move",
        dragToolbar: "Drag toolbar",
        notesOn: "Turn notes on",
        notesOff: "Turn notes off",
        notesNotAllowed: "Notes not allowed",
        notesOnLabel: "Notes: On",
        notesOffLabel: "Notes: Off",
        drawingOn: "Turn drawing on",
        drawingOff: "Turn drawing off",
        drawingNotAllowed: "Drawing not allowed",
        drawingOnLabel: "Drawing: On",
        drawingOffLabel: "Drawing: Off",
        textBoxComingSoon: "Text box (Coming soon)",
        textboxNotAllowed: "Text box not allowed",
        textboxOn: "Turn text box on",
        textboxOff: "Turn text box off",
        textboxOnLabel: "Text Box: On",
        textboxOffLabel: "Text Box: Off",
        highlightOn: "Turn highlight on",
        highlightOff: "Turn highlight off",
        highlightsNotAllowed: "Highlights not allowed",
        highlightOnLabel: "Highlight: On",
        highlightOffLabel: "Highlight: Off",
        highlightColorLabel: "Highlight color",
        colorRed: "Red",
        colorOrange: "Orange",
        colorYellow: "Yellow",
        colorGreen: "Green",
        colorLightBlue: "Light Blue",
        colorPurple: "Purple",
        underlinesNotAllowed: "Underlines not allowed",
        underlineOn: "Turn underline on",
        underlineOff: "Turn underline off",
        underlineOnLabel: "Underline: On",
        underlineOffLabel: "Underline: Off",
        undo: "Undo ({{ctrl}}+Z)",
        redo: "Redo ({{ctrl}}+Y)",
        undoCooldown: "Undo (please wait)",
        redoCooldown: "Redo (please wait)",
      },
      contextMenu: {
        addNote: "Add Note",
        highlight: "Highlight",
        underline: "Underline",
        copy: "Copy",
        removeHighlight: "Remove Highlight",
        removeUnderline: "Remove Underline",
        searchSelected: "Search for selected word",
        selectionToolbar: "Selection menu",
        askAi: "Ask AI",
        share: "Share",
        translate: "Translate",
        comingSoon: "Coming soon",
        translationTitle: "Translation",
        translating: "Translating…",
        translationFailed: "Translation failed",
      },
      readerShell: {
        loadingDocument: "Loading document...",
        documentControls: "Document controls",
      },
      emptyState: {
        errorAlt: "Error",
        documentAlt: "Document",
        unableToLoad: "Unable to load document",
        noDocument: "No document loaded",
        requestDoc: "Request a document from your library to get started",
      },
      unauthorizedDomain: {
        errorAlt: "Unauthorized domain",
        title: "Unsupported access domain",
        description: "This reader cannot be opened from this address.",
        moreInfo: "For more information, please visit:",
      },
      search: {
        ariaLabel: "Search results",
        searchResults: "Search Results",
        close: "Close search",
        placeholder: "Search in document...",
        clear: "Clear search",
        searching: "Searching...",
        enterQuery: "Enter a search query to find text in the document",
        noResults: "No results found for \"{{query}}\"",
        resultsCount_one: "Found {{count}} result",
        resultsCount_other: "Found {{count}} results",
        matchCount_one: "{{count}} match",
        matchCount_other: "{{count}} matches",
        navigateToResult: "Click to navigate to this result",
      },
      bookmarks: {
        title: "Bookmarks",
        close: "Close bookmarks",
        loading: "Loading bookmarks...",
        error: "Error loading bookmarks: {{error}}",
        noItems: "No bookmarks yet",
        navigate: "Click to navigate to this bookmark",
        navigateLabel: "Navigate to {{label}}",
        remove: "Remove bookmark",
        removeLabel: "Remove bookmark {{label}}",
        deleteError: "Failed to delete bookmark",
        defaultLabel: "Bookmark {{page}}",
      },
      notes: {
        title: "My Notebook",
        close: "Close My Notebook",
        share: "Share notebook",
        searchPlaceholder: "Type here",
        clearSearch: "Clear search",
        tabsLabel: "Notebook filters",
        tabs: {
          all: "All",
          highlight: "Highlight",
          underline: "Underline",
          note: "Note",
        },
        resultsFound_one: "{{count}} Result found",
        resultsFound_other: "{{count}} Result found",
        copyItem: "Copy item",
        shareItem: "Share item",
        navigate: "Click to navigate to this note",
        ariaLabel: "Note: {{preview}} Page {{page}} {{created}}",
        createdOn: "Created on {{date}}",
        pageTitle: "Page {{page}}",
        remove: "Delete item",
        removeLabel: "Remove note from Page {{page}}",
        none: "No items yet",
        noItems: "No items yet",
      },
      readingAssistant: {
        title: "Reading Assistant",
        close: "Close Reading Assistant",
        resize: "Resize Reading Assistant",
        resizeHint: "Drag to resize. Double-click to reset.",
        tabsLabel: "Reading Assistant tabs",
        tabs: {
          summary: "Summary",
          askAi: "Ask AI",
          quiz: "Quiz",
        },
        status: {
          loading: "Checking…",
          processing: "This document is still being prepared for AI. Please try again shortly.",
          unavailable: "AI features are not available for this document.",
          failed: "Document processing failed. AI features are not available.",
          error: "Unable to load AI features. {{message}}",
        },
        summary: {
          typesLabel: "Summary type",
          types: {
            quick: "Quick Summary",
            detailed: "Detailed Summary",
            chapter: "Chapter-by-Chapter Summary",
          },
          cardTitles: {
            quick: "The Quick Summary",
            detailed: "The Detailed Summary",
            chapter: "Chapter-by-Chapter Summary",
          },
          welcomeTitle: "Reading Assistant",
          welcome: "Welcome to the AI-powered reading experience. Choose a summary option below when you're ready.",
          loading: "Generating summary",
          error: "Could not generate a summary. {{message}}",
          empty: "Choose a summary type to generate one.",
          chooseChapter: "Choose a chapter below to generate its summary.",
          chapterListLabel: "Chapters",
          noChapters: "No chapters are available for this document.",
          backToTypes: "Back",
          regenerate: "Regenerate",
        },
        askAi: {
          placeholder: "Ask anything about this book...",
          submit: "Send question",
          empty: "Ask a question to start the conversation.",
          sending: "Thinking",
          error: "Could not get a response. {{message}}",
          export: "Export",
          newChat: "New chat",
        },
        quiz: {
          title: "Take a Quiz",
          subtitle: "Choose what you'd like to be tested on.",
          cta: "Take the Quiz",
          loading: "Generating quiz",
          error: "Could not generate a quiz. {{message}}",
          modalTitle: "AI Quiz",
          disclaimer: "AI-generated content, for reference only.",
          close: "Close quiz",
          checkAnswer: "Check Answer",
          explanation: "Explanation",
          previous: "Previous",
          next: "Next Question",
          finish: "Finish",
          progress: "Question {{current}} of {{total}}",
          answerRequired: "Answer this question to continue.",
          completedTitle: "Quiz Completed!",
          yourScore: "Your Score",
          completedMessage: "You have completed the quiz successfully.",
          reattempt: "Reattempt Quiz",
          save: "Save",
          saving: "Saving…",
          saved: "Saved",
          saveError: "Could not save quiz result. {{message}}",
          deleteError: "Could not delete quiz result. {{message}}",
          deleteResult: "Delete saved quiz",
          deletedToast: "Quiz deleted",
          recentQuizzes: "Recent Quizzes",
          seeDetails: "See Details",
          showDetails: "Show Details",
          hideDetails: "Hide Details",
          correct: "Correct",
          incorrect: "Incorrect",
          multipleChoice: "Multiple Choice",
          questionStatusAria: "Question {{number}}: {{status}}",
          backToDashboard: "Quiz Dashboard",
          scopeLabel: "Quiz scope",
          scopeBook: "By Book",
          scopeChapter: "By Chapter",
          scopePage: "By Page",
          scopePageTitle: "Page {{page}}",
          scoreAria: "Score {{correct}} out of {{total}}",
          answerOptions: "Answer options",
          navigationAria: "Quiz navigation",
          noQuestions: "No quiz questions returned",
          feedback: {
            greatJob: "Great Job!",
            goodEffort: "Good Effort!",
            keepPracticing: "Keep Practicing!",
          },
        },
        menu: {
          preferences: "AI Preferences",
          citation: "AI Citation",
          copy: "AI Copy",
          quizzes: "AI Quizzes",
          notes: "Notes",
          prefs: {
            aiLanguage: "Preferred language",
            citationEnabled: "Show citations",
            contextInclusionEnabled: "Include reading context",
          },
        },
      },
      publicationDetails: {
        title: "Publication Details",
        close: "Close publication details",
        copy: "Copy publication details",
        copied: "Copied to clipboard",
        description: "Description",
        noData: "No data available",
        empty: "No publication details are available for this document.",
        fields: {
          title: "Title",
          author: "Author",
          code: "Code",
          type: "Type",
          language: "Language",
          original_publisher: "Original publisher",
          series: "Series",
          edition: "Edition",
          pages: "Pages",
          pisbn13: "PISBN13",
          publication_year: "Publication year",
          copyright_year: "Copyright year",
          read_direction: "Read direction",
          content_type: "Content type",
        },
      },
      toc: {
        title: "Table of Contents",
        close: "Close table of contents",
        untitled: "Untitled section",
        empty: "No table of contents available",
        noItems: "No table of contents available",
        chapter: "Chapter",
      },
      pages: {
        title: "Pages",
        count_one: "{{count}} page",
        count_other: "{{count}} pages",
        empty: "No pages available",
        thumbnailAlt: "Page {{page}}",
        ariaLabel: "Page thumbnails",
      },
      pullouts: {
        fallbackTitle: "Pullout",
        hintLabel: "Hint:",
        hintAvailable: "Hint available",
        expandHint: "Expand hint",
        collapseHint: "Collapse hint",
      },
      epub: {
        loading: "Loading EPUB...",
        errorTitle: "Error loading EPUB",
        reload: "Reload Page",
        imageAlt: "Image",
        imageLightboxAria: "Expanded image",
        closeImagePreview: "Close image preview",
        noteIndicatorTitle: "Note {{current}} of {{total}}: {{text}}{{suffix}}",
        noteSelectedSuffix: " (Selected text note)",
        noteTitleEdit: "Edit Note",
        noteTitleAdd: "Add Note",
        noteCounter: "({{current}} of {{total}})",
        selectedTextLabel: "Selected text:",
        notePlaceholderSelected: "Add your note about the selected text...",
        notePlaceholder: "Type note",
        noteActionSave: "Save",
        noteActionCreate: "Create",
        contextAddNote: "Add Note",
        contextHighlight: "Highlight",
        contextSearch: "Search for selected word",
      },
      notifications: {
        featureNotAllowed: "This feature is not available.",
        featureComingSoon: "This feature is coming soon.",
        highlightsNotAvailable: "Highlighting is not available for this document.",
        underlinesNotAvailable: "Underlining is not available for this document.",
        notesNotAvailable: "Notes are not available for this document.",
        drawingNotAvailable: "Drawing is not available for this document.",
        bookmarksNotAvailable: "Bookmarks are not available for this document.",
        searchNotAvailable: "Search is not available for this document.",
        commentsNotAvailable: "Comments are not available for this document.",
        pageOutOfRange: "This page is not available.",
        aiAssistantComingSoon: "AI Assistant coming soon.",
        textBoxComingSoon: "Text boxes coming soon.",
        textboxNotAllowed: "Text box not allowed",
        textToSpeechComingSoon: "Text-to-speech coming soon.",
        sessionExpired: "Your session has expired. Please refresh and try again.",
        operationFailed: "Unable to {{operation}}. Please try again.",
        operations: {
          completeAction: "complete this action",
          saveAiPreferences: "save AI preferences",
          copyText: "copy text",
          saveBookmark: "save bookmark",
          deleteBookmark: "delete bookmark",
          saveNote: "save note",
          updateNote: "update note",
          deleteNote: "delete note",
          saveHighlight: "save highlight",
          updateHighlight: "update highlight",
          deleteHighlight: "delete highlight",
          saveUnderline: "save underline",
          deleteUnderline: "delete underline",
          saveDrawing: "save drawing",
          deleteDrawing: "delete drawing",
          updateTextbox: "update text box",
          deleteTextbox: "delete text box",
        },
        copyLimitExceeded: "Copy limit exceeded. Only {{limit}} characters were copied.",
        copyNotAllowed: "Copy is not allowed for this document.",
      },
      faq: {
        open: "Open FAQ",
        title: "How to use the E-Reader",
      },
      help: {
        close: "Close help",
        title: "E-Reader User Guide",
        featuresTab: "Features",
        shortcutsTab: "Keyboard Shortcuts",
        gesturesTab: "Touch Gestures",
        gestures: {
          title: "Touch gestures",
          tap: "Tap",
          tapDesc: "Select an item or open a link",
          doubleTap: "Double Tap",
          doubleTapDesc: "Zoom in or zoom out",
          swipeLeft: "Swipe Left",
          swipeLeftDesc: "Go to the next page",
          swipeRight: "Swipe Right",
          swipeRightDesc: "Go to the previous page",
          swipeUpDown: "Swipe Up / Down",
          swipeUpDownDesc: "Scroll through the page",
          pinchOut: "Pinch Out (two fingers spread)",
          pinchIn: "Pinch In (two fingers close)",
          longPress: "Long Press",
          longPressDesc: "Select text or open additional options",
        },
        readingNav: "Reading & Navigation",
        navigation: "Page Navigation",
        navigationDesc: "Use the page input field to jump to any page",
        zoomControls: "Zoom Controls",
        zoomControlsDesc: "Adjust zoom level or select fit-to-width/page mode",
        search: "Search",
        searchDesc: "Find and navigate through text in the document",
        displayDesc: "Change reading appearance and page layout options",
        publicationDesc: "View details about the current publication",
        organization: "Organization",
        bookmarks: "Bookmarks",
        bookmarksDesc: "Save important pages for quick access",
        notes: "Notes",
        notesDesc: "Review highlights, underlines, and notes in My Notebook",
        annotationTools: "Annotation Tools",
        highlights: "Highlights",
        highlightsDesc: "Highlight important text to stand out",
        underlineDesc: "Underline text to mark key passages",
        drawing: "Drawing",
        drawingDesc: "Draw freehand annotations directly on pages",
        undoRedo: "Undo & Redo",
        undoRedoDesc: "Revert or redo your annotations",
        comingSoon: "Coming Soon",
        audioReading: "Audio Reading",
        audioReadingDesc: "Listen to document content with text-to-speech",
        aiAssistant: "AI Assistant",
        aiAssistantDesc: "Get intelligent insights and summaries",
        translateDesc: "Translate selected text with AI",
        shortcuts: {
          navigationAccessibility: "Navigation & Accessibility",
          browseForward: "Browse forward through interactive elements",
          browseBackward: "Browse backward through interactive elements",
          activateButton: "Activate focused button or link",
          selectToggle: "Select or toggle focused element",
          closeDialogs: "Close open dialogs and menus",
          nextPrevPage: "Next or previous page",
          jumpTop: "Jump to document start",
          jumpBottom: "Jump to document end",
          zoomViewControls: "Zoom & View Controls",
          zoomIn: "Zoom in",
          zoomOut: "Zoom out",
          fitWidth: "Fit to width",
          fitPage: "Fit to page",
          editingAnnotations: "Editing & Annotations",
          undo: "Undo last action",
          redo: "Redo last action",
          toggleHighlight: "Toggle highlight mode",
          drawingBrush: "Toggle drawing brush",
          toggleNotes: "Toggle notes sidebar",
          toggleBookmarks: "Toggle bookmarks sidebar",
          openToc: "Open table of contents",
          saveBookmark: "Save bookmark",
          searchContent: "Search & Content",
          searchWithin: "Search within document",
          copyText: "Copy selected text",
          selectAll: "Select all text in the current page or view",
        },
      },
      loading: {
        ariaLabel: "Loading",
        initializing: "Initializing...",
        restoringSession: "Restoring session...",
        fetchingAccessToken: "Fetching access token...",
        loadingDocument: "Loading document...",
        authenticating: "Authenticating...",
        finalizing: "Finalizing...",
      },
      landingPage: {
        uploadTitle: "Upload Document",
        uploadSubtitle: "Drag and drop a PDF or EPUB file here, or click to upload",
        supportedFormats: "Supported formats: PDF, EPUB",
        uploadAriaLabel: "Upload PDF or EPUB file",
      },
      errors: {
        failedToLoadPdf: "Failed to load PDF",
        failedToLoadEpub: "Failed to load EPUB",
        unsupportedFileType: "Unsupported file type. Please upload a PDF or EPUB.",
        errorReadingFile: "Error reading file.",
        searchFailed: "Search failed",
        failedToRestoreSession: "Failed to restore session.",
        failedToInitializeReader: "Failed to initialize reader from token.",
      },
    },
  },
  el: {
    translation: {
      common: {
        cancel: "Ακύρωση",
        close: "Κλείσιμο",
        menu: "Μενού",
        search: "Αναζήτηση",
        bookmarks: "Σελιδοδείκτες",
        notes: "Σημειώσεις",
        pages: "Σελίδες",
        tableOfContents: "Πίνακας περιεχομένων",
        page: "Σελίδα",
        section: "Ενότητα",
        loading: "Φόρτωση...",
        submit: "Υποβολή",
        apply: "Εφαρμογή",
        remove: "Αφαίρεση",
        error: "Σφάλμα",
        language: "Γλώσσα",
        theme: "Θέμα",
        light: "Ανοιχτό",
        dark: "Σκούρο",
        on: "Ενεργό",
        off: "Ανενεργό",
        showMore: "Εμφάνιση περισσότερων",
        showLess: "Εμφάνιση λιγότερων",
        undo: "Αναίρεση",
        redo: "Επανάληψη",
        underline: "Υπογράμμιση",
        highlight: "Επισήμανση",
        textbox: "Πλαίσιο κειμένου",
        document: "Έγγραφο",
        color: "Χρώμα",
        back: "Πίσω",
      },
      toolbar: {
        expand: "Επέκταση γραμμής εργαλείων",
        collapse: "Σύμπτυξη γραμμής εργαλείων",
        aiAssistant: "Ρώτησε τον AI Βοηθό",
        aiAssistantComingSoon: "Ρώτησε τον AI Βοηθό (Σύντομα)",
        searchNotAllowed: "Η αναζήτηση δεν επιτρέπεται",
        textToSpeechComingSoon: "Μετατροπή κειμένου σε ομιλία (Σύντομα)",
        addBookmark: "Προσθήκη σελιδοδείκτη",
        removeBookmark: "Αφαίρεση σελιδοδείκτη",
        bookmarked: "Σελιδοδείκτης",
        bookmarksNotAllowed: "Οι σελιδοδείκτες δεν επιτρέπονται",
        moreOptions: "Περισσότερες επιλογές",
        display: "Εμφάνιση",
        lightHint: "Ανοιχτό φόντο με σκούρο κείμενο",
        darkHint: "Σκούρο φόντο με ανοιχτό κείμενο",
        pageView: "Προβολή σελίδας",
        singlePage: "Μονή σελίδα",
        singlePageHint: "Κύλιση μία σελίδα τη φορά",
        doublePage: "Διπλή σελίδα",
        doublePageHint: "Προβολή σελίδων δίπλα-δίπλα",
        view: "Λειτουργία χρωμάτων",
        share: "Κοινοποίηση",
        download: "Λήψη",
        citation: "Παραπομπή",
        print: "Εκτύπωση",
        displayMenu: "Μενού εμφάνισης",
        displayMenuItems: {
          colorMode: "Λειτουργία χρώματος",
          fontSize: "Μέγεθος γραμματοσειράς",
          fontFamily: "Γραμματοσειρά",
          lineHeight: "Ύψος γραμμής",
          increaseLineHeight: "Αύξηση ύψους γραμμής",
          decreaseLineHeight: "Μείωση ύψους γραμμής",
          layout: "Διάταξη",
          rotate: "Περιστροφή",
          readingDirection: "Κατεύθυνση ανάγνωσης",
          rotateLeft: "Περιστροφή αριστερά",
          rotateRight: "Περιστροφή δεξιά",
          ltr: "Αριστερά προς δεξιά",
          rtl: "Δεξιά προς αριστερά",
          fonts: {
            original: "Αρχική",
            sans: "Sans",
            serif: "Serif",
          },
          colors: {
            light: "Φωτεινό",
            dark: "Σκοτεινό",
            mint: "Μέντα",
            sepia: "Σέπια",
          },
        },
      },
      mobile: {
        searchPlaceholder: "Αναζήτηση λέξης-κλειδιού...",
        cancelSearch: "Ακύρωση αναζήτησης",
        faq: "Συχνές Ερωτήσεις",
      },
      menu: {
        close: "Κλείσιμο μενού",
        documentPageCount: "Σελίδα {{current}} από {{total}}",
      },
      rightToolbar: {
        showToc: "Εμφάνιση πίνακα περιεχομένων",
        hideToc: "Απόκρυψη πίνακα περιεχομένων",
        showPagesThumbnails: "Εμφάνιση μικρογραφιών σελίδων",
        hidePagesThumbnails: "Απόκρυψη μικρογραφιών σελίδων",
        showBookmarks: "Εμφάνιση σελιδοδεικτών",
        hideBookmarks: "Απόκρυψη σελιδοδεικτών",
        info: "Πληροφορίες έκδοσης",
        showPublicationDetails: "Εμφάνιση στοιχείων έκδοσης",
        hidePublicationDetails: "Απόκρυψη στοιχείων έκδοσης",
        askAi: "Ρωτήστε το AI",
        readingGroup: "Ομάδα ανάγνωσης",
        showNotes: "Εμφάνιση σημειώσεων",
        hideNotes: "Απόκρυψη σημειώσεων",
        myNotebook: "Το σημειωματάριό μου",
        clickToEnterPage: "Κάντε κλικ για εισαγωγή αριθμού σελίδας",
        currentPageLabel: "Τρέχουσα σελίδα {{current}}. Κάντε κλικ για αλλαγή.",
        previousPage: "Προηγούμενη σελίδα",
        nextPage: "Επόμενη σελίδα",
        zoomOut: "Σμίκρυνση",
        zoomIn: "Μεγέθυνση",
        resetZoom: "Επαναφορά ζουμ",
        resetZoomTitle: "Επαναφορά ζουμ στο 100%",
        decreaseFontSize: "Μείωση μεγέθους γραμματοσειράς",
        increaseFontSize: "Αύξηση μεγέθους γραμματοσειράς",
        resetFontSize: "Επαναφορά μεγέθους γραμματοσειράς",
        resetFontSizeTitle: "Επαναφορά μεγέθους γραμματοσειράς στο 100%",
        viewModeOptions: "Επιλογές προβολής",
        fitToWidth: "Προσαρμογή στο πλάτος",
        fitToPage: "Προσαρμογή στη σελίδα",
        enterFullscreen: "Είσοδος σε πλήρη οθόνη",
        exitFullscreen: "Έξοδος από πλήρη οθόνη",
        enterPageNumber: "Εισαγάγετε αριθμό σελίδας",
        pageInputPlaceholder: "{{min}}-{{max}}",
        pageInputTitle: "Εισαγωγή αριθμού σελίδας ({{min}}-{{max}})",
        pageInputInvalid: "Εισαγάγετε έγκυρο αριθμό σελίδας",
        pageInputOutOfRange: "Η σελίδα πρέπει να είναι μεταξύ 1 και {{total}}",
        showReadingAssistant: "Εμφάνιση Βοηθού Ανάγνωσης",
        hideReadingAssistant: "Απόκρυψη Βοηθού Ανάγνωσης",
      },
      floatingToolbar: {
        ariaLabel: "Αιωρούμενη γραμμή εργαλείων",
        dragToMove: "Σύρετε για μετακίνηση",
        dragToolbar: "Σύρετε τη γραμμή εργαλείων",
        notesOn: "Ενεργοποίηση σημειώσεων",
        notesOff: "Απενεργοποίηση σημειώσεων",
        notesNotAllowed: "Οι σημειώσεις δεν επιτρέπονται",
        notesOnLabel: "Σημειώσεις: Ενεργό",
        notesOffLabel: "Σημειώσεις: Ανενεργό",
        drawingOn: "Ενεργοποίηση σχεδίασης",
        drawingOff: "Απενεργοποίηση σχεδίασης",
        drawingNotAllowed: "Η σχεδίαση δεν επιτρέπεται",
        drawingOnLabel: "Σχεδίαση: Ενεργό",
        drawingOffLabel: "Σχεδίαση: Ανενεργό",
        textBoxComingSoon: "Πλαίσιο κειμένου (Σύντομα)",
        textboxNotAllowed: "Text box not allowed",
        textboxOn: "Ενεργοποίηση πλαισίου κειμένου",
        textboxOff: "Απενεργοποίηση πλαισίου κειμένου",
        textboxOnLabel: "Πλαίσιο κειμένου: Ενεργό",
        textboxOffLabel: "Πλαίσιο κειμένου: Ανενεργό",
        highlightOn: "Ενεργοποίηση επισήμανσης",
        highlightOff: "Απενεργοποίηση επισήμανσης",
        highlightsNotAllowed: "Οι επισημάνσεις δεν επιτρέπονται",
        highlightOnLabel: "Επισήμανση: Ενεργό",
        highlightOffLabel: "Επισήμανση: Ανενεργό",
        underlineOn: "Ενεργοποίηση υπογράμμισης",
        underlineOff: "Απενεργοποίηση υπογράμμισης",
        underlineOnLabel: "Υπογράμμιση: Ενεργό",
        underlineOffLabel: "Υπογράμμιση: Ανενεργό",
        undo: "Αναίρεση ({{ctrl}}+Z)",
        highlightColorLabel: "Χρώμα επισήμανσης",
        colorRed: "Κόκκινο",
        colorOrange: "Πορτοκαλί",
        colorYellow: "Κίτρινο",
        colorGreen: "Πράσινο",
        colorLightBlue: "Ανοιχτό μπλε",
        colorPurple: "Μοβ",
        underlinesNotAllowed: "Οι υπογραμμίσεις δεν επιτρέπονται",
        redo: "Επανάληψη ({{ctrl}}+Y)",
        undoCooldown: "Αναίρεση (παρακαλώ περιμένετε)",
        redoCooldown: "Επανάληψη (παρακαλώ περιμένετε)",
      },
      contextMenu: {
        addNote: "Προσθήκη σημείωσης",
        highlight: "Επισήμανση",
        underline: "Υπογράμμιση",
        copy: "Αντιγραφή",
        removeHighlight: "Αφαίρεση επισήμανσης",
        removeUnderline: "Αφαίρεση υπογράμμισης",
        searchSelected: "Αναζήτηση επιλεγμένης λέξης",
        selectionToolbar: "Μενού επιλογής",
        askAi: "Ρωτήστε το AI",
        share: "Κοινοποίηση",
        translate: "Μετάφραση",
        comingSoon: "Σύντομα",
        translationTitle: "Μετάφραση",
        translating: "Μετάφραση…",
        translationFailed: "Η μετάφραση απέτυχε",
      },
      readerShell: {
        loadingDocument: "Φόρτωση εγγράφου...",
        documentControls: "Έλεγχοι εγγράφου",
      },
      emptyState: {
        errorAlt: "Σφάλμα",
        documentAlt: "Έγγραφο",
        unableToLoad: "Αδυναμία φόρτωσης εγγράφου",
        noDocument: "Δεν έχει φορτωθεί έγγραφο",
        requestDoc: "Ζητήστε ένα έγγραφο από τη βιβλιοθήκη σας για να ξεκινήσετε",
      },
      search: {
        ariaLabel: "Αποτελέσματα αναζήτησης",
        searchResults: "Αποτελέσματα Αναζήτησης",
        close: "Κλείσιμο αναζήτησης",
        placeholder: "Αναζήτηση στο έγγραφο...",
        clear: "Εκκαθάριση αναζήτησης",
        searching: "Αναζήτηση...",
        enterQuery: "Εισαγάγετε όρο αναζήτησης για να βρείτε κείμενο στο έγγραφο",
        noResults: "Δεν βρέθηκαν αποτελέσματα για \"{{query}}\"",
        resultsCount_one: "Βρέθηκε {{count}} αποτέλεσμα",
        resultsCount_other: "Βρέθηκαν {{count}} αποτελέσματα",
        matchCount_one: "{{count}} αντιστοίχιση",
        matchCount_other: "{{count}} αντιστοιχίσεις",
        navigateToResult: "Κάντε κλικ για μετάβαση σε αυτό το αποτέλεσμα",
      },
      bookmarks: {
        title: "Σελιδοδείκτες",
        close: "Κλείσιμο σελιδοδεικτών",
        loading: "Φόρτωση σελιδοδεικτών...",
        error: "Σφάλμα φόρτωσης σελιδοδεικτών: {{error}}",
        noItems: "Δεν υπάρχουν σελιδοδείκτες ακόμα",
        navigate: "Κάντε κλικ για μετάβαση σε αυτόν τον σελιδοδείκτη",
        remove: "Αφαίρεση σελιδοδείκτη",
        removeLabel: "Αφαίρεση σελιδοδείκτη {{label}}",
        deleteError: "Αποτυχία διαγραφής σελιδοδείκτη",
        navigateLabel: "Μετάβαση στο {{label}}",
        defaultLabel: "Σελιδοδείκτης {{page}}",
      },
      notes: {
        title: "Το σημειωματάριό μου",
        close: "Κλείσιμο του σημειωματάριού μου",
        navigate: "Κάντε κλικ για μετάβαση σε αυτή τη σημείωση",
        ariaLabel: "Σημείωση: {{preview}} Σελίδα {{page}} {{created}}",
        createdOn: "Δημιουργήθηκε στις {{date}}",
        pageTitle: "Σελίδα {{page}}",
        remove: "Αφαίρεση σημείωσης",
        removeLabel: "Αφαίρεση σημείωσης από τη Σελίδα {{page}}",
        none: "Δεν υπάρχουν σημειώσεις ακόμα",
        noItems: "Δεν υπάρχουν στοιχεία ακόμα",
        share: "Κοινοποίηση σημειωματάριου",
        searchPlaceholder: "Πληκτρολογήστε εδώ",
        clearSearch: "Εκκαθάριση αναζήτησης",
        tabsLabel: "Φίλτρα σημειωματάριου",
        tabs: {
          all: "Όλα",
          highlight: "Επισήμανση",
          underline: "Υπογράμμιση",
          note: "Σημείωση",
        },
        resultsFound_one: "Βρέθηκε {{count}} αποτέλεσμα",
        resultsFound_other: "Βρέθηκαν {{count}} αποτελέσματα",
        copyItem: "Αντιγραφή στοιχείου",
        shareItem: "Κοινοποίηση στοιχείου",
      },
      toc: {
        title: "Πίνακας περιεχομένων",
        close: "Κλείσιμο πίνακα περιεχομένων",
        untitled: "Χωρίς τίτλο ενότητα",
        empty: "Δεν υπάρχει διαθέσιμος πίνακας περιεχομένων",
        noItems: "Δεν υπάρχει διαθέσιμος πίνακας περιεχομένων",
        chapter: "Κεφάλαιο",
      },
      pages: {
        title: "Σελίδες",
        count_one: "{{count}} σελίδα",
        count_other: "{{count}} σελίδες",
        empty: "Δεν υπάρχουν διαθέσιμες σελίδες",
        thumbnailAlt: "Σελίδα {{page}}",
        ariaLabel: "Μικρογραφίες σελίδων",
      },
      epub: {
        loading: "Φόρτωση EPUB...",
        errorTitle: "Σφάλμα φόρτωσης EPUB",
        reload: "Επαναφόρτωση σελίδας",
        noteIndicatorTitle: "Σημείωση {{current}} από {{total}}: {{text}}{{suffix}}",
        noteSelectedSuffix: " (Σημείωση επιλεγμένου κειμένου)",
        noteTitleEdit: "Επεξεργασία σημείωσης",
        noteTitleAdd: "Προσθήκη σημείωσης",
        noteCounter: "({{current}} από {{total}})",
        selectedTextLabel: "Επιλεγμένο κείμενο:",
        notePlaceholderSelected: "Προσθέστε τη σημείωσή σας για το επιλεγμένο κείμενο...",
        notePlaceholder: "Πληκτρολογήστε σημείωση",
        noteActionSave: "Αποθήκευση",
        noteActionCreate: "Δημιουργία",
        contextAddNote: "Προσθήκη σημείωσης",
        contextHighlight: "Επισήμανση",
        contextSearch: "Αναζήτηση της επιλεγμένης λέξης",
        imageAlt: "Εικόνα",
        imageLightboxAria: "Μεγεθυμένη εικόνα",
        closeImagePreview: "Κλείσιμο προεπισκόπησης εικόνας",
      },
      notifications: {
        featureNotAllowed: "Αυτή η λειτουργία δεν είναι διαθέσιμη.",
        featureComingSoon: "Αυτή η λειτουργία έρχεται σύντομα.",
        highlightsNotAvailable: "Η επισήμανση δεν είναι διαθέσιμη για αυτό το έγγραφο.",
        underlinesNotAvailable: "Η υπογράμμιση δεν είναι διαθέσιμη για αυτό το έγγραφο.",
        notesNotAvailable: "Οι σημειώσεις δεν είναι διαθέσιμες για αυτό το έγγραφο.",
        drawingNotAvailable: "Η σχεδίαση δεν είναι διαθέσιμη για αυτό το έγγραφο.",
        bookmarksNotAvailable: "Οι σελιδοδείκτες δεν είναι διαθέσιμοι για αυτό το έγγραφο.",
        searchNotAvailable: "Η αναζήτηση δεν είναι διαθέσιμη για αυτό το έγγραφο.",
        commentsNotAvailable: "Τα σχόλια δεν είναι διαθέσιμα για αυτό το έγγραφο.",
        pageOutOfRange: "Αυτή η σελίδα δεν είναι διαθέσιμη.",
        aiAssistantComingSoon: "Ο AI Βοηθός έρχεται σύντομα.",
        textBoxComingSoon: "Τα πλαίσια κειμένου έρχονται σύντομα.",
        textToSpeechComingSoon: "Η μετατροπή κειμένου σε ομιλία έρχεται σύντομα.",
        sessionExpired: "Η συνεδρία σας έληξε. Ανανεώστε και δοκιμάστε ξανά.",
        operationFailed: "Αδυναμία ολοκλήρωσης {{operation}}. Δοκιμάστε ξανά.",
        copyLimitExceeded: "Υπέρβαση ορίου αντιγραφής. Αντιγράφηκαν μόνο {{limit}} χαρακτήρες.",
        copyNotAllowed: "Η αντιγραφή δεν επιτρέπεται για αυτό το έγγραφο.",
        operations: {
          saveAiPreferences: "αποθήκευσης προτιμήσεων AI",
          copyText: "αντιγραφής κειμένου",
          completeAction: "ολοκλήρωσης αυτής της ενέργειας",
          saveBookmark: "αποθήκευσης σελιδοδείκτη",
          deleteBookmark: "διαγραφής σελιδοδείκτη",
          saveNote: "αποθήκευσης σημείωσης",
          updateNote: "ενημέρωσης σημείωσης",
          deleteNote: "διαγραφής σημείωσης",
          saveHighlight: "αποθήκευσης επισήμανσης",
          updateHighlight: "ενημέρωσης επισήμανσης",
          deleteHighlight: "διαγραφής επισήμανσης",
          saveUnderline: "αποθήκευσης υπογράμμισης",
          deleteUnderline: "διαγραφής υπογράμμισης",
          saveDrawing: "αποθήκευσης σχεδίασης",
          deleteDrawing: "διαγραφής σχεδίασης",
          updateTextbox: "ενημέρωσης πλαισίου κειμένου",
          deleteTextbox: "διαγραφής πλαισίου κειμένου",
        },
      },
      faq: {
        open: "Άνοιγμα Συχνών Ερωτήσεων",
        title: "Πώς να χρησιμοποιήσετε τον E-Reader",
      },
      help: {
        close: "Κλείστε τη βοήθεια",
        title: "Οδηγός Χρήστη E-Reader",
        featuresTab: "Λειτουργίες",
        shortcutsTab: "Συντομεύσεις Πληκτρολογίου",
        gesturesTab: "Εντολές αφής",
        gestures: {
          title: "Εντολές αφής",
          tap: "Πατήστε",
          tapDesc: "Επιλέξτε ένα στοιχείο ή ανοίξτε έναν σύνδεσμο",
          doubleTap: "Διπλό Πατήστε",
          doubleTapDesc: "Μεγέθυνση ή σμίκρυνση",
          swipeLeft: "Σάρωση αριστερά",
          swipeLeftDesc: "Μεταβείτε στην επόμενη σελίδα",
          swipeRight: "Σάρωση δεξιά",
          swipeRightDesc: "Μεταβείτε στην προηγούμενη σελίδα",
          swipeUpDown: "Σάρωση πάνω / κάτω",
          swipeUpDownDesc: "Κάντε κύλιση στη σελίδα",
          pinchOut: "Στρίψιμο έξω (δύο δάχτυλα ανοιχτά)",
          pinchIn: "Στρίψιμο μέσα (δύο δάχτυλα κλειστά)",
          longPress: "Παρατεταμένο πατήμα",
          longPressDesc: "Επιλέξτε κείμενο ή ανοίξτε πρόσθετες επιλογές",
        },
        readingNav: "Ανάγνωση & Πλοήγηση",
        navigation: "Πλοήγηση Σελίδας",
        navigationDesc: "Χρησιμοποιήστε το πεδίο εισόδου σελίδας ή τις φυσικές αναπαραστάσεις για μετάβαση σε οποιαδήποτε σελίδα",
        zoomControls: "Στοιχεία Ελέγχου Ζουμ",
        zoomControlsDesc: "Προσαρμόστε το επίπεδο ζουμ ή επιλέξτε λειτουργία προσαρμογής πλάτους/σελίδας",
        search: "Αναζήτηση",
        searchDesc: "Βρείτε και πλοηγηθείτε μέσα από κείμενο στο έγγραφο",
        displayDesc: "Αλλάξτε την εμφάνιση ανάγνωσης και τις επιλογές διάταξης σελίδας",
        publicationDesc: "Δείτε λεπτομέρειες για την τρέχουσα έκδοση",
        organization: "Οργάνωση",
        bookmarks: "Σελιδοδείκτες",
        bookmarksDesc: "Αποθηκεύστε σημαντικές σελίδες για γρήγορη πρόσβαση",
        notes: "Σημειώσεις",
        notesDesc: "Προσθέστε σημειώσεις κειμένου σε συγκεκριμένες σελίδες",
        annotationTools: "Εργαλεία Σχολιασμού",
        highlights: "Επισημάνσεις",
        highlightsDesc: "Επισημάνετε σημαντικό κείμενο για να ξεχωρίσει",
        underlineDesc: "Υπογραμμίστε κείμενο για να επισημάνετε βασικά αποσπάσματα",
        drawing: "Σχεδίαση",
        drawingDesc: "Σχεδιάστε ελεύθερες σχολιάσεις απευθείας στις σελίδες",
        undoRedo: "Αναίρεση & Επανάληψη",
        undoRedoDesc: "Αναστρέψτε ή ακυρώστε τις σχολιάσεις σας",
        comingSoon: "Σύντομα",
        audioReading: "Ηχητική Ανάγνωση",
        audioReadingDesc: "Ακούστε το περιεχόμενο του εγγράφου με κείμενο σε ομιλία",
        aiAssistant: "Βοηθός AI",
        aiAssistantDesc: "Λάβετε ευφυή γνώσεις και περιλήψεις",
        shortcuts: {
          navigationAccessibility: "Πλοήγηση & Άθλιμα Πρόσβαση",
          browseForward: "Περιήγηση προς τα εμπρός μέσω διαδραστικών στοιχείων",
          browseBackward: "Περιήγηση προς τα πίσω μέσω διαδραστικών στοιχείων",
          activateButton: "Ενεργοποίηση κουμπιού ή συνδέσμου με εστίαση",
          selectToggle: "Επιλέξτε ή εναλλάξτε στοιχείο με εστίαση",
          closeDialogs: "Κλείσιμο ανοιχτών διαλόγων και μενού",
          nextPrevPage: "Επόμενη ή προηγούμενη σελίδα",
          jumpTop: "Μεταπήδηση στην αρχή του εγγράφου",
          jumpBottom: "Μεταπήδηση στο τέλος του εγγράφου",
          zoomViewControls: "Στοιχεία Ζουμ & Προβολής",
          zoomIn: "Ζουμ εισόδου",
          zoomOut: "Ζουμ εξόδου",
          fitWidth: "Προσαρμογή στο πλάτος",
          fitPage: "Προσαρμογή στη σελίδα",
          editingAnnotations: "Επεξεργασία & Σχολιασμός",
          undo: "Αναίρεση τελευταίας ενέργειας",
          redo: "Επανάληψη τελευταίας ενέργειας",
          toggleHighlight: "Εναλλαγή λειτουργίας επισήμανσης",
          drawingBrush: "Εναλλαγή πινέλου σχεδίασης",
          toggleNotes: "Εναλλαγή πλαϊνής γραμμής σημειώσεων",
          toggleBookmarks: "Εναλλαγή πλαϊνής γραμμής σελιδοδεικτών",
          openToc: "Άνοιγμα πίνακα περιεχομένων",
          saveBookmark: "Αποθήκευση σελιδοδείκτη",
          searchContent: "Αναζήτηση & Περιεχόμενο",
          searchWithin: "Αναζήτηση εντός εγγράφου",
          copyText: "Αντιγραφή επιλεγμένου κειμένου",
          selectAll: "Επιλογή όλου του κειμένου στην τρέχουσα σελίδα ή προβολή",
        },
        translateDesc: "Μεταφράστε επιλεγμένο κείμενο με AI",
      },
      loading: {
        initializing: "Αρχικοποίηση...",
        restoringSession: "Επαναφορά συνεδρίας...",
        fetchingAccessToken: "Λήψη token πρόσβασης...",
        loadingDocument: "Φόρτωση εγγράφου...",
        ariaLabel: "Φόρτωση",
        authenticating: "Έλεγχος ταυτότητας...",
        finalizing: "Ολοκλήρωση...",
      },
      landingPage: {
        uploadTitle: "Ανέβασμα Εγγράφου",
        uploadSubtitle: "Σύρετε και αποθέστε ένα αρχείο PDF ή EPUB εδώ, ή κάντε κλικ για ανέβασμα",
        supportedFormats: "Υποστηριζόμενες μορφές: PDF, EPUB",
        uploadAriaLabel: "Ανέβασμα αρχείου PDF ή EPUB",
      },
      errors: {
        failedToLoadPdf: "Αποτυχία φόρτωσης PDF",
        failedToLoadEpub: "Αποτυχία φόρτωσης EPUB",
        unsupportedFileType: "Μη υποστηριζόμενος τύπος αρχείου. Ανεβάστε PDF ή EPUB.",
        errorReadingFile: "Σφάλμα ανάγνωσης αρχείου.",
        searchFailed: "Η αναζήτηση απέτυχε",
        failedToRestoreSession: "Αποτυχία επαναφοράς συνεδρίας.",
        failedToInitializeReader: "Αποτυχία αρχικοποίησης αναγνώστη από το token.",
      },
      readingAssistant: {
        title: "Βοηθός Ανάγνωσης",
        close: "Κλείσιμο Βοηθού Ανάγνωσης",
        resize: "Αλλαγή μεγέθους Βοηθού Ανάγνωσης",
        resizeHint: "Σύρετε για αλλαγή μεγέθους. Διπλό κλικ για επαναφορά.",
        tabsLabel: "Καρτέλες Βοηθού Ανάγνωσης",
        tabs: {
          summary: "Περίληψη",
          askAi: "Ρωτήστε το AI",
          quiz: "Κουίζ",
        },
        status: {
          loading: "Έλεγχος…",
          processing: "Το έγγραφο προετοιμάζεται ακόμη για AI. Δοκιμάστε ξανά σύντομα.",
          unavailable: "Οι λειτουργίες AI δεν είναι διαθέσιμες για αυτό το έγγραφο.",
          failed: "Η επεξεργασία του εγγράφου απέτυχε. Οι λειτουργίες AI δεν είναι διαθέσιμες.",
          error: "Αδυναμία φόρτωσης λειτουργιών AI. {{message}}",
        },
        summary: {
          typesLabel: "Τύπος περίληψης",
          types: {
            quick: "Γρήγορη περίληψη",
            detailed: "Αναλυτική περίληψη",
            chapter: "Περίληψη ανά κεφάλαιο",
          },
          cardTitles: {
            quick: "Η γρήγορη περίληψη",
            detailed: "Η αναλυτική περίληψη",
            chapter: "Περίληψη ανά κεφάλαιο",
          },
          welcomeTitle: "Βοηθός Ανάγνωσης",
          welcome: "Καλώς ήρθατε στην εμπειρία ανάγνωσης με AI. Επιλέξτε μια επιλογή περίληψης όταν είστε έτοιμοι.",
          loading: "Δημιουργία περίληψης",
          error: "Αδυναμία δημιουργίας περίληψης. {{message}}",
          empty: "Επιλέξτε τύπο περίληψης για δημιουργία.",
          chooseChapter: "Επιλέξτε κεφάλαιο παρακάτω για περίληψη.",
          chapterListLabel: "Κεφάλαια",
          noChapters: "Δεν υπάρχουν διαθέσιμα κεφάλαια για αυτό το έγγραφο.",
          backToTypes: "Πίσω",
          regenerate: "Επαναδημιουργία",
        },
        askAi: {
          placeholder: "Ρωτήστε οτιδήποτε για αυτό το βιβλίο...",
          submit: "Αποστολή ερώτησης",
          empty: "Κάντε μια ερώτηση για να ξεκινήσετε τη συνομιλία.",
          sending: "Σκέψη",
          error: "Αδυναμία λήψης απάντησης. {{message}}",
          export: "Εξαγωγή",
          newChat: "Νέα συνομιλία",
        },
        quiz: {
          title: "Κάντε κουίζ",
          subtitle: "Επιλέξτε τι θέλετε να εξεταστείτε.",
          cta: "Ξεκινήστε το κουίζ",
          loading: "Δημιουργία κουίζ",
          error: "Αδυναμία δημιουργίας κουίζ. {{message}}",
          modalTitle: "Κουίζ AI",
          disclaimer: "Περιεχόμενο AI, μόνο για αναφορά.",
          close: "Κλείσιμο κουίζ",
          checkAnswer: "Έλεγχος απάντησης",
          explanation: "Επεξήγηση",
          previous: "Προηγούμενο",
          next: "Επόμενη ερώτηση",
          finish: "Ολοκλήρωση",
          progress: "Ερώτηση {{current}} από {{total}}",
          answerRequired: "Απαντήστε σε αυτή την ερώτηση για να συνεχίσετε.",
          completedTitle: "Το κουίζ ολοκληρώθηκε!",
          yourScore: "Η βαθμολογία σας",
          completedMessage: "Ολοκληρώσατε το κουίζ με επιτυχία.",
          reattempt: "Επανάληψη κουίζ",
          save: "Αποθήκευση",
          saving: "Αποθήκευση…",
          saved: "Αποθηκεύτηκε",
          saveError: "Αδυναμία αποθήκευσης αποτελέσματος. {{message}}",
          deleteError: "Αδυναμία διαγραφής αποτελέσματος. {{message}}",
          deleteResult: "Διαγραφή αποθηκευμένου κουίζ",
          deletedToast: "Το κουίζ διαγράφηκε",
          recentQuizzes: "Πρόσφατα κουίζ",
          seeDetails: "Λεπτομέρειες",
          showDetails: "Εμφάνιση λεπτομερειών",
          hideDetails: "Απόκρυψη λεπτομερειών",
          correct: "Σωστό",
          incorrect: "Λάθος",
          multipleChoice: "Πολλαπλής επιλογής",
          questionStatusAria: "Ερώτηση {{number}}: {{status}}",
          backToDashboard: "Πίνακας κουίζ",
          scopeLabel: "Εμβέλεια κουίζ",
          scopeBook: "Ανά βιβλίο",
          scopeChapter: "Ανά κεφάλαιο",
          scopePage: "Ανά σελίδα",
          scopePageTitle: "Σελίδα {{page}}",
          scoreAria: "Βαθμολογία {{correct}} από {{total}}",
          answerOptions: "Επιλογές απάντησης",
          navigationAria: "Πλοήγηση κουίζ",
          noQuestions: "Δεν επιστράφηκαν ερωτήσεις κουίζ",
          feedback: {
            greatJob: "Μπράβο!",
            goodEffort: "Καλή προσπάθεια!",
            keepPracticing: "Συνεχίστε την εξάσκηση!",
          },
        },
        menu: {
          preferences: "Προτιμήσεις AI",
          citation: "Παραπομπή AI",
          copy: "Αντιγραφή AI",
          quizzes: "Κουίζ AI",
          notes: "Σημειώσεις",
          prefs: {
            aiLanguage: "Προτιμώμενη γλώσσα",
            citationEnabled: "Εμφάνιση παραπομπών",
            contextInclusionEnabled: "Συμπερίληψη πλαισίου ανάγνωσης",
          },
        },
      },
      pullouts: {
        fallbackTitle: "Αναδυόμενο",
        hintLabel: "Υπόδειξη:",
        hintAvailable: "Διαθέσιμη υπόδειξη",
        expandHint: "Επέκταση υπόδειξης",
        collapseHint: "Σύμπτυξη υπόδειξης",
      },
      publicationDetails: {
        title: "Στοιχεία έκδοσης",
        close: "Κλείσιμο στοιχείων έκδοσης",
        copy: "Αντιγραφή στοιχείων έκδοσης",
        copied: "Αντιγράφηκε στο πρόχειρο",
        description: "Περιγραφή",
        noData: "Δεν υπάρχουν διαθέσιμα δεδομένα",
        empty: "Δεν υπάρχουν διαθέσιμα στοιχεία έκδοσης για αυτό το έγγραφο.",

        fields: {
          title: "Τίτλος",
          author: "Συγγραφέας",
          code: "Κωδικός",
          type: "Τύπος",
          language: "Γλώσσα",
          original_publisher: "Αρχικός εκδότης",
          series: "Σειρά",
          edition: "Έκδοση",
          pages: "Σελίδες",
          pisbn13: "PISBN13",
          publication_year: "Έτος έκδοσης",
          copyright_year: "Έτος πνευματικών δικαιωμάτων",
          read_direction: "Κατεύθυνση ανάγνωσης",
          content_type: "Τύπος περιεχομένου",
        },
      },
    },
  },
  es: {
    translation: {
      common: {
        cancel: "Cancelar",
        close: "Cerrar",
        menu: "Menú",
        search: "Buscar",
        bookmarks: "Marcadores",
        notes: "Notas",
        pages: "Páginas",
        tableOfContents: "Tabla de contenidos",
        page: "Página",
        section: "Sección",
        loading: "Cargando...",
        submit: "Enviar",
        apply: "Aplicar",
        remove: "Eliminar",
        error: "Error",
        language: "Idioma",
        theme: "Tema",
        light: "Claro",
        dark: "Oscuro",
        on: "Activado",
        off: "Desactivado",
        showMore: "Mostrar más",
        showLess: "Mostrar menos",
        undo: "Deshacer",
        redo: "Rehacer",
        underline: "Subrayado",
        highlight: "Resaltar",
        textbox: "Cuadro de texto",
        document: "Documento",
        color: "Color",
        back: "Atrás",
      },
      toolbar: {
        expand: "Expandir barra de herramientas",
        collapse: "Contraer barra de herramientas",
        aiAssistant: "Preguntar al Asistente IA",
        aiAssistantComingSoon: "Preguntar al Asistente IA (Próximamente)",
        searchNotAllowed: "La búsqueda no está permitida",
        textToSpeechComingSoon: "Texto a voz (Próximamente)",
        addBookmark: "Añadir marcador",
        removeBookmark: "Eliminar marcador",
        bookmarked: "Marcado",
        bookmarksNotAllowed: "Los marcadores no están permitidos",
        moreOptions: "Más opciones",
        display: "Pantalla",
        lightHint: "Fondo claro con texto oscuro",
        darkHint: "Fondo oscuro con texto claro",
        pageView: "Vista de página",
        singlePage: "Página única",
        singlePageHint: "Desplazar una página a la vez",
        doublePage: "Doble página",
        doublePageHint: "Ver páginas lado a lado",
        view: "Modo de color",
        share: "Compartir",
        download: "Descargar",
        citation: "Cita",
        print: "Imprimir",
        displayMenu: "Menú de pantalla",
        displayMenuItems: {
          colorMode: "Modo de color",
          fontSize: "Tamaño de fuente",
          fontFamily: "Fuente",
          lineHeight: "Interlineado",
          increaseLineHeight: "Aumentar interlineado",
          decreaseLineHeight: "Disminuir interlineado",
          layout: "Diseño",
          rotate: "Rotar",
          readingDirection: "Dirección de lectura",
          rotateLeft: "Rotar a la izquierda",
          rotateRight: "Rotar a la derecha",
          ltr: "Izquierda a derecha",
          rtl: "Derecha a izquierda",
          fonts: {
            original: "Original",
            sans: "Sans",
            serif: "Serif",
          },
          colors: {
            light: "Claro",
            dark: "Oscuro",
            mint: "Menta",
            sepia: "Sepia",
          },
        },
      },
      mobile: {
        searchPlaceholder: "Buscar palabra clave...",
        cancelSearch: "Cancelar búsqueda",
        faq: "Preguntas frecuentes",
      },
      menu: {
        close: "Cerrar menú",
        documentPageCount: "Página {{current}} de {{total}}",
      },
      rightToolbar: {
        showToc: "Mostrar tabla de contenidos",
        hideToc: "Ocultar tabla de contenidos",
        showPagesThumbnails: "Mostrar miniaturas de páginas",
        hidePagesThumbnails: "Ocultar miniaturas de páginas",
        showBookmarks: "Mostrar marcadores",
        hideBookmarks: "Ocultar marcadores",
        info: "Información de la publicación",
        showPublicationDetails: "Mostrar detalles de la publicación",
        hidePublicationDetails: "Ocultar detalles de la publicación",
        askAi: "Preguntar a la IA",
        readingGroup: "Grupo de lectura",
        showNotes: "Mostrar notas",
        hideNotes: "Ocultar notas",
        myNotebook: "Mi cuaderno",
        clickToEnterPage: "Haz clic para ingresar el número de página",
        currentPageLabel: "Página actual {{current}}. Haz clic para cambiar.",
        previousPage: "Página anterior",
        nextPage: "Página siguiente",
        zoomOut: "Alejar",
        zoomIn: "Acercar",
        resetZoom: "Restablecer zoom",
        resetZoomTitle: "Restablecer zoom al 100%",
        decreaseFontSize: "Disminuir tamaño de fuente",
        increaseFontSize: "Aumentar tamaño de fuente",
        resetFontSize: "Restablecer tamaño de fuente",
        resetFontSizeTitle: "Restablecer tamaño de fuente al 100%",
        viewModeOptions: "Opciones de vista",
        fitToWidth: "Ajustar al ancho",
        fitToPage: "Ajustar a la página",
        enterFullscreen: "Entrar en pantalla completa",
        exitFullscreen: "Salir de pantalla completa",
        enterPageNumber: "Introduce el número de página",
        pageInputPlaceholder: "{{min}}-{{max}}",
        pageInputTitle: "Ingrese número de página ({{min}}-{{max}})",
        pageInputInvalid: "Por favor ingresa un número de página válido",
        pageInputOutOfRange: "La página debe estar entre 1 y {{total}}",
        showReadingAssistant: "Mostrar asistente de lectura",
        hideReadingAssistant: "Ocultar asistente de lectura",
      },
      floatingToolbar: {
        ariaLabel: "Barra de herramientas flotante",
        dragToMove: "Arrastra para mover",
        dragToolbar: "Arrastrar barra de herramientas",
        notesOn: "Activar notas",
        notesOff: "Desactivar notas",
        notesNotAllowed: "Las notas no están permitidas",
        notesOnLabel: "Notas: Activadas",
        notesOffLabel: "Notas: Desactivadas",
        drawingOn: "Activar dibujo",
        drawingOff: "Desactivar dibujo",
        drawingNotAllowed: "El dibujo no está permitido",
        drawingOnLabel: "Dibujo: Activado",
        drawingOffLabel: "Dibujo: Desactivado",
        textBoxComingSoon: "Cuadro de texto (Próximamente)",
        textboxNotAllowed: "Text box not allowed",
        textboxOn: "Activar cuadro de texto",
        textboxOff: "Desactivar cuadro de texto",
        textboxOnLabel: "Cuadro de texto: Activado",
        textboxOffLabel: "Cuadro de texto: Desactivado",
        highlightOn: "Activar resaltado",
        highlightOff: "Desactivar resaltado",
        highlightsNotAllowed: "Los resaltados no están permitidos",
        highlightOnLabel: "Resaltado: Activado",
        highlightOffLabel: "Resaltado: Desactivado",
        highlightColorLabel: "Color de resaltado",
        colorRed: "Rojo",
        colorOrange: "Naranja",
        colorYellow: "Amarillo",
        colorGreen: "Verde",
        colorLightBlue: "Azul claro",
        colorPurple: "Morado",
        underlinesNotAllowed: "El subrayado no está permitido",
        underlineOn: "Activar subrayado",
        underlineOff: "Desactivar subrayado",
        underlineOnLabel: "Subrayado: Activado",
        underlineOffLabel: "Subrayado: Desactivado",
        undo: "Deshacer ({{ctrl}}+Z)",
        redo: "Rehacer ({{ctrl}}+Y)",
        undoCooldown: "Deshacer (espere)",
        redoCooldown: "Rehacer (espere)",
      },
      contextMenu: {
        addNote: "Agregar nota",
        highlight: "Resaltar",
        underline: "Subrayar",
        copy: "Copiar",
        removeHighlight: "Eliminar resaltado",
        removeUnderline: "Eliminar subrayado",
        searchSelected: "Buscar palabra seleccionada",
        selectionToolbar: "Menú de selección",
        askAi: "Preguntar a la IA",
        share: "Compartir",
        translate: "Traducir",
        comingSoon: "Próximamente",
        translationTitle: "Traducción",
        translating: "Traduciendo…",
        translationFailed: "Error de traducción",
      },
      readerShell: {
        loadingDocument: "Cargando documento...",
        documentControls: "Controles de documento",
      },
      emptyState: {
        errorAlt: "Error",
        documentAlt: "Documento",
        unableToLoad: "No se pudo cargar el documento",
        noDocument: "No hay documento cargado",
        requestDoc: "Solicita un documento de tu biblioteca para comenzar",
      },
      search: {
        ariaLabel: "Resultados de búsqueda",
        searchResults: "Resultados de Búsqueda",
        close: "Cerrar búsqueda",
        placeholder: "Buscar en el documento...",
        clear: "Borrar búsqueda",
        searching: "Buscando...",
        enterQuery: "Ingresa una consulta para encontrar texto en el documento",
        noResults: "No se encontraron resultados para \"{{query}}\"",
        resultsCount_one: "Se encontró {{count}} resultado",
        resultsCount_other: "Se encontraron {{count}} resultados",
        matchCount_one: "{{count}} coincidencia",
        matchCount_other: "{{count}} coincidencias",
        navigateToResult: "Haz clic para ir a este resultado",
      },
      bookmarks: {
        title: "Marcadores",
        close: "Cerrar marcadores",
        loading: "Cargando marcadores...",
        error: "Error al cargar marcadores: {{error}}",
        noItems: "Aún no hay marcadores",
        navigate: "Haz clic para ir a este marcador",
        remove: "Eliminar marcador",
        removeLabel: "Eliminar marcador {{label}}",
        navigateLabel: "Ir a {{label}}",
        defaultLabel: "Marcador {{page}}",
        deleteError: "Error al eliminar el marcador",
      },
      notes: {
        title: "Mi cuaderno",
        close: "Cerrar mi cuaderno",
        navigate: "Haz clic para ir a esta nota",
        ariaLabel: "Nota: {{preview}} Página {{page}} {{created}}",
        createdOn: "Creado el {{date}}",
        pageTitle: "Página {{page}}",
        remove: "Eliminar nota",
        removeLabel: "Eliminar nota de la página {{page}}",
        none: "Aún no hay notas",
        noItems: "Aún no hay elementos",
        share: "Compartir cuaderno",
        searchPlaceholder: "Escribe aquí",
        clearSearch: "Borrar búsqueda",
        tabsLabel: "Filtros del cuaderno",
        tabs: {
          all: "Todos",
          highlight: "Resaltado",
          underline: "Subrayado",
          note: "Nota",
        },
        resultsFound_one: "{{count}} resultado encontrado",
        resultsFound_other: "{{count}} resultados encontrados",
        copyItem: "Copiar elemento",
        shareItem: "Compartir elemento",
      },
      toc: {
        title: "Tabla de contenidos",
        close: "Cerrar tabla de contenidos",
        untitled: "Sección sin título",
        empty: "No hay tabla de contenidos disponible",
        noItems: "No hay tabla de contenidos disponible",
        chapter: "Capítulo",
      },
      pages: {
        title: "Páginas",
        count_one: "{{count}} página",
        count_other: "{{count}} páginas",
        empty: "No hay páginas disponibles",
        thumbnailAlt: "Página {{page}}",
        ariaLabel: "Miniaturas de páginas",
      },
      epub: {
        loading: "Cargando EPUB...",
        errorTitle: "Error al cargar EPUB",
        reload: "Recargar página",
        noteIndicatorTitle: "Nota {{current}} de {{total}}: {{text}}{{suffix}}",
        noteSelectedSuffix: " (Nota de texto seleccionado)",
        noteTitleEdit: "Editar nota",
        noteTitleAdd: "Añadir nota",
        noteCounter: "({{current}} de {{total}})",
        selectedTextLabel: "Texto seleccionado:",
        notePlaceholderSelected: "Agrega tu nota sobre el texto seleccionado...",
        notePlaceholder: "Escribe una nota",
        noteActionSave: "Guardar",
        noteActionCreate: "Crear",
        contextAddNote: "Añadir nota",
        contextHighlight: "Resaltar",
        contextSearch: "Buscar la palabra seleccionada",
        imageAlt: "Imagen",
        imageLightboxAria: "Imagen ampliada",
        closeImagePreview: "Cerrar vista previa de imagen",
      },
      notifications: {
        featureNotAllowed: "Esta función no está disponible.",
        featureComingSoon: "Esta función próximamente.",
        highlightsNotAvailable: "El resaltado no está disponible para este documento.",
        underlinesNotAvailable: "La función de subrayado no está disponible para este documento.",
        notesNotAvailable: "Las notas no están disponibles para este documento.",
        drawingNotAvailable: "El dibujo no está disponible para este documento.",
        bookmarksNotAvailable: "Los marcadores no están disponibles para este documento.",
        searchNotAvailable: "La búsqueda no está disponible para este documento.",
        commentsNotAvailable: "Los comentarios no están disponibles para este documento.",
        pageOutOfRange: "Esta página no está disponible.",
        aiAssistantComingSoon: "El Asistente IA llegará pronto.",
        textBoxComingSoon: "Los cuadros de texto llegarán pronto.",
        textboxNotAllowed: "Text box not allowed",
        textToSpeechComingSoon: "La conversión de texto a voz llegará pronto.",
        sessionExpired: "Tu sesión ha caducado. Actualiza y vuelve a intentarlo.",
        operationFailed: "No se pudo {{operation}}. Inténtalo de nuevo.",
        copyLimitExceeded: "Límite de copia excedido. Solo se copiaron {{limit}} caracteres.",
        copyNotAllowed: "No se permite copiar en este documento.",
        operations: {
          saveAiPreferences: "guardar las preferencias de IA",
          copyText: "copiar el texto",
          completeAction: "completar esta acción",
          saveBookmark: "guardar el marcador",
          deleteBookmark: "eliminar el marcador",
          saveNote: "guardar la nota",
          updateNote: "actualizar la nota",
          deleteNote: "eliminar la nota",
          saveHighlight: "guardar el resaltado",
          updateHighlight: "actualizar el resaltado",
          deleteHighlight: "eliminar el resaltado",
          saveUnderline: "guardar el subrayado",
          deleteUnderline: "eliminar el subrayado",
          saveDrawing: "guardar el dibujo",
          deleteDrawing: "eliminar el dibujo",
          updateTextbox: "actualizar el cuadro de texto",
          deleteTextbox: "eliminar el cuadro de texto",
        },
      },
      faq: {
        open: "Abrir FAQ",
        title: "Cómo usar el E-Reader",
      },
      help: {
        close: "Cerrar ayuda",
        title: "Guía del Usuario del E-Reader",
        featuresTab: "Características",
        shortcutsTab: "Atajos de Teclado",
        gesturesTab: "Gestos táctiles",
        gestures: {
          title: "Gestos táctiles",
          tap: "Tocar",
          tapDesc: "Selecciona un elemento o abre un enlace",
          doubleTap: "Doble toque",
          doubleTapDesc: "Acercar o alejar",
          swipeLeft: "Deslizar a la izquierda",
          swipeLeftDesc: "Ir a la página siguiente",
          swipeRight: "Deslizar a la derecha",
          swipeRightDesc: "Ir a la página anterior",
          swipeUpDown: "Deslizar hacia arriba/abajo",
          swipeUpDownDesc: "Desplazarse por la página",
          pinchOut: "Alejar (dos dedos separados)",
          pinchIn: "Acercar (dos dedos juntos)",
          longPress: "Mantener pulsado",
          longPressDesc: "Seleccionar texto o abrir opciones adicionales",
        },
        readingNav: "Lectura & Navegación",
        navigation: "Navegación de Página",
        navigationDesc: "Utiliza el campo de entrada de página o miniaturas para saltar a cualquier página",
        zoomControls: "Controles de Zoom",
        zoomControlsDesc: "Ajusta el nivel de zoom o selecciona modo ajuste al ancho/página",
        search: "Búsqueda",
        searchDesc: "Encuentra y navega a través del texto en el documento",
        displayDesc: "Cambia la apariencia de lectura y las opciones de diseño de página",
        publicationDesc: "Ver detalles sobre la publicación actual",
        organization: "Organización",
        bookmarks: "Marcadores",
        bookmarksDesc: "Guarda páginas importantes para acceso rápido",
        notes: "Notas",
        notesDesc: "Añade notas de texto a páginas específicas",
        annotationTools: "Herramientas de Anotación",
        highlights: "Destacados",
        highlightsDesc: "Destaca texto importante para que resalte",
        underlineDesc: "Subraya texto para marcar pasajes clave",
        drawing: "Dibujo",
        drawingDesc: "Dibuja anotaciones a mano alzada directamente en las páginas",
        undoRedo: "Deshacer & Rehacer",
        undoRedoDesc: "Revierte o rehace tus anotaciones",
        comingSoon: "Próximamente",
        audioReading: "Lectura de Audio",
        audioReadingDesc: "Escucha contenido del documento con conversión de texto a voz",
        aiAssistant: "Asistente de IA",
        aiAssistantDesc: "Obtén información inteligente y resúmenes",
        shortcuts: {
          navigationAccessibility: "Navegación & Accesibilidad",
          browseForward: "Navega hacia adelante a través de elementos interactivos",
          browseBackward: "Navega hacia atrás a través de elementos interactivos",
          activateButton: "Activa botón o enlace enfocado",
          selectToggle: "Selecciona o alterna elemento enfocado",
          closeDialogs: "Cierra diálogos y menús abiertos",
          nextPrevPage: "Página siguiente o anterior",
          jumpTop: "Ir al inicio del documento",
          jumpBottom: "Ir al final del documento",
          zoomViewControls: "Controles de Zoom & Vista",
          zoomIn: "Ampliar",
          zoomOut: "Reducir",
          fitWidth: "Ajustar al ancho",
          fitPage: "Ajustar a la página",
          editingAnnotations: "Edición & Anotaciones",
          undo: "Deshacer última acción",
          redo: "Rehacer última acción",
          toggleHighlight: "Alterna modo de destacado",
          drawingBrush: "Alterna pincel de dibujo",
          toggleNotes: "Alterna barra lateral de notas",
          toggleBookmarks: "Alterna barra lateral de marcadores",
          openToc: "Abre tabla de contenidos",
          saveBookmark: "Guarda marcador",
          searchContent: "Búsqueda & Contenido",
          searchWithin: "Busca dentro del documento",
          copyText: "Copia texto seleccionado",
          selectAll: "Seleccionar todo el texto de la página o vista actual",
        },
        translateDesc: "Traduce el texto seleccionado con IA",
      },
      loading: {
        initializing: "Inicializando...",
        restoringSession: "Restaurando sesión...",
        fetchingAccessToken: "Obteniendo token de acceso...",
        loadingDocument: "Cargando documento...",
        ariaLabel: "Cargando",
        authenticating: "Autenticando...",
        finalizing: "Finalizando...",
      },
      errors: {
        failedToLoadPdf: "No se pudo cargar el PDF",
        failedToLoadEpub: "No se pudo cargar el EPUB",
        unsupportedFileType: "Tipo de archivo no compatible. Sube un PDF o EPUB.",
        errorReadingFile: "Error al leer el archivo.",
        searchFailed: "La búsqueda falló",
        failedToRestoreSession: "No se pudo restaurar la sesión.",
        failedToInitializeReader: "No se pudo inicializar el lector desde el token.",
      },
      readingAssistant: {
        title: "Asistente de lectura",
        close: "Cerrar asistente de lectura",
        resize: "Cambiar tamaño del asistente",
        resizeHint: "Arrastra para cambiar el tamaño. Doble clic para restablecer.",
        tabsLabel: "Pestañas del asistente de lectura",
        tabs: {
          summary: "Resumen",
          askAi: "Preguntar a la IA",
          quiz: "Cuestionario",
        },
        status: {
          loading: "Comprobando…",
          processing: "Este documento aún se está preparando para la IA. Inténtalo de nuevo en breve.",
          unavailable: "Las funciones de IA no están disponibles para este documento.",
          failed: "Error al procesar el documento. Las funciones de IA no están disponibles.",
          error: "No se pudieron cargar las funciones de IA. {{message}}",
        },
        summary: {
          typesLabel: "Tipo de resumen",
          types: {
            quick: "Resumen rápido",
            detailed: "Resumen detallado",
            chapter: "Resumen por capítulo",
          },
          cardTitles: {
            quick: "El resumen rápido",
            detailed: "El resumen detallado",
            chapter: "Resumen por capítulo",
          },
          welcomeTitle: "Asistente de lectura",
          welcome: "Bienvenido a la experiencia de lectura con IA. Elige una opción de resumen cuando estés listo.",
          loading: "Generando resumen",
          error: "No se pudo generar el resumen. {{message}}",
          empty: "Elige un tipo de resumen para generar uno.",
          chooseChapter: "Elige un capítulo abajo para generar su resumen.",
          chapterListLabel: "Capítulos",
          noChapters: "No hay capítulos disponibles para este documento.",
          backToTypes: "Atrás",
          regenerate: "Regenerar",
        },
        askAi: {
          placeholder: "Pregunta lo que quieras sobre este libro...",
          submit: "Enviar pregunta",
          empty: "Haz una pregunta para iniciar la conversación.",
          sending: "Pensando",
          error: "No se pudo obtener una respuesta. {{message}}",
          export: "Exportar",
          newChat: "Nuevo chat",
        },
        quiz: {
          title: "Hacer un cuestionario",
          subtitle: "Elige sobre qué quieres evaluarte.",
          cta: "Empezar cuestionario",
          loading: "Generando cuestionario",
          error: "No se pudo generar el cuestionario. {{message}}",
          modalTitle: "Cuestionario IA",
          disclaimer: "Contenido generado por IA, solo como referencia.",
          close: "Cerrar cuestionario",
          checkAnswer: "Comprobar respuesta",
          explanation: "Explicación",
          previous: "Anterior",
          next: "Siguiente pregunta",
          finish: "Finalizar",
          progress: "Pregunta {{current}} de {{total}}",
          answerRequired: "Responde esta pregunta para continuar.",
          completedTitle: "¡Cuestionario completado!",
          yourScore: "Tu puntuación",
          completedMessage: "Has completado el cuestionario correctamente.",
          reattempt: "Reintentar cuestionario",
          save: "Guardar",
          saving: "Guardando…",
          saved: "Guardado",
          saveError: "No se pudo guardar el resultado. {{message}}",
          deleteError: "No se pudo eliminar el resultado. {{message}}",
          deleteResult: "Eliminar cuestionario guardado",
          deletedToast: "Cuestionario eliminado",
          recentQuizzes: "Cuestionarios recientes",
          seeDetails: "Ver detalles",
          showDetails: "Mostrar detalles",
          hideDetails: "Ocultar detalles",
          correct: "Correcto",
          incorrect: "Incorrecto",
          multipleChoice: "Opción múltiple",
          questionStatusAria: "Pregunta {{number}}: {{status}}",
          backToDashboard: "Panel de cuestionarios",
          scopeLabel: "Alcance del cuestionario",
          scopeBook: "Por libro",
          scopeChapter: "Por capítulo",
          scopePage: "Por página",
          scopePageTitle: "Página {{page}}",
          scoreAria: "Puntuación {{correct}} de {{total}}",
          answerOptions: "Opciones de respuesta",
          navigationAria: "Navegación del cuestionario",
          noQuestions: "No se devolvieron preguntas",
          feedback: {
            greatJob: "¡Buen trabajo!",
            goodEffort: "¡Buen esfuerzo!",
            keepPracticing: "¡Sigue practicando!",
          },
        },
        menu: {
          preferences: "Preferencias de IA",
          citation: "Cita IA",
          copy: "Copia IA",
          quizzes: "Cuestionarios IA",
          notes: "Notas",
          prefs: {
            aiLanguage: "Idioma preferido",
            citationEnabled: "Mostrar citas",
            contextInclusionEnabled: "Incluir contexto de lectura",
          },
        },
      },
      pullouts: {
        fallbackTitle: "Contenido emergente",
        hintLabel: "Pista:",
        hintAvailable: "Pista disponible",
        expandHint: "Expandir pista",
        collapseHint: "Contraer pista",
      },
      publicationDetails: {
        title: "Detalles de la publicación",
        close: "Cerrar detalles de la publicación",
        copy: "Copiar detalles de la publicación",
        copied: "Copiado al portapapeles",
        description: "Descripción",
        noData: "No hay datos disponibles",
        empty: "No hay detalles de publicación disponibles para este documento.",

        fields: {
          title: "Título",
          author: "Autor",
          code: "Código",
          type: "Tipo",
          language: "Idioma",
          original_publisher: "Editorial original",
          series: "Serie",
          edition: "Edición",
          pages: "Páginas",
          pisbn13: "PISBN13",
          publication_year: "Año de publicación",
          copyright_year: "Año de copyright",
          read_direction: "Dirección de lectura",
          content_type: "Tipo de contenido",
        },
      },
    },
  },
  ru: {
    translation: {
      common: {
        cancel: "Отмена",
        close: "Закрыть",
        menu: "Меню",
        search: "Поиск",
        bookmarks: "Закладки",
        notes: "Заметки",
        pages: "Страницы",
        tableOfContents: "Оглавление",
        page: "Страница",
        section: "Раздел",
        loading: "Загрузка...",
        submit: "Отправить",
        apply: "Применить",
        remove: "Удалить",
        error: "Ошибка",
        language: "Язык",
        theme: "Тема",
        light: "Светлая",
        dark: "Тёмная",
        on: "Вкл",
        off: "Выкл",
        showMore: "Показать больше",
        showLess: "Показать меньше",
        undo: "Отменить",
        redo: "Повторить",
        underline: "Подчеркивание",
        highlight: "Выделение",
        textbox: "Текстовое поле",
        document: "Документ",
        back: "Назад",
      },
      toolbar: {
        expand: "Развернуть панель инструментов",
        collapse: "Свернуть панель инструментов",
        aiAssistant: "Спросить ИИ-помощника",
        aiAssistantComingSoon: "Спросить ИИ-помощника (Скоро)",
        searchNotAllowed: "Поиск недоступен",
        textToSpeechComingSoon: "Озвучивание текста (Скоро)",
        addBookmark: "Добавить закладку",
        removeBookmark: "Удалить закладку",
        bookmarked: "Закладка",
        bookmarksNotAllowed: "Закладки недоступны",
        moreOptions: "Больше опций",
        display: "Отображение",
        lightHint: "Светлый фон и тёмный текст",
        darkHint: "Тёмный фон и светлый текст",
        pageView: "Вид страницы",
        singlePage: "Одна страница",
        singlePageHint: "Прокрутка по одной странице",
        doublePage: "Две страницы",
        doublePageHint: "Просмотр страниц рядом",
        view: "Цветовой режим",
        share: "Поделиться",
        download: "Скачать",
        citation: "Цитирование",
        print: "Печать",
        displayMenu: "Меню отображения",
        displayMenuItems: {
          colorMode: "Цветовой режим",
          fontSize: "Размер шрифта",
          fontFamily: "Шрифт",
          lineHeight: "Межстрочный интервал",
          increaseLineHeight: "Увеличить межстрочный интервал",
          decreaseLineHeight: "Уменьшить межстрочный интервал",
          layout: "Макет",
          rotate: "Поворот",
          readingDirection: "Направление чтения",
          rotateLeft: "Повернуть влево",
          rotateRight: "Повернуть вправо",
          ltr: "Слева направо",
          rtl: "Справа налево",
          fonts: {
            original: "Исходный",
            sans: "Sans",
            serif: "Serif",
          },
          colors: {
            light: "Светлый",
            dark: "Тёмный",
            mint: "Мятный",
            sepia: "Сепия",
          },
        },
      },
      mobile: {
        searchPlaceholder: "Поиск по ключевому слову...",
        cancelSearch: "Отменить поиск",
        faq: "FAQ",
      },
      menu: {
        close: "Закрыть меню",
        documentPageCount: "Страница {{current}} из {{total}}",
      },
      rightToolbar: {
        showToc: "Показать оглавление",
        hideToc: "Скрыть оглавление",
        showPagesThumbnails: "Показать миниатюры страниц",
        hidePagesThumbnails: "Скрыть миниатюры страниц",
        showBookmarks: "Показать закладки",
        hideBookmarks: "Скрыть закладки",
        info: "Информация об издании",
        showPublicationDetails: "Показать сведения об издании",
        hidePublicationDetails: "Скрыть сведения об издании",
        askAi: "Спросить ИИ",
        readingGroup: "Группа чтения",
        showNotes: "Показать заметки",
        hideNotes: "Скрыть заметки",
        myNotebook: "Мой блокнот",
        clickToEnterPage: "Нажмите, чтобы ввести номер страницы",
        currentPageLabel: "Текущая страница {{current}}. Нажмите для изменения.",
        previousPage: "Предыдущая страница",
        nextPage: "Следующая страница",
        zoomOut: "Уменьшить",
        zoomIn: "Увеличить",
        resetZoom: "Сбросить масштаб",
        resetZoomTitle: "Сбросить масштаб до 100%",
        decreaseFontSize: "Уменьшить размер шрифта",
        increaseFontSize: "Увеличить размер шрифта",
        resetFontSize: "Сбросить размер шрифта",
        resetFontSizeTitle: "Сбросить размер шрифта на 100%",
        viewModeOptions: "Параметры просмотра",
        fitToWidth: "По ширине",
        fitToPage: "По странице",
        enterFullscreen: "Полноэкранный режим",
        exitFullscreen: "Выход из полноэкранного режима",
        enterPageNumber: "Введите номер страницы",
        pageInputPlaceholder: "{{min}}-{{max}}",
        pageInputTitle: "Введите номер страницы ({{min}}-{{max}})",
        pageInputInvalid: "Введите корректный номер страницы",
        pageInputOutOfRange: "Страница должна быть между 1 и {{total}}",
        showReadingAssistant: "Показать помощника чтения",
        hideReadingAssistant: "Скрыть помощника чтения",
      },
      floatingToolbar: {
        ariaLabel: "Плавающая панель инструментов",
        dragToMove: "Перетащите для перемещения",
        dragToolbar: "Перетащить панель инструментов",
        notesOn: "Включить заметки",
        notesOff: "Выключить заметки",
        notesNotAllowed: "Заметки недоступны",
        notesOnLabel: "Заметки: Вкл",
        notesOffLabel: "Заметки: Выкл",
        drawingOn: "Включить рисование",
        drawingOff: "Выключить рисование",
        drawingNotAllowed: "Рисование недоступно",
        drawingOnLabel: "Рисование: Вкл",
        drawingOffLabel: "Рисование: Выкл",
        textBoxComingSoon: "Текстовое поле (Скоро)",
        textboxNotAllowed: "Text box not allowed",
        textboxOn: "Включить текстовое поле",
        textboxOff: "Выключить текстовое поле",
        textboxOnLabel: "Текстовое поле: Вкл",
        textboxOffLabel: "Текстовое поле: Выкл",
        highlightOn: "Включить выделение",
        highlightOff: "Выключить выделение",
        highlightsNotAllowed: "Выделения недоступны",
        highlightOnLabel: "Выделение: Вкл",
        highlightOffLabel: "Выделение: Выкл",
        highlightColorLabel: "Цвет выделения",
        colorRed: "Красный",
        colorOrange: "Оранжевый",
        colorYellow: "Жёлтый",
        colorGreen: "Зелёный",
        colorLightBlue: "Голубой",
        colorPurple: "Фиолетовый",
        underlinesNotAllowed: "Подчеркивание недоступно",
        underlineOn: "Включить подчеркивание",
        underlineOff: "Выключить подчеркивание",
        underlineOnLabel: "Подчеркивание: Вкл",
        underlineOffLabel: "Подчеркивание: Выкл",
        undo: "Отменить ({{ctrl}}+Z)",
        redo: "Повторить ({{ctrl}}+Y)",
        undoCooldown: "Отменить (подождите)",
        redoCooldown: "Повторить (подождите)",
      },
      contextMenu: {
        addNote: "Добавить заметку",
        highlight: "Выделить",
        underline: "Подчеркнуть",
        copy: "Копировать",
        removeHighlight: "Удалить выделение",
        removeUnderline: "Удалить подчеркивание",
        searchSelected: "Найти выбранное слово",
        selectionToolbar: "Меню выделения",
        askAi: "Спросить ИИ",
        share: "Поделиться",
        translate: "Перевести",
        comingSoon: "Скоро",
        translationTitle: "Перевод",
        translating: "Перевод…",
        translationFailed: "Ошибка перевода",
      },
      readerShell: {
        loadingDocument: "Загрузка документа...",
        documentControls: "Элементы управления документом",
      },
      emptyState: {
        errorAlt: "Ошибка",
        documentAlt: "Документ",
        unableToLoad: "Не удалось загрузить документ",
        noDocument: "Документ не загружен",
        requestDoc: "Запросите документ из вашей библиотеки, чтобы начать",
      },
      search: {
        ariaLabel: "Результаты поиска",
        searchResults: "Результаты Поиска",
        close: "Закрыть поиск",
        placeholder: "Поиск в документе...",
        clear: "Очистить поиск",
        searching: "Поиск...",
        enterQuery: "Введите запрос для поиска текста в документе",
        noResults: "Нет результатов для \"{{query}}\"",
        resultsCount_one: "Найден {{count}} результат",
        resultsCount_other: "Найдено {{count}} результатов",
        matchCount_one: "{{count}} совпадение",
        matchCount_other: "{{count}} совпадений",
        navigateToResult: "Нажмите, чтобы перейти к результату",
      },
      bookmarks: {
        title: "Закладки",
        close: "Закрыть закладки",
        loading: "Загрузка закладок...",
        error: "Ошибка загрузки закладок: {{error}}",
        noItems: "Пока нет закладок",
        navigate: "Нажмите, чтобы перейти к закладке",
        remove: "Удалить закладку",
        removeLabel: "Удалить закладку {{label}}",
        navigateLabel: "Перейти к {{label}}",
        defaultLabel: "Закладка {{page}}",
        deleteError: "Не удалось удалить закладку",
      },
      notes: {
        title: "Мой блокнот",
        close: "Закрыть мой блокнот",
        navigate: "Нажмите, чтобы перейти к заметке",
        ariaLabel: "Заметка: {{preview}} Страница {{page}} {{created}}",
        createdOn: "Создано {{date}}",
        pageTitle: "Страница {{page}}",
        remove: "Удалить заметку",
        removeLabel: "Удалить заметку со страницы {{page}}",
        none: "Пока нет заметок",
        share: "Поделиться блокнотом",
        searchPlaceholder: "Введите здесь",
        clearSearch: "Очистить поиск",
        tabsLabel: "Фильтры блокнота",
        tabs: {
          all: "Все",
          highlight: "Выделение",
          underline: "Подчёркивание",
          note: "Заметка",
        },
        resultsFound_one: "Найден {{count}} результат",
        resultsFound_other: "Найдено результатов: {{count}}",
        copyItem: "Копировать элемент",
        shareItem: "Поделиться элементом",
        noItems: "Пока нет элементов",
      },
      toc: {
        title: "Оглавление",
        close: "Закрыть оглавление",
        untitled: "Раздел без названия",
        empty: "Оглавление недоступно",
        noItems: "Оглавление недоступно",
        chapter: "Глава",
      },
      pages: {
        title: "Страницы",
        count_one: "{{count}} страница",
        count_other: "{{count}} страниц",
        empty: "Нет доступных страниц",
        thumbnailAlt: "Страница {{page}}",
        ariaLabel: "Миниатюры страниц",
      },
      epub: {
        loading: "Загрузка EPUB...",
        errorTitle: "Ошибка загрузки EPUB",
        reload: "Перезагрузить страницу",
        noteIndicatorTitle: "Заметка {{current}} из {{total}}: {{text}}{{suffix}}",
        noteSelectedSuffix: " (Заметка выбранного текста)",
        noteTitleEdit: "Редактировать заметку",
        noteTitleAdd: "Добавить заметку",
        noteCounter: "({{current}} из {{total}})",
        selectedTextLabel: "Выделенный текст:",
        notePlaceholderSelected: "Добавьте заметку о выбранном тексте...",
        notePlaceholder: "Введите заметку",
        noteActionSave: "Сохранить",
        noteActionCreate: "Создать",
        contextAddNote: "Добавить заметку",
        contextHighlight: "Выделить",
        contextSearch: "Искать выбранное слово",
        imageAlt: "Изображение",
        imageLightboxAria: "Увеличенное изображение",
        closeImagePreview: "Закрыть просмотр изображения",
      },
      notifications: {
        featureComingSoon: "Эта функция скоро.",
        featureNotAllowed: "Эта функция недоступна.",
        highlightsNotAvailable: "Выделение недоступно для этого документа.",
        underlinesNotAvailable: "Подчеркивание недоступно для этого документа.",
        notesNotAvailable: "Заметки недоступны для этого документа.",
        drawingNotAvailable: "Рисование недоступно для этого документа.",
        bookmarksNotAvailable: "Закладки недоступны для этого документа.",
        searchNotAvailable: "Поиск недоступен для этого документа.",
        commentsNotAvailable: "Комментарии недоступны для этого документа.",
        pageOutOfRange: "Эта страница недоступна.",
        aiAssistantComingSoon: "ИИ-помощник скоро появится.",
        textBoxComingSoon: "Текстовые поля скоро появятся.",
        textToSpeechComingSoon: "Озвучивание текста скоро появится.",
        sessionExpired: "Сессия истекла. Обновите страницу и попробуйте снова.",
        operationFailed: "Не удалось {{operation}}. Попробуйте снова.",
        copyLimitExceeded: "Превышен лимит копирования. Скопировано только {{limit}} символов.",
        copyNotAllowed: "Копирование запрещено для этого документа.",
        operations: {
          saveAiPreferences: "сохранить настройки ИИ",
          copyText: "скопировать текст",
          completeAction: "выполнить это действие",
          saveBookmark: "сохранить закладку",
          deleteBookmark: "удалить закладку",
          saveNote: "сохранить заметку",
          updateNote: "обновить заметку",
          deleteNote: "удалить заметку",
          saveHighlight: "сохранить выделение",
          updateHighlight: "обновить выделение",
          deleteHighlight: "удалить выделение",
          saveUnderline: "сохранить подчеркивание",
          deleteUnderline: "удалить подчеркивание",
          saveDrawing: "сохранить рисунок",
          deleteDrawing: "удалить рисунок",
          updateTextbox: "обновить текстовое поле",
          deleteTextbox: "удалить текстовое поле",
        },
      },
      faq: {
        open: "Открыть FAQ",
        title: "Как пользоваться E-Reader",
      },
      help: {
        close: "Закрыть справку",
        title: "Руководство пользователя E-Reader",
        featuresTab: "Функции",
        shortcutsTab: "Сочетания клавиш",
        gesturesTab: "Жесты",
        gestures: {
          title: "Жесты",
          tap: "Нажатие",
          tapDesc: "Выберите элемент или откройте ссылку",
          doubleTap: "Двойное нажатие",
          doubleTapDesc: "Приблизить или отдалить",
          swipeLeft: "Смахнуть влево",
          swipeLeftDesc: "Перейти к следующей странице",
          swipeRight: "Смахнуть вправо",
          swipeRightDesc: "Перейти к предыдущей странице",
          swipeUpDown: "Смахнуть вверх/вниз",
          swipeUpDownDesc: "Прокрутить страницу",
          pinchOut: "Раздвинуть (два пальца)",
          pinchIn: "Свести (два пальца)",
          longPress: "Длительное нажатие",
          longPressDesc: "Выделить текст или открыть дополнительные опции",
        },
        readingNav: "Чтение и навигация",
        navigation: "Навигация по странице",
        navigationDesc: "Используйте поле ввода страницы или миниатюры для перемещения на любую страницу",
        zoomControls: "Элементы управления масштабом",
        zoomControlsDesc: "Отрегулируйте уровень масштабирования или выберите режим подгонки по ширине/странице",
        search: "Поиск",
        searchDesc: "Найти и навигировать по тексту в документе",
        displayDesc: "Измените внешний вид чтения и параметры макета страницы",
        publicationDesc: "Просмотр сведений о текущем издании",
        organization: "Организация",
        bookmarks: "Закладки",
        bookmarksDesc: "Сохраняйте важные страницы для быстрого доступа",
        notes: "Примечания",
        notesDesc: "Добавьте текстовые примечания к определённым страницам",
        annotationTools: "Инструменты аннотирования",
        highlights: "Выделения",
        highlightsDesc: "Выделяйте важный текст, чтобы он выделялся",
        underlineDesc: "Подчёркивайте текст, чтобы отмечать ключевые фрагменты",
        drawing: "Рисование",
        drawingDesc: "Рисуйте свободные аннотации прямо на страницах",
        undoRedo: "Отменить и повторить",
        undoRedoDesc: "Отмените или повторите свои аннотации",
        comingSoon: "Скоро",
        audioReading: "Озвучивание",
        audioReadingDesc: "Слушайте содержание документа с преобразованием текста в речь",
        aiAssistant: "ИИ помощник",
        aiAssistantDesc: "Получайте умные идеи и сводки",
        shortcuts: {
          navigationAccessibility: "Навигация и доступность",
          browseForward: "Просмотр вперёд через интерактивные элементы",
          browseBackward: "Просмотр назад через интерактивные элементы",
          activateButton: "Активировать сфокусированную кнопку или ссылку",
          selectToggle: "Выберите или переключите сфокусированный элемент",
          closeDialogs: "Закрыть открытые диалоги и меню",
          nextPrevPage: "Следующая или предыдущая страница",
          jumpTop: "Перейти в начало документа",
          jumpBottom: "Перейти в конец документа",
          zoomViewControls: "Элементы управления масштабом и видом",
          zoomIn: "Увеличить",
          zoomOut: "Уменьшить",
          fitWidth: "Подогнать по ширине",
          fitPage: "Подогнать по странице",
          editingAnnotations: "Редактирование и аннотирование",
          undo: "Отменить последнее действие",
          redo: "Повторить последнее действие",
          toggleHighlight: "Переключить режим выделения",
          drawingBrush: "Переключить кисть рисования",
          toggleNotes: "Переключить боковую панель примечаний",
          toggleBookmarks: "Переключить боковую панель закладок",
          openToc: "Открыть оглавление",
          saveBookmark: "Сохранить закладку",
          searchContent: "Поиск и содержание",
          searchWithin: "Поиск в пределах документа",
          copyText: "Скопировать выбранный текст",
          selectAll: "Выбрать весь текст на текущей странице или в текущем представлении",
        },
        translateDesc: "Переводите выделенный текст с помощью ИИ",
      },
      loading: {
        initializing: "Инициализация...",
        restoringSession: "Восстановление сессии...",
        fetchingAccessToken: "Получение токена доступа...",
        loadingDocument: "Загрузка документа...",
        ariaLabel: "Загрузка",
        authenticating: "Аутентификация...",
        finalizing: "Завершение...",
      },
      errors: {
        failedToLoadPdf: "Не удалось загрузить PDF",
        failedToLoadEpub: "Не удалось загрузить EPUB",
        unsupportedFileType: "Неподдерживаемый тип файла. Загрузите PDF или EPUB.",
        errorReadingFile: "Ошибка чтения файла.",
        searchFailed: "Поиск не удался",
        failedToRestoreSession: "Не удалось восстановить сеанс.",
        failedToInitializeReader: "Не удалось инициализировать читалку по токену.",
      },
      readingAssistant: {
        title: "Помощник чтения",
        close: "Закрыть помощника чтения",
        resize: "Изменить размер помощника",
        resizeHint: "Перетащите, чтобы изменить размер. Двойной щелчок — сброс.",
        tabsLabel: "Вкладки помощника чтения",
        tabs: {
          summary: "Краткое содержание",
          askAi: "Спросить ИИ",
          quiz: "Викторина",
        },
        status: {
          loading: "Проверка…",
          processing: "Документ ещё готовится для ИИ. Повторите попытку чуть позже.",
          unavailable: "Функции ИИ недоступны для этого документа.",
          failed: "Обработка документа не удалась. Функции ИИ недоступны.",
          error: "Не удалось загрузить функции ИИ. {{message}}",
        },
        summary: {
          typesLabel: "Тип краткого содержания",
          types: {
            quick: "Краткое резюме",
            detailed: "Подробное резюме",
            chapter: "По главам",
          },
          cardTitles: {
            quick: "Краткое резюме",
            detailed: "Подробное резюме",
            chapter: "Резюме по главам",
          },
          welcomeTitle: "Помощник чтения",
          welcome: "Добро пожаловать в чтение с ИИ. Выберите вариант резюме, когда будете готовы.",
          loading: "Создание резюме",
          error: "Не удалось создать резюме. {{message}}",
          empty: "Выберите тип резюме для создания.",
          chooseChapter: "Выберите главу ниже, чтобы создать её резюме.",
          chapterListLabel: "Главы",
          noChapters: "Для этого документа нет доступных глав.",
          backToTypes: "Назад",
          regenerate: "Создать заново",
        },
        askAi: {
          placeholder: "Спросите что угодно об этой книге...",
          submit: "Отправить вопрос",
          empty: "Задайте вопрос, чтобы начать разговор.",
          sending: "Думаю",
          error: "Не удалось получить ответ. {{message}}",
          export: "Экспорт",
          newChat: "Новый чат",
        },
        quiz: {
          title: "Пройти викторину",
          subtitle: "Выберите, по чему хотите пройти проверку.",
          cta: "Начать викторину",
          loading: "Создание викторины",
          error: "Не удалось создать викторину. {{message}}",
          modalTitle: "Викторина ИИ",
          disclaimer: "Контент ИИ, только для справки.",
          close: "Закрыть викторину",
          checkAnswer: "Проверить ответ",
          explanation: "Пояснение",
          previous: "Назад",
          next: "Следующий вопрос",
          finish: "Завершить",
          progress: "Вопрос {{current}} из {{total}}",
          answerRequired: "Ответьте на этот вопрос, чтобы продолжить.",
          completedTitle: "Викторина завершена!",
          yourScore: "Ваш результат",
          completedMessage: "Вы успешно завершили викторину.",
          reattempt: "Пройти снова",
          save: "Сохранить",
          saving: "Сохранение…",
          saved: "Сохранено",
          saveError: "Не удалось сохранить результат. {{message}}",
          deleteError: "Не удалось удалить результат. {{message}}",
          deleteResult: "Удалить сохранённую викторину",
          deletedToast: "Викторина удалена",
          recentQuizzes: "Недавние викторины",
          seeDetails: "Подробнее",
          showDetails: "Показать детали",
          hideDetails: "Скрыть детали",
          correct: "Верно",
          incorrect: "Неверно",
          multipleChoice: "Множественный выбор",
          questionStatusAria: "Вопрос {{number}}: {{status}}",
          backToDashboard: "Панель викторин",
          scopeLabel: "Область викторины",
          scopeBook: "По книге",
          scopeChapter: "По главе",
          scopePage: "По странице",
          scopePageTitle: "Страница {{page}}",
          scoreAria: "Результат {{correct}} из {{total}}",
          answerOptions: "Варианты ответа",
          navigationAria: "Навигация по викторине",
          noQuestions: "Вопросы викторины не получены",
          feedback: {
            greatJob: "Отлично!",
            goodEffort: "Хорошая попытка!",
            keepPracticing: "Продолжайте практиковаться!",
          },
        },
        menu: {
          preferences: "Настройки ИИ",
          citation: "Цитирование ИИ",
          copy: "Копирование ИИ",
          quizzes: "Викторины ИИ",
          notes: "Заметки",
          prefs: {
            aiLanguage: "Предпочитаемый язык",
            citationEnabled: "Показывать цитаты",
            contextInclusionEnabled: "Включать контекст чтения",
          },
        },
      },
      pullouts: {
        fallbackTitle: "Всплывающий блок",
        hintLabel: "Подсказка:",
        hintAvailable: "Подсказка доступна",
        expandHint: "Развернуть подсказку",
        collapseHint: "Свернуть подсказку",
      },
      publicationDetails: {
        title: "Сведения об издании",
        close: "Закрыть сведения об издании",
        copy: "Копировать сведения об издании",
        copied: "Скопировано в буфер обмена",
        description: "Описание",
        noData: "Нет данных",
        empty: "Сведения об издании для этого документа недоступны.",

        fields: {
          title: "Название",
          author: "Автор",
          code: "Код",
          type: "Тип",
          language: "Язык",
          original_publisher: "Оригинальный издатель",
          series: "Серия",
          edition: "Издание",
          pages: "Страницы",
          pisbn13: "PISBN13",
          publication_year: "Год публикации",
          copyright_year: "Год авторского права",
          read_direction: "Направление чтения",
          content_type: "Тип содержимого",
        },
      },
    },
  },
  th: {
    translation: {
      common: {
        cancel: "ยกเลิก",
        close: "ปิด",
        noItems: "ไม่มีสารบัญให้ใช้งาน",
        menu: "เมนู",
        search: "ค้นหา",
        bookmarks: "ที่คั่นหน้า",
        notes: "บันทึกย่อ",
        pages: "หน้า",
        tableOfContents: "สารบัญ",
        page: "หน้า",
        section: "ส่วน",
        loading: "กำลังโหลด...",
        submit: "ส่ง",
        apply: "ใช้งาน",
        remove: "ลบ",
        error: "ข้อผิดพลาด",
        language: "ภาษา",
        theme: "ธีม",
        light: "สว่าง",
        dark: "มืด",
        on: "เปิด",
        off: "ปิด",
        showMore: "แสดงเพิ่มเติม",
        showLess: "แสดงน้อยลง",
        undo: "เลิกทำ",
        redo: "ทำซ้ำ",
        underline: "ขีดเส้นใต้",
        highlight: "ไฮไลต์",
        textbox: "กล่องข้อความ",
        document: "เอกสาร",
        back: "กลับ",
      },
      toolbar: {
        expand: "ขยายแถบเครื่องมือ",
        collapse: "ย่อแถบเครื่องมือ",
        aiAssistant: "ถามผู้ช่วย AI",
        aiAssistantComingSoon: "ถามผู้ช่วย AI (เร็วๆ นี้)",
        searchNotAllowed: "ไม่อนุญาตให้ค้นหา",
        textToSpeechComingSoon: "แปลงข้อความเป็นเสียง (เร็วๆ นี้)",
        addBookmark: "เพิ่มที่คั่นหน้า",
        removeBookmark: "ลบที่คั่นหน้า",
        bookmarked: "คั่นหน้าแล้ว",
        bookmarksNotAllowed: "ไม่อนุญาตให้ใช้ที่คั่นหน้า",
        moreOptions: "ตัวเลือกเพิ่มเติม",
        display: "การแสดงผล",
        lightHint: "พื้นหลังสว่างและข้อความเข้ม",
        darkHint: "พื้นหลังมืดและข้อความสว่าง",
        pageView: "มุมมองหน้า",
        singlePage: "หน้าเดียว",
        singlePageHint: "เลื่อนทีละหน้า",
        doublePage: "สองหน้า",
        doublePageHint: "ดูหน้าคู่กัน",
        view: "โหมดสี",
        share: "แชร์",
        download: "ดาวน์โหลด",
        citation: "การอ้างอิง",
        print: "พิมพ์",
        displayMenu: "เมนูการแสดงผล",
        displayMenuItems: {
          colorMode: "โหมดสี",
          fontSize: "ขนาดตัวอักษร",
          fontFamily: "แบบอักษร",
          lineHeight: "ระยะห่างบรรทัด",
          increaseLineHeight: "เพิ่มระยะห่างบรรทัด",
          decreaseLineHeight: "ลดระยะห่างบรรทัด",
          layout: "เลย์เอาต์",
          rotate: "หมุน",
          readingDirection: "ทิศทางการอ่าน",
          rotateLeft: "หมุนซ้าย",
          rotateRight: "หมุนขวา",
          ltr: "ซ้ายไปขวา",
          rtl: "ขวาไปซ้าย",
          fonts: {
            original: "ต้นฉบับ",
            sans: "Sans",
            serif: "Serif",
          },
          colors: {
            light: "สว่าง",
            dark: "มืด",
            mint: "มิ้นต์",
            sepia: "ซีเปีย",
          },
        },
      },
      mobile: {
        searchPlaceholder: "ค้นหาคำสำคัญ...",
        cancelSearch: "ยกเลิกการค้นหา",
        faq: "คำถามที่พบบ่อย",
      },
      menu: {
        close: "ปิดเมนู",
        documentPageCount: "หน้า {{current}} จาก {{total}}",
      },
      rightToolbar: {
        showToc: "แสดงสารบัญ",
        hideToc: "ซ่อนสารบัญ",
        showPagesThumbnails: "แสดงภาพย่อหน้า",
        hidePagesThumbnails: "ซ่อนภาพย่อหน้า",
        showBookmarks: "แสดงที่คั่นหน้า",
        hideBookmarks: "ซ่อนที่คั่นหน้า",
        info: "ข้อมูลสิ่งพิมพ์",
        showPublicationDetails: "แสดงรายละเอียดสิ่งพิมพ์",
        hidePublicationDetails: "ซ่อนรายละเอียดสิ่งพิมพ์",
        askAi: "ถาม AI",
        readingGroup: "กลุ่มการอ่าน",
        showNotes: "แสดงบันทึกย่อ",
        hideNotes: "ซ่อนบันทึกย่อ",
        myNotebook: "สมุดบันทึกของฉัน",
        clickToEnterPage: "คลิกเพื่อป้อนหมายเลขหน้า",
        currentPageLabel: "หน้าปัจจุบัน {{current}} คลิกเพื่อเปลี่ยน",
        previousPage: "หน้าก่อนหน้า",
        nextPage: "หน้าถัดไป",
        zoomOut: "ย่อ",
        zoomIn: "ขยาย",
        resetZoom: "รีเซ็ตการซูม",
        resetZoomTitle: "รีเซ็ตการซูมเป็น 100%",
        decreaseFontSize: "ลดขนาดฟอนต์",
        increaseFontSize: "เพิ่มขนาดฟอนต์",
        resetFontSize: "รีเซ็ตขนาดฟอนต์",
        resetFontSizeTitle: "รีเซ็ตขนาดฟอนต์เป็น 100%",
        viewModeOptions: "ตัวเลือกมุมมอง",
        fitToWidth: "พอดีกับความกว้าง",
        fitToPage: "พอดีกับหน้า",
        enterFullscreen: "เต็มหน้าจอ",
        exitFullscreen: "ออกจากเต็มหน้าจอ",
        enterPageNumber: "ป้อนหมายเลขหน้า",
        pageInputPlaceholder: "{{min}}-{{max}}",
        pageInputTitle: "ป้อนหมายเลขหน้า ({{min}}-{{max}})",
        pageInputInvalid: "โปรดป้อนหมายเลขหน้าที่ถูกต้อง",
        pageInputOutOfRange: "หน้าต้องอยู่ระหว่าง 1 ถึง {{total}}",
        showReadingAssistant: "แสดงผู้ช่วยการอ่าน",
        hideReadingAssistant: "ซ่อนผู้ช่วยการอ่าน",
      },
      floatingToolbar: {
        ariaLabel: "แถบเครื่องมือลอย",
        dragToMove: "ลากเพื่อย้าย",
        dragToolbar: "ลากแถบเครื่องมือ",
        notesOn: "เปิดบันทึกย่อ",
        notesOff: "ปิดบันทึกย่อ",
        notesNotAllowed: "ไม่อนุญาตให้ใช้บันทึกย่อ",
        notesOnLabel: "บันทึกย่อ: เปิด",
        notesOffLabel: "บันทึกย่อ: ปิด",
        drawingOn: "เปิดการวาด",
        drawingOff: "ปิดการวาด",
        drawingNotAllowed: "ไม่อนุญาตให้วาด",
        drawingOnLabel: "การวาด: เปิด",
        drawingOffLabel: "การวาด: ปิด",
        textBoxComingSoon: "กล่องข้อความ (เร็วๆ นี้)",
        textboxNotAllowed: "Text box not allowed",
        textboxOn: "เปิดกล่องข้อความ",
        textboxOff: "ปิดกล่องข้อความ",
        textboxOnLabel: "กล่องข้อความ: เปิด",
        textboxOffLabel: "กล่องข้อความ: ปิด",
        highlightOn: "เปิดไฮไลต์",
        highlightOff: "ปิดไฮไลต์",
        highlightsNotAllowed: "ไม่อนุญาตให้ไฮไลต์",
        highlightOnLabel: "ไฮไลต์: เปิด",
        highlightOffLabel: "ไฮไลต์: ปิด",
        underlineOn: "เปิดขีดเส้นใต้",
        underlineOff: "ปิดขีดเส้นใต้",
        underlineOnLabel: "ขีดเส้นใต้: เปิด",
        underlineOffLabel: "ขีดเส้นใต้: ปิด",
        highlightColorLabel: "สีไฮไลต์",
        colorRed: "แดง",
        colorOrange: "ส้ม",
        colorYellow: "เหลือง",
        colorGreen: "เขียว",
        colorLightBlue: "ฟ้าอ่อน",
        colorPurple: "ม่วง",
        underlinesNotAllowed: "ไม่อนุญาตให้ขีดเส้นใต้",
        undo: "เลิกทำ ({{ctrl}}+Z)",
        redo: "ทำซ้ำ ({{ctrl}}+Y)",
        undoCooldown: "เลิกทำ (โปรดรอ)",
        redoCooldown: "ทำซ้ำ (โปรดรอ)",
      },
      contextMenu: {
        addNote: "เพิ่มบันทึก",
        highlight: "ไฮไลต์",
        underline: "ขีดเส้นใต้",
        copy: "คัดลอก",
        removeHighlight: "ลบไฮไลต์",
        removeUnderline: "ลบขีดเส้นใต้",
        searchSelected: "ค้นหาคำที่เลือก",
        selectionToolbar: "เมนูการเลือก",
        askAi: "ถาม AI",
        share: "แชร์",
        translate: "แปล",
        comingSoon: "เร็ว ๆ นี้",
        translationTitle: "การแปล",
        translating: "กำลังแปล…",
        translationFailed: "แปลไม่สำเร็จ",
      },
      readerShell: {
        loadingDocument: "กำลังโหลดเอกสาร...",
        documentControls: "ควบคุมเอกสาร",
      },
      emptyState: {
        errorAlt: "ข้อผิดพลาด",
        documentAlt: "เอกสาร",
        unableToLoad: "ไม่สามารถโหลดเอกสารได้",
        noDocument: "ยังไม่ได้โหลดเอกสาร",
        requestDoc: "ขอเอกสารจากห้องสมุดของคุณเพื่อเริ่มต้น",
      },
      search: {
        ariaLabel: "ผลการค้นหา",
        searchResults: "ผลการค้นหา",
        close: "ปิดการค้นหา",
        placeholder: "ค้นหาในเอกสาร...",
        clear: "ล้างการค้นหา",
        searching: "กำลังค้นหา...",
        enterQuery: "ป้อนคำค้นหาเพื่อค้นหาข้อความในเอกสาร",
        noResults: "ไม่พบผลลัพธ์สำหรับ \"{{query}}\"",
        resultsCount_one: "พบ {{count}} ผลลัพธ์",
        resultsCount_other: "พบ {{count}} ผลลัพธ์",
        matchCount_one: "{{count}} รายการที่ตรงกัน",
        matchCount_other: "{{count}} รายการที่ตรงกัน",
        navigateToResult: "คลิกเพื่อไปยังผลลัพธ์นี้",
      },
      bookmarks: {
        title: "ที่คั่นหน้า",
        close: "ปิดที่คั่นหน้า",
        loading: "กำลังโหลดที่คั่นหน้า...",
        error: "เกิดข้อผิดพลาดในการโหลดที่คั่นหน้า: {{error}}",
        noItems: "ยังไม่มีที่คั่นหน้า",
        navigate: "คลิกเพื่อไปยังที่คั่นหน้านี้",
        remove: "ลบที่คั่นหน้า",
        removeLabel: "ลบที่คั่นหน้า {{label}}",
        navigateLabel: "ไปที่ {{label}}",
        defaultLabel: "ที่คั่นหน้า {{page}}",
        deleteError: "ลบที่คั่นหน้าไม่สำเร็จ",
      },
      notes: {
        title: "สมุดบันทึกของฉัน",
        close: "ปิดสมุดบันทึกของฉัน",
        navigate: "คลิกเพื่อไปยังบันทึกนี้",
        ariaLabel: "บันทึก: {{preview}} หน้า {{page}} {{created}}",
        createdOn: "สร้างเมื่อ {{date}}",
        pageTitle: "หน้า {{page}}",
        remove: "ลบบันทึก",
        removeLabel: "ลบบันทึกจากหน้า {{page}}",
        none: "ยังไม่มีบันทึก",
        share: "แชร์สมุดบันทึก",
        searchPlaceholder: "พิมพ์ที่นี่",
        clearSearch: "ล้างการค้นหา",
        tabsLabel: "ตัวกรองสมุดบันทึก",
        tabs: {
          all: "ทั้งหมด",
          highlight: "ไฮไลต์",
          underline: "ขีดเส้นใต้",
          note: "บันทึก",
        },
        resultsFound_one: "พบ {{count}} รายการ",
        resultsFound_other: "พบ {{count}} รายการ",
        copyItem: "คัดลอกรายการ",
        shareItem: "แชร์รายการ",
        noItems: "ยังไม่มีรายการ",
      },
      toc: {
        title: "สารบัญ",
        close: "ปิดสารบัญ",
        untitled: "ส่วนที่ไม่มีชื่อ",
        empty: "ไม่มีสารบัญให้ใช้งาน",
      },
      pages: {
        title: "หน้า",
        count_one: "{{count}} หน้า",
        count_other: "{{count}} หน้า",
        empty: "ไม่มีหน้าให้ใช้งาน",
        thumbnailAlt: "หน้า {{page}}",
        ariaLabel: "ภาพย่อหน้า",
      },
      epub: {
        loading: "กำลังโหลด EPUB...",
        errorTitle: "เกิดข้อผิดพลาดในการโหลด EPUB",
        reload: "โหลดหน้าใหม่",
        noteIndicatorTitle: "บันทึก {{current}} จาก {{total}}: {{text}}{{suffix}}",
        noteSelectedSuffix: " (บันทึกข้อความที่เลือก)",
        noteTitleEdit: "แก้ไขบันทึก",
        noteTitleAdd: "เพิ่มบันทึก",
        noteCounter: "({{current}} จาก {{total}})",
        selectedTextLabel: "ข้อความที่เลือก:",
        notePlaceholderSelected: "เพิ่มบันทึกเกี่ยวกับข้อความที่เลือก...",
        notePlaceholder: "พิมพ์บันทึก",
        noteActionSave: "บันทึก",
        noteActionCreate: "สร้าง",
        contextAddNote: "เพิ่มบันทึก",
        contextHighlight: "ไฮไลต์",
        contextSearch: "ค้นหาคำที่เลือก",
        imageAlt: "รูปภาพ",
        imageLightboxAria: "รูปภาพขยาย",
        closeImagePreview: "ปิดตัวอย่างรูปภาพ",
      },
      notifications: {
        featureNotAllowed: "ฟีเจอร์นี้ไม่พร้อมใช้งาน",
        featureComingSoon: "ฟีเจอร์นี้จะเข้ามาหนิด",
        highlightsNotAvailable: "ไม่สามารถไฮไลต์ได้สำหรับเอกสารนี้",
        underlinesNotAvailable: "ไม่สามารถขีดเส้นใต้สำหรับเอกสารนี้ได้",
        notesNotAvailable: "ไม่สามารถใช้บันทึกได้สำหรับเอกสารนี้",
        drawingNotAvailable: "ไม่สามารถวาดได้สำหรับเอกสารนี้",
        bookmarksNotAvailable: "ไม่สามารถใช้ที่คั่นหน้าได้สำหรับเอกสารนี้",
        searchNotAvailable: "ไม่สามารถค้นหาได้สำหรับเอกสารนี้",
        commentsNotAvailable: "ไม่สามารถใช้ความคิดเห็นได้สำหรับเอกสารนี้",
        pageOutOfRange: "หน้านี้ไม่พร้อมใช้งาน",
        aiAssistantComingSoon: "ผู้ช่วย AI กำลังจะมาเร็วๆ นี้",
        textBoxComingSoon: "กล่องข้อความกำลังจะมาเร็วๆ นี้",
        textToSpeechComingSoon: "แปลงข้อความเป็นเสียงกำลังจะมาเร็วๆ นี้",
        sessionExpired: "เซสชันหมดอายุ โปรดรีเฟรชและลองอีกครั้ง",
        operationFailed: "ไม่สามารถ {{operation}} ได้ โปรดลองอีกครั้ง",
        copyLimitExceeded: "เกินขีดจำกัดการคัดลอก คัดลอกได้เพียง {{limit}} ตัวอักษร",
        copyNotAllowed: "ไม่อนุญาตให้คัดลอกสำหรับเอกสารนี้",
        operations: {
          saveAiPreferences: "บันทึกการตั้งค่า AI",
          copyText: "คัดลอกข้อความ",
          completeAction: "ดำเนินการนี้",
          saveBookmark: "บันทึกที่คั่นหน้า",
          deleteBookmark: "ลบที่คั่นหน้า",
          saveNote: "บันทึกโน้ต",
          updateNote: "อัปเดตโน้ต",
          deleteNote: "ลบโน้ต",
          saveHighlight: "บันทึกไฮไลต์",
          updateHighlight: "อัปเดตไฮไลต์",
          deleteHighlight: "ลบไฮไลต์",
          saveUnderline: "บันทึกขีดเส้นใต้",
          deleteUnderline: "ลบขีดเส้นใต้",
          saveDrawing: "บันทึกภาพวาด",
          deleteDrawing: "ลบภาพวาด",
          updateTextbox: "อัปเดตกล่องข้อความ",
          deleteTextbox: "ลบกล่องข้อความ",
        },
      },
      faq: {
        open: "เปิดคำถามที่พบบ่อย",
        title: "วิธีใช้ E-Reader",
      },
      help: {
        close: "ปิดความช่วยเหลือ",
        title: "คู่มือผู้ใช้ E-Reader",
        featuresTab: "คุณสมบัติ",
        shortcutsTab: "ทางลัดแป้นพิมพ์",
        gesturesTab: "ท่าทางสัมผัส",
        gestures: {
          title: "ท่าทางสัมผัส",
          tap: "แตะ",
          tapDesc: "เลือกไอเท็มหรือเปิดลิงก์",
          doubleTap: "แตะสองครั้ง",
          doubleTapDesc: "ขยายหรือย่อ",
          swipeLeft: "ปัดไปทางซ้าย",
          swipeLeftDesc: "ไปยังหน้าถัดไป",
          swipeRight: "ปัดไปทางขวา",
          swipeRightDesc: "ไปยังหน้าก่อนหน้า",
          swipeUpDown: "ปัดขึ้น/ลง",
          swipeUpDownDesc: "เลื่อนหน้าจอ",
          pinchOut: "หมุนออก (สองนิ้วแยก)",
          pinchIn: "หมุนเข้า (สองนิ้วชิด)",
          longPress: "กดค้าง",
          longPressDesc: "เลือกข้อความหรือเปิดตัวเลือกเพิ่มเติม",
        },
        readingNav: "การอ่านและการนำทาง",
        navigation: "การนำทางหน้า",
        navigationDesc: "ใช้ฟิลด์ป้อนข้อมูลหน้าหรือภาพขนาดย่อเพื่อข้ามไปยังหน้าใดก็ได้",
        zoomControls: "การควบคุมการซูม",
        zoomControlsDesc: "ปรับระดับการซูมหรือเลือกโหมดพอดีความกว้าง/หน้า",
        search: "ค้นหา",
        searchDesc: "ค้นหาและนำทางผ่านข้อความในเอกสาร",
        displayDesc: "เปลี่ยนลักษณะการอ่านและตัวเลือกการจัดวางหน้า",
        publicationDesc: "ดูรายละเอียดเกี่ยวกับสิ่งพิมพ์ปัจจุบัน",
        organization: "องค์กร",
        bookmarks: "ที่คั่นหน้า",
        bookmarksDesc: "บันทึกหน้าที่สำคัญเพื่อการเข้าถึงอย่างรวดเร็ว",
        notes: "หมายเหตุ",
        notesDesc: "เพิ่มหมายเหตุข้อความไปยังหน้าเฉพาะ",
        annotationTools: "เครื่องมือคำอธิบาย",
        highlights: "ความสำคัญ",
        highlightsDesc: "เน้นข้อความสำคัญให้เด่นชัด",
        underlineDesc: "ขีดเส้นใต้ข้อความเพื่อทำเครื่องหมายช่วงสำคัญ",
        drawing: "การวาดรูป",
        drawingDesc: "วาดคำอธิบายที่เขียนด้วยมือลงบนหน้า",
        undoRedo: "ยกเลิกและทำซ้ำ",
        undoRedoDesc: "ย้อนกลับหรือทำซ้ำคำอธิบายของคุณ",
        comingSoon: "เร็ว ๆ นี้",
        audioReading: "การอ่านเสียง",
        audioReadingDesc: "ฟังเนื้อหาเอกสารด้วยการแปลงข้อความเป็นคำพูด",
        aiAssistant: "ผู้ช่วย AI",
        aiAssistantDesc: "รับข้อมูลเชิงลึกและบทสรุปที่ชาญฉลาด",
        shortcuts: {
          navigationAccessibility: "การนำทางและการเข้าถึง",
          browseForward: "เรียกดูไปข้างหน้าผ่านองค์ประกอบแบบโต้ตอบ",
          browseBackward: "เรียกดูย้อนกลับผ่านองค์ประกอบแบบโต้ตอบ",
          activateButton: "เปิดใช้งานปุ่มหรือลิงก์ที่อยู่ในโฟกัส",
          selectToggle: "เลือกหรือสลับองค์ประกอบที่อยู่ในโฟกัส",
          closeDialogs: "ปิดไดอะล็อกและเมนูที่เปิด",
          nextPrevPage: "หน้าถัดไปหรือหน้าก่อนหน้า",
          jumpTop: "ข้ามไปยังจุดเริ่มต้นเอกสาร",
          jumpBottom: "ข้ามไปยังจุดสิ้นสุดเอกสาร",
          zoomViewControls: "การควบคุมการซูมและมุมมอง",
          zoomIn: "ซูมเข้า",
          zoomOut: "ซูมออก",
          fitWidth: "พอดีความกว้าง",
          fitPage: "พอดีหน้า",
          editingAnnotations: "การแก้ไขและคำอธิบาย",
          undo: "ยกเลิกการดำเนินการล่าสุด",
          redo: "ทำซ้ำการดำเนินการล่าสุด",
          toggleHighlight: "สลับโหมดเน้น",
          drawingBrush: "สลับแปรงวาด",
          toggleNotes: "สลับแถบด้านข้างบันทึก",
          toggleBookmarks: "สลับแถบด้านข้างที่คั่นหน้า",
          openToc: "เปิดสารบัญ",
          saveBookmark: "บันทึกที่คั่นหน้า",
          searchContent: "ค้นหาและเนื้อหา",
          searchWithin: "ค้นหาในเอกสาร",
          copyText: "คัดลอกข้อความที่เลือก",
          selectAll: "เลือกข้อความทั้งหมดในหน้าหรือมุมมองปัจจุบัน",
        },
        translateDesc: "แปลข้อความที่เลือกด้วย AI",
      },
      loading: {
        initializing: "กำลังเริ่มต้น...",
        restoringSession: "กำลังกู้คืนเซสชัน...",
        fetchingAccessToken: "กำลังดึงโทเค็นการเข้าถึง...",
        loadingDocument: "กำลังโหลดเอกสาร...",
        ariaLabel: "กำลังโหลด",
        authenticating: "กำลังยืนยันตัวตน...",
        finalizing: "กำลังสรุป...",
      },
      errors: {
        failedToLoadPdf: "ไม่สามารถโหลด PDF ได้",
        failedToLoadEpub: "ไม่สามารถโหลด EPUB ได้",
        unsupportedFileType: "ประเภทไฟล์ไม่รองรับ โปรดอัปโหลด PDF หรือ EPUB",
        errorReadingFile: "เกิดข้อผิดพลาดในการอ่านไฟล์",
        searchFailed: "การค้นหาล้มเหลว",
        failedToRestoreSession: "กู้คืนเซสชันไม่สำเร็จ",
        failedToInitializeReader: "เริ่มต้นตัวอ่านจากโทเค็นไม่สำเร็จ",
      },
      readingAssistant: {
        title: "ผู้ช่วยการอ่าน",
        close: "ปิดผู้ช่วยการอ่าน",
        resize: "ปรับขนาดผู้ช่วยการอ่าน",
        resizeHint: "ลากเพื่อปรับขนาด ดับเบิลคลิกเพื่อรีเซ็ต",
        tabsLabel: "แท็บผู้ช่วยการอ่าน",
        tabs: {
          summary: "สรุป",
          askAi: "ถาม AI",
          quiz: "แบบทดสอบ",
        },
        status: {
          loading: "กำลังตรวจสอบ…",
          processing: "เอกสารยังอยู่ระหว่างเตรียมสำหรับ AI โปรดลองอีกครั้งในไม่ช้า",
          unavailable: "ฟีเจอร์ AI ไม่พร้อมใช้งานสำหรับเอกสารนี้",
          failed: "ประมวลผลเอกสารไม่สำเร็จ ฟีเจอร์ AI ไม่พร้อมใช้งาน",
          error: "ไม่สามารถโหลดฟีเจอร์ AI ได้ {{message}}",
        },
        summary: {
          typesLabel: "ประเภทสรุป",
          types: {
            quick: "สรุปสั้น",
            detailed: "สรุปละเอียด",
            chapter: "สรุปทีละบท",
          },
          cardTitles: {
            quick: "สรุปสั้น",
            detailed: "สรุปละเอียด",
            chapter: "สรุปทีละบท",
          },
          welcomeTitle: "ผู้ช่วยการอ่าน",
          welcome: "ยินดีต้อนรับสู่ประสบการณ์การอ่านด้วย AI เลือกตัวเลือกสรุปเมื่อพร้อม",
          loading: "กำลังสร้างสรุป",
          error: "สร้างสรุปไม่สำเร็จ {{message}}",
          empty: "เลือกประเภทสรุปเพื่อสร้าง",
          chooseChapter: "เลือกบทด้านล่างเพื่อสร้างสรุป",
          chapterListLabel: "บท",
          noChapters: "ไม่มีบทสำหรับเอกสารนี้",
          backToTypes: "กลับ",
          regenerate: "สร้างใหม่",
        },
        askAi: {
          placeholder: "ถามอะไรก็ได้เกี่ยวกับหนังสือเล่มนี้...",
          submit: "ส่งคำถาม",
          empty: "ถามคำถามเพื่อเริ่มการสนทนา",
          sending: "กำลังคิด",
          error: "ไม่ได้รับคำตอบ {{message}}",
          export: "ส่งออก",
          newChat: "แชทใหม่",
        },
        quiz: {
          title: "ทำแบบทดสอบ",
          subtitle: "เลือกสิ่งที่ต้องการทดสอบ",
          cta: "เริ่มแบบทดสอบ",
          loading: "กำลังสร้างแบบทดสอบ",
          error: "สร้างแบบทดสอบไม่สำเร็จ {{message}}",
          modalTitle: "แบบทดสอบ AI",
          disclaimer: "เนื้อหาจาก AI สำหรับอ้างอิงเท่านั้น",
          close: "ปิดแบบทดสอบ",
          checkAnswer: "ตรวจคำตอบ",
          explanation: "คำอธิบาย",
          previous: "ก่อนหน้า",
          next: "คำถามถัดไป",
          finish: "เสร็จสิ้น",
          progress: "คำถาม {{current}} จาก {{total}}",
          answerRequired: "ตอบคำถามนี้เพื่อไปต่อ",
          completedTitle: "ทำแบบทดสอบเสร็จแล้ว!",
          yourScore: "คะแนนของคุณ",
          completedMessage: "คุณทำแบบทดสอบสำเร็จแล้ว",
          reattempt: "ทำแบบทดสอบอีกครั้ง",
          save: "บันทึก",
          saving: "กำลังบันทึก…",
          saved: "บันทึกแล้ว",
          saveError: "บันทึกผลไม่สำเร็จ {{message}}",
          deleteError: "ลบผลไม่สำเร็จ {{message}}",
          deleteResult: "ลบแบบทดสอบที่บันทึก",
          deletedToast: "ลบแบบทดสอบแล้ว",
          recentQuizzes: "แบบทดสอบล่าสุด",
          seeDetails: "ดูรายละเอียด",
          showDetails: "แสดงรายละเอียด",
          hideDetails: "ซ่อนรายละเอียด",
          correct: "ถูก",
          incorrect: "ผิด",
          multipleChoice: "ปรนัย",
          questionStatusAria: "คำถาม {{number}}: {{status}}",
          backToDashboard: "แดชบอร์ดแบบทดสอบ",
          scopeLabel: "ขอบเขตแบบทดสอบ",
          scopeBook: "ทั้งเล่ม",
          scopeChapter: "ตามบท",
          scopePage: "ตามหน้า",
          scopePageTitle: "หน้า {{page}}",
          scoreAria: "คะแนน {{correct}} จาก {{total}}",
          answerOptions: "ตัวเลือกคำตอบ",
          navigationAria: "การนำทางแบบทดสอบ",
          noQuestions: "ไม่ได้รับคำถามแบบทดสอบ",
          feedback: {
            greatJob: "ยอดเยี่ยม!",
            goodEffort: "พยายามดี!",
            keepPracticing: "ฝึกฝนต่อไป!",
          },
        },
        menu: {
          preferences: "การตั้งค่า AI",
          citation: "การอ้างอิง AI",
          copy: "คัดลอก AI",
          quizzes: "แบบทดสอบ AI",
          notes: "บันทึก",
          prefs: {
            aiLanguage: "ภาษาที่ต้องการ",
            citationEnabled: "แสดงการอ้างอิง",
            contextInclusionEnabled: "รวมบริบทการอ่าน",
          },
        },
      },
      pullouts: {
        fallbackTitle: "ป๊อปอัป",
        hintLabel: "คำใบ้:",
        hintAvailable: "มีคำใบ้",
        expandHint: "ขยายคำใบ้",
        collapseHint: "ยุบคำใบ้",
      },
      publicationDetails: {
        title: "รายละเอียดสิ่งพิมพ์",
        close: "ปิดรายละเอียดสิ่งพิมพ์",
        copy: "คัดลอกรายละเอียดสิ่งพิมพ์",
        copied: "คัดลอกไปยังคลิปบอร์ดแล้ว",
        description: "คำอธิบาย",
        noData: "ไม่มีข้อมูล",
        empty: "ไม่มีรายละเอียดสิ่งพิมพ์สำหรับเอกสารนี้",

        fields: {
          title: "ชื่อเรื่อง",
          author: "ผู้แต่ง",
          code: "รหัส",
          type: "ประเภท",
          language: "ภาษา",
          original_publisher: "สำนักพิมพ์ต้นฉบับ",
          series: "ชุดหนังสือ",
          edition: "ครั้งที่พิมพ์",
          pages: "จำนวนหน้า",
          pisbn13: "PISBN13",
          publication_year: "ปีที่เผยแพร่",
          copyright_year: "ปีลิขสิทธิ์",
          read_direction: "ทิศทางการอ่าน",
          content_type: "ประเภทเนื้อหา",
        },
      },
    },
  },
  tr: {
    translation: {
      common: {
        cancel: "İptal",
        close: "Kapat",
        noItems: "İçindekiler mevcut değil",
        menu: "Menü",
        search: "Ara",
        bookmarks: "Yer imleri",
        notes: "Notlar",
        pages: "Sayfalar",
        tableOfContents: "İçindekiler",
        page: "Sayfa",
        section: "Bölüm",
        loading: "Yükleniyor...",
        submit: "Gönder",
        apply: "Uygula",
        remove: "Kaldır",
        error: "Hata",
        language: "Dil",
        theme: "Tema",
        light: "Açık",
        dark: "Koyu",
        on: "Açık",
        off: "Kapalı",
        showMore: "Daha fazla göster",
        showLess: "Daha az göster",
        undo: "Geri al",
        redo: "Yinele",
        underline: "Altı çizili",
        highlight: "Vurgulama",
        textbox: "Metin kutusu",
        document: "Belge",
        back: "Geri",
      },
      toolbar: {
        expand: "Araç çubuğunu genişlet",
        collapse: "Araç çubuğunu daralt",
        aiAssistant: "Yapay Zekâ Asistanına Sor",
        aiAssistantComingSoon: "Yapay Zekâ Asistanına Sor (Yakında)",
        searchNotAllowed: "Arama izinli değil",
        textToSpeechComingSoon: "Metinden konuşma (Yakında)",
        addBookmark: "Yer imi ekle",
        removeBookmark: "Yer imini kaldır",
        bookmarked: "Yer imi eklendi",
        bookmarksNotAllowed: "Yer imleri izinli değil",
        moreOptions: "Daha fazla seçenek",
        display: "Görünüm",
        lightHint: "Açık arka plan, koyu metin",
        darkHint: "Koyu arka plan, açık metin",
        pageView: "Sayfa görünümü",
        singlePage: "Tek sayfa",
        singlePageHint: "Bir seferde bir sayfa kaydır",
        doublePage: "Çift sayfa",
        doublePageHint: "Sayfaları yan yana görüntüle",
        view: "Renk modu",
        share: "Paylaş",
        download: "İndir",
        citation: "Alıntı",
        print: "Yazdır",
        displayMenu: "Görünüm menüsü",
        displayMenuItems: {
          colorMode: "Renk modu",
          fontSize: "Yazı boyutu",
          fontFamily: "Yazı tipi",
          lineHeight: "Satır yüksekliği",
          increaseLineHeight: "Satır yüksekliğini artır",
          decreaseLineHeight: "Satır yüksekliğini azalt",
          layout: "Düzen",
          rotate: "Döndür",
          readingDirection: "Okuma yönü",
          rotateLeft: "Sola döndür",
          rotateRight: "Sağa döndür",
          ltr: "Soldan sağa",
          rtl: "Sağdan sola",
          fonts: {
            original: "Orijinal",
            sans: "Sans",
            serif: "Serif",
          },
          colors: {
            light: "Açık",
            dark: "Koyu",
            mint: "Nane",
            sepia: "Sepya",
          },
        },
      },
      mobile: {
        searchPlaceholder: "Anahtar kelime ara...",
        cancelSearch: "Aramayı iptal et",
        faq: "SSS",
      },
      menu: {
        close: "Menüyü kapat",
        documentPageCount: "Sayfa {{current}} / {{total}}",
      },
      rightToolbar: {
        showToc: "İçindekileri göster",
        hideToc: "İçindekileri gizle",
        showPagesThumbnails: "Sayfa küçük resimlerini göster",
        hidePagesThumbnails: "Sayfa küçük resimlerini gizle",
        showBookmarks: "Yer imlerini göster",
        hideBookmarks: "Yer imlerini gizle",
        info: "Yayın bilgisi",
        showPublicationDetails: "Yayın ayrıntılarını göster",
        hidePublicationDetails: "Yayın ayrıntılarını gizle",
        askAi: "Yapay zekaya sor",
        readingGroup: "Okuma grubu",
        showNotes: "Notları göster",
        hideNotes: "Notları gizle",
        myNotebook: "Defterim",
        clickToEnterPage: "Sayfa numarası girmek için tıklayın",
        currentPageLabel: "Geçerli sayfa {{current}}. Değiştirmek için tıklayın.",
        previousPage: "Önceki sayfa",
        nextPage: "Sonraki sayfa",
        zoomOut: "Uzaklaştır",
        zoomIn: "Yakınlaştır",
        resetZoom: "Yakınlaştırmayı sıfırla",
        resetZoomTitle: "Yakınlaştırmayı %100'e sıfırla",
        decreaseFontSize: "Yazı boyutunu küçült",
        increaseFontSize: "Yazı boyutunu büyült",
        resetFontSize: "Yazı boyutunu sıfırla",
        resetFontSizeTitle: "Yazı boyutunu %100'e sıfırla",
        viewModeOptions: "Görünüm seçenekleri",
        fitToWidth: "Genişliğe sığdır",
        fitToPage: "Sayfaya sığdır",
        enterFullscreen: "Tam ekrana geç",
        exitFullscreen: "Tam ekrandan çık",
        enterPageNumber: "Sayfa numarası girin",
        pageInputPlaceholder: "{{min}}-{{max}}",
        pageInputTitle: "Sayfa numarası girin ({{min}}-{{max}})",
        pageInputInvalid: "Geçerli bir sayfa numarası girin",
        pageInputOutOfRange: "Sayfa 1 ile {{total}} arasında olmalı",
        showReadingAssistant: "Okuma Asistanını göster",
        hideReadingAssistant: "Okuma Asistanını gizle",
      },
      floatingToolbar: {
        ariaLabel: "Kayan araç çubuğu",
        dragToMove: "Taşımak için sürükleyin",
        dragToolbar: "Araç çubuğunu sürükleyin",
        notesOn: "Notları aç",
        notesOff: "Notları kapat",
        notesNotAllowed: "Notlara izin verilmiyor",
        notesOnLabel: "Notlar: Açık",
        notesOffLabel: "Notlar: Kapalı",
        drawingOn: "Çizimi aç",
        drawingOff: "Çizimi kapat",
        drawingNotAllowed: "Çizime izin verilmiyor",
        drawingOnLabel: "Çizim: Açık",
        drawingOffLabel: "Çizim: Kapalı",
        textBoxComingSoon: "Metin kutusu (Yakında)",
        textboxNotAllowed: "Text box not allowed",
        textboxOn: "Metin kutusunu aç",
        textboxOff: "Metin kutusunu kapat",
        textboxOnLabel: "Metin kutusu: Açık",
        textboxOffLabel: "Metin kutusu: Kapalı",
        highlightOn: "Vurgulamayı aç",
        highlightOff: "Vurgulamayı kapat",
        highlightsNotAllowed: "Vurgulamaya izin verilmiyor",
        highlightOnLabel: "Vurgu: Açık",
        highlightOffLabel: "Vurgu: Kapalı",
        underlineOn: "Altını çiz",
        underlineOff: "Alt çizgiyi kapat",
        underlineOnLabel: "Altı çizili: Açık",
        underlineOffLabel: "Altı çizili: Kapalı",
        highlightColorLabel: "Vurgu rengi",
        colorRed: "Kırmızı",
        colorOrange: "Turuncu",
        colorYellow: "Sarı",
        colorGreen: "Yeşil",
        colorLightBlue: "Açık mavi",
        colorPurple: "Mor",
        underlinesNotAllowed: "Alt çizgiye izin verilmiyor",
        undo: "Geri al ({{ctrl}}+Z)",
        redo: "Yinele ({{ctrl}}+Y)",
        undoCooldown: "Geri al (lütfen bekleyin)",
        redoCooldown: "Yinele (lütfen bekleyin)",
      },
      contextMenu: {
        addNote: "Not ekle",
        highlight: "Vurgula",
        underline: "Altını çiz",
        copy: "Kopyala",
        removeHighlight: "Vurguyu kaldır",
        removeUnderline: "Alt çizgiyi kaldır",
        searchSelected: "Seçili kelimeyi ara",
        selectionToolbar: "Seçim menüsü",
        askAi: "Yapay zekaya sor",
        share: "Paylaş",
        translate: "Çevir",
        comingSoon: "Yakında",
        translationTitle: "Çeviri",
        translating: "Çevriliyor…",
        translationFailed: "Çeviri başarısız",
      },
      readerShell: {
        loadingDocument: "Belge yükleniyor...",
        documentControls: "Belge denetimleri",
      },
      emptyState: {
        errorAlt: "Hata",
        documentAlt: "Belge",
        unableToLoad: "Belge yüklenemedi",
        noDocument: "Belge yüklenmedi",
        requestDoc: "Başlamak için kütüphanenizden bir belge isteyin",
      },
      search: {
        ariaLabel: "Arama sonuçları",
        searchResults: "Arama Sonuçları",
        close: "Aramayı kapat",
        placeholder: "Belgede ara...",
        clear: "Aramayı temizle",
        searching: "Aranıyor...",
        enterQuery: "Belgede metin bulmak için arama girin",
        noResults: "\"{{query}}\" için sonuç bulunamadı",
        resultsCount_one: "{{count}} sonuç bulundu",
        resultsCount_other: "{{count}} sonuç bulundu",
        matchCount_one: "{{count}} eşleşme",
        matchCount_other: "{{count}} eşleşme",
        navigateToResult: "Bu sonuca gitmek için tıklayın",
      },
      bookmarks: {
        title: "Yer imleri",
        close: "Yer imlerini kapat",
        loading: "Yer imleri yükleniyor...",
        error: "Yer imleri yüklenirken hata: {{error}}",
        noItems: "Henüz yer imi yok",
        navigate: "Bu yer imine gitmek için tıklayın",
        remove: "Yer imini kaldır",
        removeLabel: "Yer imi kaldır {{label}}",
        navigateLabel: "{{label}} konumuna git",
        defaultLabel: "Yer imi {{page}}",
        deleteError: "Yer imi silinemedi",
      },
      notes: {
        title: "Defterim",
        close: "Defterimi kapat",
        navigate: "Bu nota gitmek için tıklayın",
        ariaLabel: "Not: {{preview}} Sayfa {{page}} {{created}}",
        createdOn: "{{date}} tarihinde oluşturuldu",
        pageTitle: "Sayfa {{page}}",
        remove: "Notu kaldır",
        removeLabel: "{{page}} sayfasından notu kaldır",
        none: "Henüz not yok",
        noItems: "Henüz öğe yok",
        share: "Defteri paylaş",
        searchPlaceholder: "Buraya yazın",
        clearSearch: "Aramayı temizle",
        tabsLabel: "Defter filtreleri",
        tabs: {
          all: "Tümü",
          highlight: "Vurgulama",
          underline: "Altı çizili",
          note: "Not",
        },
        resultsFound_one: "{{count}} sonuç bulundu",
        resultsFound_other: "{{count}} sonuç bulundu",
        copyItem: "Öğeyi kopyala",
        shareItem: "Öğeyi paylaş",
      },
      toc: {
        title: "İçindekiler",
        close: "İçindekileri kapat",
        untitled: "Başlıksız bölüm",
        empty: "İçindekiler mevcut değil",
      },
      pages: {
        title: "Sayfalar",
        count_one: "{{count}} sayfa",
        count_other: "{{count}} sayfa",
        empty: "Sayfa yok",
        thumbnailAlt: "Sayfa {{page}}",
        ariaLabel: "Sayfa küçük resimleri",
      },
      epub: {
        loading: "EPUB yükleniyor...",
        errorTitle: "EPUB yükleme hatası",
        reload: "Sayfayı yeniden yükle",
        noteIndicatorTitle: "Not {{current}} / {{total}}: {{text}}{{suffix}}",
        noteSelectedSuffix: " (Seçili metin notu)",
        noteTitleEdit: "Notu düzenle",
        noteTitleAdd: "Not ekle",
        noteCounter: "({{current}} / {{total}})",
        selectedTextLabel: "Seçili metin:",
        notePlaceholderSelected: "Seçili metin hakkında not ekleyin...",
        notePlaceholder: "Not yazın",
        noteActionSave: "Kaydet",
        noteActionCreate: "Oluştur",
        contextAddNote: "Not ekle",
        contextHighlight: "Vurgula",
        contextSearch: "Seçili kelimeyi ara",
        imageAlt: "Görsel",
        imageLightboxAria: "Büyütülmüş görsel",
        closeImagePreview: "Görsel önizlemeyi kapat",
      },
      notifications: {
        featureNotAllowed: "Bu özellik mevcut değil.",
        featureComingSoon: "Bu özellik yakında gelecek.",
        highlightsNotAvailable: "Vurgulama bu belge için mevcut değil.",
        underlinesNotAvailable: "Altı çizme bu belge için kullanılamıyor.",
        notesNotAvailable: "Notlar bu belge için mevcut değil.",
        drawingNotAvailable: "Çizim bu belge için mevcut değil.",
        bookmarksNotAvailable: "Yer imleri bu belge için mevcut değil.",
        searchNotAvailable: "Arama bu belge için mevcut değil.",
        commentsNotAvailable: "Yorumlar bu belge için mevcut değil.",
        pageOutOfRange: "Bu sayfa mevcut değil.",
        aiAssistantComingSoon: "Yapay Zekâ Asistanı yakında geliyor.",
        textBoxComingSoon: "Metin kutuları yakında geliyor.",
        textToSpeechComingSoon: "Metinden konuşma yakında geliyor.",
        sessionExpired: "Oturumunuzun süresi doldu. Yenileyin ve tekrar deneyin.",
        operationFailed: "{{operation}} işlemi yapılamadı. Lütfen tekrar deneyin.",
        copyLimitExceeded: "Kopyalama sınırı aşıldı. Yalnızca {{limit}} karakter kopyalandı.",
        copyNotAllowed: "Bu belge için kopyalama izni verilmiyor.",
        operations: {
          saveAiPreferences: "AI tercihlerini kaydet",
          copyText: "metni kopyala",
          completeAction: "bu işlemi tamamla",
          saveBookmark: "yer imini kaydet",
          deleteBookmark: "yer imini sil",
          saveNote: "notu kaydet",
          updateNote: "notu güncelle",
          deleteNote: "notu sil",
          saveHighlight: "vurgulamayı kaydet",
          updateHighlight: "vurgulamayı güncelle",
          deleteHighlight: "vurgulamayı sil",
          saveUnderline: "altı çiziliyi kaydet",
          deleteUnderline: "altı çiziliyi sil",
          saveDrawing: "çizimi kaydet",
          deleteDrawing: "çizimi sil",
          updateTextbox: "metin kutusunu güncelle",
          deleteTextbox: "metin kutusunu sil",
        },
      },
      faq: {
        open: "SSS'yi aç",
        title: "E-Reader Nasıl Kullanılır",
      },
      help: {
        close: "Yardımı kapat",
        title: "E-Reader Kullanıcı Kılavuzu",
        featuresTab: "Özellikler",
        shortcutsTab: "Klavye Kısayolları",
        gesturesTab: "Dokunmatik Hareketler",
        gestures: {
          title: "Dokunmatik Hareketler",
          tap: "Dokun",
          tapDesc: "Bir öğe seçin veya bir bağlantı açın",
          doubleTap: "Çift Dokunuş",
          doubleTapDesc: "Yakınlaştır veya uzaklaştır",
          swipeLeft: "Sola Kaydır",
          swipeLeftDesc: "Sonraki sayfaya git",
          swipeRight: "Sağa Kaydır",
          swipeRightDesc: "Önceki sayfaya git",
          swipeUpDown: "Yukarı/Aşağı Kaydır",
          swipeUpDownDesc: "Sayfa içinde kaydır",
          pinchOut: "Açma (iki parmak yayılır)",
          pinchIn: "Sıkıştırma (iki parmak kapanır)",
          longPress: "Uzun Basma",
          longPressDesc: "Metni seçin veya ek seçenekleri açın",
        },
        readingNav: "Okuma & Gezinme",
        navigation: "Sayfa Gezintisi",
        navigationDesc: "Herhangi bir sayfaya atlamak için sayfa giriş alanını veya küçük resimleri kullanın",
        zoomControls: "Yakınlaştırma Kontrolleri",
        zoomControlsDesc: "Yakınlaştırma seviyesini ayarlayın veya sayfaya/genişliğe sığdırma modunu seçin",
        search: "Arama",
        searchDesc: "Belgedeki metni bulun ve gezinin",
        displayDesc: "Okuma görünümünü ve sayfa düzeni seçeneklerini değiştirin",
        publicationDesc: "Geçerli yayına ilişkin ayrıntıları görüntüleyin",
        organization: "Organizasyon",
        bookmarks: "Yer İmleri",
        bookmarksDesc: "Hızlı erişim için önemli sayfaları kaydedin",
        notes: "Notlar",
        notesDesc: "Belirli sayfalara metin notları ekleyin",
        annotationTools: "Ek Açıklama Araçları",
        highlights: "İşaretlemeler",
        highlightsDesc: "Önemli metni vurgulayın",
        underlineDesc: "Önemli pasajları işaretlemek için metni altını çizin",
        drawing: "Çizim",
        drawingDesc: "Sayfaların üzerine doğrudan serbest çizim ek açıklamaları çizin",
        undoRedo: "Geri Al & Yinele",
        undoRedoDesc: "Ek açıklamalarınızı geri alın veya yineleyin",
        comingSoon: "Yakında",
        audioReading: "Ses Okuyucu",
        audioReadingDesc: "Metinden konuşmaya ile belge içeriğini dinleyin",
        aiAssistant: "AI Asistanı",
        aiAssistantDesc: "Akıllı öngörüler ve özetler alın",
        shortcuts: {
          navigationAccessibility: "Gezinme & Erişilebilirlik",
          browseForward: "Etkileşimli öğeler arasında ileri git",
          browseBackward: "Etkileşimli öğeler arasında geri git",
          activateButton: "Odaklanmış düğmeyi veya bağlantıyı etkinleştir",
          selectToggle: "Odaklanmış öğeyi seç veya aç/kapat",
          closeDialogs: "Açık iletişim kutularını ve menüleri kapat",
          nextPrevPage: "Sonraki veya önceki sayfa",
          jumpTop: "Belge başına atla",
          jumpBottom: "Belge sonuna atla",
          zoomViewControls: "Yakınlaştırma & Görünüm Kontrolleri",
          zoomIn: "Yakınlaştır",
          zoomOut: "Uzaklaştır",
          fitWidth: "Genişliğe sığdır",
          fitPage: "Sayfaya sığdır",
          editingAnnotations: "Düzenleme & Ek Açıklama",
          undo: "Son işlemi geri al",
          redo: "Son işlemi yinele",
          toggleHighlight: "İşaretleme modunu aç/kapat",
          drawingBrush: "Çizim fırçasını aç/kapat",
          toggleNotes: "Notlar kenar çubuğunu aç/kapat",
          toggleBookmarks: "Yer imleri kenar çubuğunu aç/kapat",
          openToc: "İçindekiler tablosunu aç",
          saveBookmark: "Yer imini kaydet",
          searchContent: "Arama & İçerik",
          searchWithin: "Belge içinde ara",
          copyText: "Seçili metni kopyala",
          selectAll: "Geçerli sayfa veya görünümdeki tüm metni seç",
        },
        translateDesc: "Seçili metni yapay zekâ ile çevirin",
      },
      loading: {
        initializing: "Başlatılıyor...",
        restoringSession: "Oturum geri yükleniyor...",
        fetchingAccessToken: "Erişim belirteci alınıyor...",
        loadingDocument: "Belge yükleniyor...",
        ariaLabel: "Yükleniyor",
        authenticating: "Kimlik doğrulanıyor...",
        finalizing: "Tamamlanıyor...",
      },
      landingPage: {
        uploadTitle: "Belge Yükle",
        uploadSubtitle: "Bir PDF veya EPUB dosyasını buraya sürükleyip bırakın veya yüklemek için tıklayın",
        supportedFormats: "Desteklenen biçimler: PDF, EPUB",
        uploadAriaLabel: "PDF veya EPUB dosyası yükle",
      },
      errors: {
        failedToLoadPdf: "PDF yüklenemedi",
        failedToLoadEpub: "EPUB yüklenemedi",
        unsupportedFileType: "Desteklenmeyen dosya türü. PDF veya EPUB yükleyin.",
        errorReadingFile: "Dosya okuma hatası.",
        searchFailed: "Arama başarısız",
        failedToRestoreSession: "Oturum geri yüklenemedi.",
        failedToInitializeReader: "Okuyucu tokenden başlatılamadı.",
      },
      readingAssistant: {
        title: "Okuma Asistanı",
        close: "Okuma Asistanını kapat",
        resize: "Okuma Asistanını yeniden boyutlandır",
        resizeHint: "Boyutlandırmak için sürükleyin. Sıfırlamak için çift tıklayın.",
        tabsLabel: "Okuma Asistanı sekmeleri",
        tabs: {
          summary: "Özet",
          askAi: "Yapay zekaya sor",
          quiz: "Quiz",
        },
        status: {
          loading: "Kontrol ediliyor…",
          processing: "Bu belge hâlâ AI için hazırlanıyor. Lütfen biraz sonra tekrar deneyin.",
          unavailable: "AI özellikleri bu belge için kullanılamıyor.",
          failed: "Belge işleme başarısız. AI özellikleri kullanılamıyor.",
          error: "AI özellikleri yüklenemedi. {{message}}",
        },
        summary: {
          typesLabel: "Özet türü",
          types: {
            quick: "Kısa özet",
            detailed: "Ayrıntılı özet",
            chapter: "Bölüm bölüm özet",
          },
          cardTitles: {
            quick: "Kısa özet",
            detailed: "Ayrıntılı özet",
            chapter: "Bölüm bölüm özet",
          },
          welcomeTitle: "Okuma Asistanı",
          welcome: "AI destekli okuma deneyimine hoş geldiniz. Hazır olduğunuzda bir özet seçeneği belirleyin.",
          loading: "Özet oluşturuluyor",
          error: "Özet oluşturulamadı. {{message}}",
          empty: "Oluşturmak için bir özet türü seçin.",
          chooseChapter: "Özetini oluşturmak için aşağıdan bir bölüm seçin.",
          chapterListLabel: "Bölümler",
          noChapters: "Bu belge için bölüm yok.",
          backToTypes: "Geri",
          regenerate: "Yeniden oluştur",
        },
        askAi: {
          placeholder: "Bu kitap hakkında herhangi bir şey sorun...",
          submit: "Soruyu gönder",
          empty: "Sohbete başlamak için bir soru sorun.",
          sending: "Düşünüyor",
          error: "Yanıt alınamadı. {{message}}",
          export: "Dışa aktar",
          newChat: "Yeni sohbet",
        },
        quiz: {
          title: "Quiz yap",
          subtitle: "Neyi test etmek istediğinizi seçin.",
          cta: "Quize başla",
          loading: "Quiz oluşturuluyor",
          error: "Quiz oluşturulamadı. {{message}}",
          modalTitle: "AI Quiz",
          disclaimer: "AI içeriği, yalnızca referans içindir.",
          close: "Quizi kapat",
          checkAnswer: "Yanıtı kontrol et",
          explanation: "Açıklama",
          previous: "Önceki",
          next: "Sonraki soru",
          finish: "Bitir",
          progress: "Soru {{current}} / {{total}}",
          answerRequired: "Devam etmek için bu soruyu yanıtlayın.",
          completedTitle: "Quiz tamamlandı!",
          yourScore: "Puanınız",
          completedMessage: "Quizi başarıyla tamamladınız.",
          reattempt: "Quizi yeniden dene",
          save: "Kaydet",
          saving: "Kaydediliyor…",
          saved: "Kaydedildi",
          saveError: "Sonuç kaydedilemedi. {{message}}",
          deleteError: "Sonuç silinemedi. {{message}}",
          deleteResult: "Kayıtlı quizi sil",
          deletedToast: "Quiz silindi",
          recentQuizzes: "Son quizler",
          seeDetails: "Ayrıntıları gör",
          showDetails: "Ayrıntıları göster",
          hideDetails: "Ayrıntıları gizle",
          correct: "Doğru",
          incorrect: "Yanlış",
          multipleChoice: "Çoktan seçmeli",
          questionStatusAria: "Soru {{number}}: {{status}}",
          backToDashboard: "Quiz paneli",
          scopeLabel: "Quiz kapsamı",
          scopeBook: "Kitaba göre",
          scopeChapter: "Bölüme göre",
          scopePage: "Sayfaya göre",
          scopePageTitle: "Sayfa {{page}}",
          scoreAria: "Puan {{correct}} / {{total}}",
          answerOptions: "Yanıt seçenekleri",
          navigationAria: "Quiz gezinmesi",
          noQuestions: "Quiz sorusu dönmedi",
          feedback: {
            greatJob: "Harika!",
            goodEffort: "İyi çaba!",
            keepPracticing: "Pratik yapmaya devam!",
          },
        },
        menu: {
          preferences: "AI tercihleri",
          citation: "AI alıntı",
          copy: "AI kopyala",
          quizzes: "AI quizleri",
          notes: "Notlar",
          prefs: {
            aiLanguage: "Tercih edilen dil",
            citationEnabled: "Alıntıları göster",
            contextInclusionEnabled: "Okuma bağlamını dahil et",
          },
        },
      },
      pullouts: {
        fallbackTitle: "Açılır içerik",
        hintLabel: "İpucu:",
        hintAvailable: "İpucu mevcut",
        expandHint: "İpucunu genişlet",
        collapseHint: "İpucunu daralt",
      },
      publicationDetails: {
        title: "Yayın ayrıntıları",
        close: "Yayın ayrıntılarını kapat",
        copy: "Yayın ayrıntılarını kopyala",
        copied: "Panoya kopyalandı",
        description: "Açıklama",
        noData: "Veri yok",
        empty: "Bu belge için yayın ayrıntısı yok.",

        fields: {
          title: "Başlık",
          author: "Yazar",
          code: "Kod",
          type: "Tür",
          language: "Dil",
          original_publisher: "Orijinal yayınevi",
          series: "Dizi",
          edition: "Baskı",
          pages: "Sayfalar",
          pisbn13: "PISBN13",
          publication_year: "Yayın yılı",
          copyright_year: "Telif yılı",
          read_direction: "Okuma yönü",
          content_type: "İçerik türü",
        },
      },
    },
  },
  zcn: {
    translation: {
      common: {
        cancel: "取消",
        close: "关闭",
        menu: "菜单",
        search: "搜索",
        bookmarks: "书签",
        notes: "笔记",
        pages: "页面",
        tableOfContents: "目录",
        page: "页",
        section: "章节",
        loading: "加载中...",
        submit: "提交",
        apply: "应用",
        remove: "移除",
        error: "错误",
        language: "语言",
        theme: "主题",
        light: "浅色",
        dark: "深色",
        on: "开启",
        off: "关闭",
        showMore: "显示更多",
        showLess: "显示更少",
        undo: "撤销",
        redo: "重做",
        underline: "下划线",
        highlight: "高亮",
        textbox: "文本框",
        document: "文档",
        back: "返回",
      },
      toolbar: {
        expand: "展开工具栏",
        collapse: "收起工具栏",
        aiAssistant: "询问 AI 助手",
        aiAssistantComingSoon: "询问 AI 助手（即将推出）",
        searchNotAllowed: "不允许搜索",
        textToSpeechComingSoon: "文字转语音（即将推出）",
        addBookmark: "添加书签",
        removeBookmark: "移除书签",
        bookmarked: "已添加书签",
        bookmarksNotAllowed: "不允许书签",
        moreOptions: "更多选项",
        display: "显示",
        lightHint: "浅色背景与深色文字",
        darkHint: "深色背景与浅色文字",
        pageView: "页面视图",
        singlePage: "单页",
        singlePageHint: "一次滚动一页",
        doublePage: "双页",
        doublePageHint: "并排查看页面",
        view: "颜色模式",
        share: "分享",
        download: "下载",
        citation: "引用",
        print: "打印",
        displayMenu: "显示菜单",
        displayMenuItems: {
          colorMode: "颜色模式",
          fontSize: "字号",
          fontFamily: "字体",
          lineHeight: "行高",
          increaseLineHeight: "增大行高",
          decreaseLineHeight: "减小行高",
          layout: "版式",
          rotate: "旋转",
          readingDirection: "阅读方向",
          rotateLeft: "向左旋转",
          rotateRight: "向右旋转",
          ltr: "从左到右",
          rtl: "从右到左",
          fonts: {
            original: "原始",
            sans: "无衬线",
            serif: "衬线",
          },
          colors: {
            light: "浅色",
            dark: "深色",
            mint: "薄荷",
            sepia: "褐色",
          },
        },
      },
      mobile: {
        searchPlaceholder: "搜索关键词...",
        cancelSearch: "取消搜索",
        faq: "常见问题",
      },
      menu: {
        close: "关闭菜单",
        documentPageCount: "第 {{current}} 页 / 共 {{total}} 页",
      },
      rightToolbar: {
        showToc: "显示目录",
        hideToc: "隐藏目录",
        showPagesThumbnails: "显示页面缩略图",
        hidePagesThumbnails: "隐藏页面缩略图",
        showBookmarks: "显示书签",
        hideBookmarks: "隐藏书签",
        info: "出版物信息",
        showPublicationDetails: "显示出版物详情",
        hidePublicationDetails: "隐藏出版物详情",
        askAi: "询问 AI",
        readingGroup: "阅读小组",
        showNotes: "显示笔记",
        hideNotes: "隐藏笔记",
        myNotebook: "我的笔记本",
        clickToEnterPage: "点击输入页码",
        currentPageLabel: "当前第 {{current}} 页，点击更改。",
        previousPage: "上一页",
        nextPage: "下一页",
        zoomOut: "缩小",
        zoomIn: "放大",
        resetZoom: "重置缩放",
        resetZoomTitle: "重置缩放到 100%",
        decreaseFontSize: "减小字体大小",
        increaseFontSize: "增加字体大小",
        resetFontSize: "重置字体大小",
        resetFontSizeTitle: "将字体大小重置为 100%",
        viewModeOptions: "视图选项",
        fitToWidth: "适合宽度",
        fitToPage: "适合页面",
        enterFullscreen: "进入全屏",
        exitFullscreen: "退出全屏",
        enterPageNumber: "输入页码",
        pageInputPlaceholder: "{{min}}-{{max}}",
        pageInputTitle: "输入页码（{{min}}-{{max}}）",
        pageInputInvalid: "请输入有效的页码",
        pageInputOutOfRange: "页码必须在 1 到 {{total}} 之间",
        showReadingAssistant: "显示阅读助手",
        hideReadingAssistant: "隐藏阅读助手",
      },
      floatingToolbar: {
        ariaLabel: "浮动工具栏",
        dragToMove: "拖动以移动",
        dragToolbar: "拖动工具栏",
        notesOn: "开启笔记",
        notesOff: "关闭笔记",
        notesNotAllowed: "不允许笔记",
        notesOnLabel: "笔记：开启",
        notesOffLabel: "笔记：关闭",
        drawingOn: "开启绘图",
        drawingOff: "关闭绘图",
        drawingNotAllowed: "不允许绘图",
        drawingOnLabel: "绘图：开启",
        drawingOffLabel: "绘图：关闭",
        textBoxComingSoon: "文本框（即将推出）",
        textboxNotAllowed: "Text box not allowed",
        textboxOn: "开启文本框",
        textboxOff: "关闭文本框",
        textboxOnLabel: "文本框：开启",
        textboxOffLabel: "文本框：关闭",
        highlightOn: "开启高亮",
        highlightOff: "关闭高亮",
        highlightsNotAllowed: "不允许高亮",
        highlightOnLabel: "高亮：开启",
        highlightOffLabel: "高亮：关闭",
        underlineOn: "开启下划线",
        underlineOff: "关闭下划线",
        underlineOnLabel: "下划线：开启",
        underlineOffLabel: "下划线：关闭",
        highlightColorLabel: "高亮颜色",
        colorRed: "红色",
        colorOrange: "橙色",
        colorYellow: "黄色",
        colorGreen: "绿色",
        colorLightBlue: "浅蓝",
        colorPurple: "紫色",
        underlinesNotAllowed: "不允许下划线",
        undo: "撤销 ({{ctrl}}+Z)",
        redo: "重做 ({{ctrl}}+Y)",
        undoCooldown: "撤销（请稍候）",
        redoCooldown: "重做（请稍候）",
      },
      contextMenu: {
        addNote: "添加笔记",
        highlight: "高亮",
        underline: "下划线",
        copy: "复制",
        removeHighlight: "删除高亮",
        removeUnderline: "删除下划线",
        searchSelected: "搜索选中的词",
        selectionToolbar: "选择菜单",
        askAi: "询问 AI",
        share: "分享",
        translate: "翻译",
        comingSoon: "即将推出",
        translationTitle: "翻译",
        translating: "正在翻译…",
        translationFailed: "翻译失败",
      },
      readerShell: {
        loadingDocument: "正在加载文档...",
        documentControls: "文档控件",
      },
      emptyState: {
        errorAlt: "错误",
        documentAlt: "文档",
        unableToLoad: "无法加载文档",
        noDocument: "未加载文档",
        requestDoc: "从你的图书馆请求文档以开始",
      },
      search: {
        ariaLabel: "搜索结果",
        searchResults: "搜索结果",
        close: "关闭搜索",
        placeholder: "在文档中搜索...",
        clear: "清除搜索",
        searching: "搜索中...",
        enterQuery: "输入搜索内容以在文档中查找文字",
        noResults: "未找到 \"{{query}}\" 的结果",
        resultsCount_one: "找到 {{count}} 条结果",
        resultsCount_other: "找到 {{count}} 条结果",
        matchCount_one: "{{count}} 个匹配",
        matchCount_other: "{{count}} 个匹配",
        navigateToResult: "点击跳转到此结果",
      },
      bookmarks: {
        title: "书签",
        close: "关闭书签",
        loading: "正在加载书签...",
        error: "加载书签出错：{{error}}",
        noItems: "暂无书签",
        navigate: "点击跳转到此书签",
        remove: "移除书签",
        removeLabel: "移除书签 {{label}}",
        navigateLabel: "转到 {{label}}",
        defaultLabel: "书签 {{page}}",
        deleteError: "删除书签失败",
      },
      notes: {
        title: "我的笔记本",
        close: "关闭我的笔记本",
        navigate: "点击跳转到此笔记",
        ariaLabel: "笔记：{{preview}} 第 {{page}} 页 {{created}}",
        createdOn: "创建于 {{date}}",
        pageTitle: "第 {{page}} 页",
        remove: "移除笔记",
        removeLabel: "从第 {{page}} 页移除笔记",
        none: "暂无笔记",
        noItems: "暂无项目",
        share: "分享笔记本",
        searchPlaceholder: "在此输入",
        clearSearch: "清除搜索",
        tabsLabel: "笔记本筛选",
        tabs: {
          all: "全部",
          highlight: "高亮",
          underline: "下划线",
          note: "笔记",
        },
        resultsFound_one: "找到 {{count}} 条结果",
        resultsFound_other: "找到 {{count}} 条结果",
        copyItem: "复制项目",
        shareItem: "分享项目",
      },
      toc: {
        title: "目录",
        close: "关闭目录",
        untitled: "未命名章节",
        empty: "没有可用目录",
        noItems: "没有可用目录",
      },
      pages: {
        title: "页面",
        count_one: "{{count}} 页",
        count_other: "{{count}} 页",
        empty: "没有可用页面",
        thumbnailAlt: "第 {{page}} 页",
        ariaLabel: "页面缩略图",
      },
      epub: {
        loading: "正在加载 EPUB...",
        errorTitle: "加载 EPUB 出错",
        reload: "重新加载页面",
        noteIndicatorTitle: "笔记 {{current}} / {{total}}：{{text}}{{suffix}}",
        noteSelectedSuffix: "（选中文本笔记）",
        noteTitleEdit: "编辑笔记",
        noteTitleAdd: "添加笔记",
        noteCounter: "（{{current}} / {{total}}）",
        selectedTextLabel: "选中文本：",
        notePlaceholderSelected: "为选中文本添加笔记...",
        notePlaceholder: "输入笔记",
        noteActionSave: "保存",
        noteActionCreate: "创建",
        contextAddNote: "添加笔记",
        contextHighlight: "高亮",
        contextSearch: "搜索所选词",
        imageAlt: "图片",
        imageLightboxAria: "放大图片",
        closeImagePreview: "关闭图片预览",
      },
      notifications: {
        featureNotAllowed: "此功能不可用。",
        featureComingSoon: "此功能即将推出。",
        highlightsNotAvailable: "此文档无法高亮。",
        underlinesNotAvailable: "此文档无法使用下划线。",
        notesNotAvailable: "此文档无法使用笔记。",
        drawingNotAvailable: "此文档无法绘图。",
        bookmarksNotAvailable: "此文档无法使用书签。",
        searchNotAvailable: "此文档无法搜索。",
        commentsNotAvailable: "此文档无法评论。",
        pageOutOfRange: "此页面不可用。",
        aiAssistantComingSoon: "AI 助手即将推出。",
        textBoxComingSoon: "文本框即将推出。",
        textToSpeechComingSoon: "文字转语音即将推出。",
        sessionExpired: "会话已过期。请刷新后重试。",
        operationFailed: "无法{{operation}}。请重试。",
        copyLimitExceeded: "超出复制限制。仅复制了 {{limit}} 个字符。",
        copyNotAllowed: "此文档不允许复制。",
        operations: {
          saveAiPreferences: "保存 AI 偏好设置",
          copyText: "复制文本",
          completeAction: "完成此操作",
          saveBookmark: "保存书签",
          deleteBookmark: "删除书签",
          saveNote: "保存笔记",
          updateNote: "更新笔记",
          deleteNote: "删除笔记",
          saveHighlight: "保存高亮",
          updateHighlight: "更新高亮",
          deleteHighlight: "删除高亮",
          saveUnderline: "保存下划线",
          deleteUnderline: "删除下划线",
          saveDrawing: "保存绘图",
          deleteDrawing: "删除绘图",
          updateTextbox: "更新文本框",
          deleteTextbox: "删除文本框",
        },
      },
      faq: {
        open: "打开常见问题",
        title: "如何使用电子阅读器",
      },
      help: {
        close: "关闭帮助",
        title: "电子阅读器用户指南",
        featuresTab: "功能",
        shortcutsTab: "键盘快捷键",
        gesturesTab: "触摸手势",
        gestures: {
          title: "触摸手势",
          tap: "轻点",
          tapDesc: "选择项目或打开链接",
          doubleTap: "双击",
          doubleTapDesc: "放大或缩小",
          swipeLeft: "向左滑动",
          swipeLeftDesc: "转到下一页",
          swipeRight: "向右滑动",
          swipeRightDesc: "转到上一页",
          swipeUpDown: "向上/向下滑动",
          swipeUpDownDesc: "滚动页面",
          pinchOut: "捏开（两指张开）",
          pinchIn: "捏合（两指靠拢）",
          longPress: "长按",
          longPressDesc: "选择文本或打开其他选项",
        },
        readingNav: "阅读和导航",
        navigation: "页面导航",
        navigationDesc: "使用页码输入字段或缩略图跳转到任何页面",
        zoomControls: "缩放控件",
        zoomControlsDesc: "调整缩放级别或选择适应宽度/页面模式",
        search: "搜索",
        searchDesc: "查找和导航文档中的文本",
        displayDesc: "更改阅读外观和页面布局选项",
        publicationDesc: "查看当前出版物的详细信息",
        organization: "组织",
        bookmarks: "书签",
        bookmarksDesc: "保存重要页面以快速访问",
        notes: "笔记",
        notesDesc: "向特定页面添加文字笔记",
        annotationTools: "注释工具",
        highlights: "亮点",
        highlightsDesc: "突出显示重要文本使其脱颖而出",
        underlineDesc: "为关键段落添加下划线",
        drawing: "绘图",
        drawingDesc: "直接在页面上绘制自由手绘注释",
        undoRedo: "撤销和重做",
        undoRedoDesc: "恢复或重做您的注释",
        comingSoon: "敬请期待",
        audioReading: "音频阅读",
        audioReadingDesc: "通过文字转语音侦听文档内容",
        aiAssistant: "人工智能助手",
        aiAssistantDesc: "获得智能见解和摘要",
        shortcuts: {
          navigationAccessibility: "导航和可访问性",
          browseForward: "在交互元素中向前浏览",
          browseBackward: "在交互元素中向后浏览",
          activateButton: "激活焦点按钮或链接",
          selectToggle: "选择或切换焦点元素",
          closeDialogs: "关闭打开的对话框和菜单",
          nextPrevPage: "下一页或上一页",
          jumpTop: "跳到文档开始",
          jumpBottom: "跳到文档末尾",
          zoomViewControls: "缩放和查看控件",
          zoomIn: "放大",
          zoomOut: "缩小",
          fitWidth: "适应宽度",
          fitPage: "适应页面",
          editingAnnotations: "编辑和注释",
          undo: "撤销上一个操作",
          redo: "重做上一个操作",
          toggleHighlight: "切换突出显示模式",
          drawingBrush: "切换绘图笔刷",
          toggleNotes: "切换笔记侧边栏",
          toggleBookmarks: "切换书签侧边栏",
          openToc: "打开目录",
          saveBookmark: "保存书签",
          searchContent: "搜索和内容",
          searchWithin: "在文档中搜索",
          copyText: "复制所选文本",
          selectAll: "选择当前页面或视图中的所有文本",
        },
        translateDesc: "使用 AI 翻译所选文本",
      },
      loading: {
        initializing: "正在初始化...",
        restoringSession: "正在恢复会话...",
        fetchingAccessToken: "正在获取访问令牌...",
        loadingDocument: "正在加载文档...",
        ariaLabel: "加载中",
        authenticating: "正在验证...",
        finalizing: "正在完成...",
      },
      errors: {
        failedToLoadPdf: "加载 PDF 失败",
        failedToLoadEpub: "加载 EPUB 失败",
        unsupportedFileType: "不支持的文件类型。请上传 PDF 或 EPUB。",
        errorReadingFile: "读取文件出错。",
        searchFailed: "搜索失败",
        failedToRestoreSession: "无法恢复会话。",
        failedToInitializeReader: "无法通过令牌初始化阅读器。",
      },
      readingAssistant: {
        title: "阅读助手",
        close: "关闭阅读助手",
        resize: "调整阅读助手大小",
        resizeHint: "拖动以调整大小。双击可重置。",
        tabsLabel: "阅读助手标签",
        tabs: {
          summary: "摘要",
          askAi: "询问 AI",
          quiz: "测验",
        },
        status: {
          loading: "正在检查…",
          processing: "文档仍在为 AI 准备中。请稍后重试。",
          unavailable: "此文档不支持 AI 功能。",
          failed: "文档处理失败。AI 功能不可用。",
          error: "无法加载 AI 功能。{{message}}",
        },
        summary: {
          typesLabel: "摘要类型",
          types: {
            quick: "快速摘要",
            detailed: "详细摘要",
            chapter: "分章摘要",
          },
          cardTitles: {
            quick: "快速摘要",
            detailed: "详细摘要",
            chapter: "分章摘要",
          },
          welcomeTitle: "阅读助手",
          welcome: "欢迎使用 AI 阅读体验。准备好后请选择下方摘要选项。",
          loading: "正在生成摘要",
          error: "无法生成摘要。{{message}}",
          empty: "选择摘要类型以生成。",
          chooseChapter: "在下方选择章节以生成摘要。",
          chapterListLabel: "章节",
          noChapters: "此文档没有可用章节。",
          backToTypes: "返回",
          regenerate: "重新生成",
        },
        askAi: {
          placeholder: "询问有关本书的任何问题...",
          submit: "发送问题",
          empty: "提出问题以开始对话。",
          sending: "思考中",
          error: "无法获取回复。{{message}}",
          export: "导出",
          newChat: "新对话",
        },
        quiz: {
          title: "参加测验",
          subtitle: "选择要测验的范围。",
          cta: "开始测验",
          loading: "正在生成测验",
          error: "无法生成测验。{{message}}",
          modalTitle: "AI 测验",
          disclaimer: "AI 生成内容，仅供参考。",
          close: "关闭测验",
          checkAnswer: "检查答案",
          explanation: "讲解",
          previous: "上一题",
          next: "下一题",
          finish: "完成",
          progress: "第 {{current}} / {{total}} 题",
          answerRequired: "请回答此题后再继续。",
          completedTitle: "测验完成！",
          yourScore: "你的得分",
          completedMessage: "你已成功完成测验。",
          reattempt: "重新测验",
          save: "保存",
          saving: "保存中…",
          saved: "已保存",
          saveError: "无法保存测验结果。{{message}}",
          deleteError: "无法删除测验结果。{{message}}",
          deleteResult: "删除已保存的测验",
          deletedToast: "测验已删除",
          recentQuizzes: "最近测验",
          seeDetails: "查看详情",
          showDetails: "显示详情",
          hideDetails: "隐藏详情",
          correct: "正确",
          incorrect: "错误",
          multipleChoice: "单选题",
          questionStatusAria: "第 {{number}} 题：{{status}}",
          backToDashboard: "测验面板",
          scopeLabel: "测验范围",
          scopeBook: "整本书",
          scopeChapter: "按章节",
          scopePage: "按页",
          scopePageTitle: "第 {{page}} 页",
          scoreAria: "得分 {{correct}} / {{total}}",
          answerOptions: "答案选项",
          navigationAria: "测验导航",
          noQuestions: "未返回测验题目",
          feedback: {
            greatJob: "做得好！",
            goodEffort: "不错的尝试！",
            keepPracticing: "继续练习！",
          },
        },
        menu: {
          preferences: "AI 偏好设置",
          citation: "AI 引用",
          copy: "AI 复制",
          quizzes: "AI 测验",
          notes: "笔记",
          prefs: {
            aiLanguage: "首选语言",
            citationEnabled: "显示引用",
            contextInclusionEnabled: "包含阅读上下文",
          },
        },
      },
      pullouts: {
        fallbackTitle: "弹出内容",
        hintLabel: "提示：",
        hintAvailable: "有可用提示",
        expandHint: "展开提示",
        collapseHint: "收起提示",
      },
      publicationDetails: {
        title: "出版物详情",
        close: "关闭出版物详情",
        copy: "复制出版物详情",
        copied: "已复制到剪贴板",
        description: "简介",
        noData: "暂无数据",
        empty: "此文档没有可用的出版物详情。",

        fields: {
          title: "标题",
          author: "作者",
          code: "编码",
          type: "类型",
          language: "语言",
          original_publisher: "原出版社",
          series: "丛书",
          edition: "版本",
          pages: "页数",
          pisbn13: "PISBN13",
          publication_year: "出版年份",
          copyright_year: "版权年份",
          read_direction: "阅读方向",
          content_type: "内容类型",
        },
      },
    },
  },
  ztw: {
    translation: {
      common: {
        cancel: "取消",
        close: "關閉",
        menu: "選單",
        search: "搜尋",
        bookmarks: "書籤",
        notes: "筆記",
        pages: "頁面",
        tableOfContents: "目錄",
        page: "頁",
        section: "章節",
        loading: "載入中...",
        submit: "提交",
        apply: "套用",
        remove: "移除",
        error: "錯誤",
        language: "語言",
        theme: "主題",
        light: "淺色",
        dark: "深色",
        on: "開啟",
        off: "關閉",
        showMore: "顯示更多",
        showLess: "顯示更少",
        undo: "復原",
        redo: "重做",
        underline: "底線",
        highlight: "標註",
        textbox: "文字方塊",
        document: "文件",
        back: "返回",
      },
      toolbar: {
        expand: "展開工具列",
        collapse: "收合工具列",
        aiAssistant: "詢問 AI 助手",
        aiAssistantComingSoon: "詢問 AI 助手（即將推出）",
        searchNotAllowed: "不允許搜尋",
        textToSpeechComingSoon: "文字轉語音（即將推出）",
        addBookmark: "新增書籤",
        removeBookmark: "移除書籤",
        bookmarked: "已加入書籤",
        bookmarksNotAllowed: "不允許書籤",
        moreOptions: "更多選項",
        display: "顯示",
        lightHint: "淺色背景與深色文字",
        darkHint: "深色背景與淺色文字",
        pageView: "頁面檢視",
        singlePage: "單頁",
        singlePageHint: "一次捲動一頁",
        doublePage: "雙頁",
        doublePageHint: "並排查看頁面",
        view: "顏色模式",
        share: "分享",
        download: "下載",
        citation: "引用",
        print: "列印",
        displayMenu: "顯示選單",
        displayMenuItems: {
          colorMode: "色彩模式",
          fontSize: "字級",
          fontFamily: "字型",
          lineHeight: "行高",
          increaseLineHeight: "增加行高",
          decreaseLineHeight: "減少行高",
          layout: "版面",
          rotate: "旋轉",
          readingDirection: "閱讀方向",
          rotateLeft: "向左旋轉",
          rotateRight: "向右旋轉",
          ltr: "由左至右",
          rtl: "由右至左",
          fonts: {
            original: "原始",
            sans: "無襯線",
            serif: "襯線",
          },
          colors: {
            light: "淺色",
            dark: "深色",
            mint: "薄荷",
            sepia: "褐色",
          },
        },
      },
      mobile: {
        searchPlaceholder: "搜尋關鍵字...",
        cancelSearch: "取消搜尋",
        faq: "常見問題",
      },
      menu: {
        close: "關閉選單",
        documentPageCount: "第 {{current}} 頁 / 共 {{total}} 頁",
      },
      rightToolbar: {
        showToc: "顯示目錄",
        hideToc: "隱藏目錄",
        showPagesThumbnails: "顯示頁面縮圖",
        hidePagesThumbnails: "隱藏頁面縮圖",
        showBookmarks: "顯示書籤",
        hideBookmarks: "隱藏書籤",
        info: "出版物資訊",
        showPublicationDetails: "顯示出版物詳情",
        hidePublicationDetails: "隱藏出版物詳情",
        askAi: "詢問 AI",
        readingGroup: "閱讀小組",
        showNotes: "顯示筆記",
        hideNotes: "隱藏筆記",
        myNotebook: "我的筆記本",
        clickToEnterPage: "點擊輸入頁碼",
        currentPageLabel: "目前第 {{current}} 頁，點擊更改。",
        previousPage: "上一頁",
        nextPage: "下一頁",
        zoomOut: "縮小",
        zoomIn: "放大",
        resetZoom: "重設縮放",
        resetZoomTitle: "重設縮放到 100%",
        decreaseFontSize: "減小字體大小",
        increaseFontSize: "增加字體大小",
        resetFontSize: "重置字體大小",
        resetFontSizeTitle: "將字體大小重置為 100%",
        viewModeOptions: "檢視選項",
        fitToWidth: "符合寬度",
        fitToPage: "符合頁面",
        enterFullscreen: "進入全螢幕",
        exitFullscreen: "退出全螢幕",
        enterPageNumber: "輸入頁碼",
        pageInputPlaceholder: "{{min}}-{{max}}",
        pageInputTitle: "輸入頁碼（{{min}}-{{max}}）",
        pageInputInvalid: "請輸入有效的頁碼",
        pageInputOutOfRange: "頁碼必須介於 1 到 {{total}}",
        showReadingAssistant: "顯示閱讀助手",
        hideReadingAssistant: "隱藏閱讀助手",
      },
      floatingToolbar: {
        ariaLabel: "浮動工具列",
        dragToMove: "拖曳以移動",
        dragToolbar: "拖曳工具列",
        notesOn: "開啟筆記",
        notesOff: "關閉筆記",
        notesNotAllowed: "不允許筆記",
        notesOnLabel: "筆記：開啟",
        notesOffLabel: "筆記：關閉",
        drawingOn: "開啟繪圖",
        drawingOff: "關閉繪圖",
        drawingNotAllowed: "不允許繪圖",
        drawingOnLabel: "繪圖：開啟",
        drawingOffLabel: "繪圖：關閉",
        textBoxComingSoon: "文字方塊（即將推出）",
        textboxNotAllowed: "Text box not allowed",
        textboxOn: "開啟文字方塊",
        textboxOff: "關閉文字方塊",
        textboxOnLabel: "文字方塊：開啟",
        textboxOffLabel: "文字方塊：關閉",
        highlightOn: "開啟標註",
        highlightOff: "關閉標註",
        highlightsNotAllowed: "不允許標註",
        highlightOnLabel: "標註：開啟",
        highlightOffLabel: "標註：關閉",
        underlineOn: "開啟底線",
        underlineOff: "關閉底線",
        underlineOnLabel: "底線：開啟",
        underlineOffLabel: "底線：關閉",
        highlightColorLabel: "標註顏色",
        colorRed: "紅色",
        colorOrange: "橘色",
        colorYellow: "黃色",
        colorGreen: "綠色",
        colorLightBlue: "淺藍",
        colorPurple: "紫色",
        underlinesNotAllowed: "不允許底線",
        undo: "復原 ({{ctrl}}+Z)",
        redo: "重做 ({{ctrl}}+Y)",
        undoCooldown: "復原（請稍候）",
        redoCooldown: "重做（請稍候）",
      },
      contextMenu: {
        addNote: "新增筆記",
        highlight: "標註",
        underline: "底線",
        copy: "複製",
        removeHighlight: "移除標註",
        removeUnderline: "移除底線",
        searchSelected: "搜尋選取的詞",
        selectionToolbar: "選取選單",
        askAi: "詢問 AI",
        share: "分享",
        translate: "翻譯",
        comingSoon: "即將推出",
        translationTitle: "翻譯",
        translating: "正在翻譯…",
        translationFailed: "翻譯失敗",
      },
      readerShell: {
        loadingDocument: "正在載入文件...",
        documentControls: "文件控制",
      },
      emptyState: {
        errorAlt: "錯誤",
        documentAlt: "文件",
        unableToLoad: "無法載入文件",
        noDocument: "未載入文件",
        requestDoc: "從您的圖書館請求文件以開始",
      },
      search: {
        ariaLabel: "搜尋結果",
        searchResults: "搜尋結果",
        close: "關閉搜尋",
        placeholder: "在文件中搜尋...",
        clear: "清除搜尋",
        searching: "搜尋中...",
        enterQuery: "輸入搜尋內容以在文件中查找文字",
        noResults: "找不到 \"{{query}}\" 的結果",
        resultsCount_one: "找到 {{count}} 筆結果",
        resultsCount_other: "找到 {{count}} 筆結果",
        matchCount_one: "{{count}} 筆符合",
        matchCount_other: "{{count}} 筆符合",
        navigateToResult: "點擊前往此結果",
      },
      bookmarks: {
        title: "書籤",
        close: "關閉書籤",
        loading: "正在載入書籤...",
        error: "載入書籤錯誤：{{error}}",
        noItems: "尚無書籤",
        navigate: "點擊前往此書籤",
        remove: "移除書籤",
        removeLabel: "移除書籤 {{label}}",
        navigateLabel: "前往 {{label}}",
        defaultLabel: "書籤 {{page}}",
        deleteError: "刪除書籤失敗",
      },
      notes: {
        title: "我的筆記本",
        close: "關閉我的筆記本",
        navigate: "點擊前往此筆記",
        ariaLabel: "筆記：{{preview}} 第 {{page}} 頁 {{created}}",
        createdOn: "建立於 {{date}}",
        pageTitle: "第 {{page}} 頁",
        remove: "移除筆記",
        removeLabel: "從第 {{page}} 頁移除筆記",
        none: "尚無筆記",
        noItems: "尚無項目",
        share: "分享筆記本",
        searchPlaceholder: "在此輸入",
        clearSearch: "清除搜尋",
        tabsLabel: "筆記本篩選",
        tabs: {
          all: "全部",
          highlight: "醒目提示",
          underline: "底線",
          note: "筆記",
        },
        resultsFound_one: "找到 {{count}} 筆結果",
        resultsFound_other: "找到 {{count}} 筆結果",
        copyItem: "複製項目",
        shareItem: "分享項目",
      },
      toc: {
        title: "目錄",
        close: "關閉目錄",
        untitled: "未命名章節",
        empty: "沒有可用目錄",
        noItems: "沒有可用目錄",
      },
      pages: {
        title: "頁面",
        count_one: "{{count}} 頁",
        count_other: "{{count}} 頁",
        empty: "沒有可用頁面",
        thumbnailAlt: "第 {{page}} 頁",
        ariaLabel: "頁面縮圖",
      },
      epub: {
        loading: "正在載入 EPUB...",
        errorTitle: "載入 EPUB 錯誤",
        reload: "重新載入頁面",
        noteIndicatorTitle: "筆記 {{current}} / {{total}}：{{text}}{{suffix}}",
        noteSelectedSuffix: "（選中文本筆記）",
        noteTitleEdit: "編輯筆記",
        noteTitleAdd: "新增筆記",
        noteCounter: "（{{current}} / {{total}}）",
        selectedTextLabel: "選中文本：",
        notePlaceholderSelected: "為選中文本新增筆記...",
        notePlaceholder: "輸入筆記",
        noteActionSave: "儲存",
        noteActionCreate: "建立",
        contextAddNote: "新增筆記",
        contextHighlight: "標註",
        contextSearch: "搜尋所選詞",
        imageAlt: "圖片",
        imageLightboxAria: "放大圖片",
        closeImagePreview: "關閉圖片預覽",
      },
      notifications: {
        featureNotAllowed: "此功能不可用。",
        featureComingSoon: "此功能即將推出。",
        highlightsNotAvailable: "此文件無法標註。",
        underlinesNotAvailable: "此文件無法使用底線。",
        notesNotAvailable: "此文件無法使用筆記。",
        drawingNotAvailable: "此文件無法繪圖。",
        bookmarksNotAvailable: "此文件無法使用書籤。",
        searchNotAvailable: "此文件無法搜尋。",
        commentsNotAvailable: "此文件無法評論。",
        pageOutOfRange: "此頁面不可用。",
        aiAssistantComingSoon: "AI 助手即將推出。",
        textBoxComingSoon: "文字方塊即將推出。",
        textToSpeechComingSoon: "文字轉語音即將推出。",
        sessionExpired: "工作階段已過期。請重新整理後再試。",
        operationFailed: "無法{{operation}}。請重試。",
        copyLimitExceeded: "超出複製限制。僅複製了 {{limit}} 個字元。",
        copyNotAllowed: "此文件不允許複製。",
        operations: {
          saveAiPreferences: "儲存 AI 偏好設定",
          copyText: "複製文字",
          completeAction: "完成此操作",
          saveBookmark: "儲存書籤",
          deleteBookmark: "刪除書籤",
          saveNote: "儲存筆記",
          updateNote: "更新筆記",
          deleteNote: "刪除筆記",
          saveHighlight: "儲存醒目提示",
          updateHighlight: "更新醒目提示",
          deleteHighlight: "刪除醒目提示",
          saveUnderline: "儲存底線",
          deleteUnderline: "刪除底線",
          saveDrawing: "儲存繪圖",
          deleteDrawing: "刪除繪圖",
          updateTextbox: "更新文字方塊",
          deleteTextbox: "刪除文字方塊",
        },
      },
      faq: {
        open: "開啟常見問題",
        title: "如何使用電子閱讀器",
      },
      help: {
        close: "關閉說明",
        title: "電子閱讀器使用者指南",
        featuresTab: "功能",
        shortcutsTab: "鍵盤快捷方式",
        gesturesTab: "觸控手勢",
        gestures: {
          title: "觸控手勢",
          tap: "輕觸",
          tapDesc: "選取項目或開啟連結",
          doubleTap: "雙擊",
          doubleTapDesc: "放大或縮小",
          swipeLeft: "向左滑動",
          swipeLeftDesc: "前往下一頁",
          swipeRight: "向右滑動",
          swipeRightDesc: "前往上一頁",
          swipeUpDown: "向上/向下滑動",
          swipeUpDownDesc: "捲動頁面",
          pinchOut: "捏開（兩指張開）",
          pinchIn: "捏合（兩指靠攏）",
          longPress: "長按",
          longPressDesc: "選取文字或開啟其他選項",
        },
        readingNav: "閱讀和導覽",
        navigation: "頁面導覽",
        navigationDesc: "使用頁碼輸入欄位或縮圖跳至任何頁面",
        zoomControls: "縮放控制項",
        zoomControlsDesc: "調整縮放級別或選擇適應寬度/頁面模式",
        search: "搜尋",
        searchDesc: "在文件中尋找並導覽文字",
        displayDesc: "變更閱讀外觀與頁面版面選項",
        publicationDesc: "檢視目前出版物的詳細資訊",
        organization: "組織",
        bookmarks: "書籤",
        bookmarksDesc: "保存重要頁面以便快速存取",
        notes: "筆記",
        notesDesc: "向特定頁面新增文字筆記",
        annotationTools: "註解工具",
        highlights: "醒目提示",
        highlightsDesc: "醒目提示重要文字使其脫穎而出",
        underlineDesc: "為關鍵段落加上底線",
        drawing: "繪圖",
        drawingDesc: "直接在頁面上繪製手繪註解",
        undoRedo: "復原和重做",
        undoRedoDesc: "復原或重做您的註解",
        comingSoon: "即將推出",
        audioReading: "音訊閱讀",
        audioReadingDesc: "透過文字轉語音聆聽文件內容",
        aiAssistant: "AI 助理",
        aiAssistantDesc: "取得智慧見解和摘要",
        shortcuts: {
          navigationAccessibility: "導覽和協助工具",
          browseForward: "透過互動元素向前瀏覽",
          browseBackward: "透過互動元素向後瀏覽",
          activateButton: "啟動焦點按鈕或連結",
          selectToggle: "選取或切換焦點元素",
          closeDialogs: "關閉開啟的對話方塊和功能表",
          nextPrevPage: "下一頁或上一頁",
          jumpTop: "跳至文件開頭",
          jumpBottom: "跳至文件結尾",
          zoomViewControls: "縮放和檢視控制項",
          zoomIn: "放大",
          zoomOut: "縮小",
          fitWidth: "適應寬度",
          fitPage: "適應頁面",
          editingAnnotations: "編輯和註解",
          undo: "復原上一個動作",
          redo: "重做上一個動作",
          toggleHighlight: "切換醒目提示模式",
          drawingBrush: "切換繪圖筆刷",
          toggleNotes: "切換筆記側邊欄",
          toggleBookmarks: "切換書籤側邊欄",
          openToc: "開啟目錄",
          saveBookmark: "保存書籤",
          searchContent: "搜尋和內容",
          searchWithin: "在文件中搜尋",
          copyText: "複製所選文字",
          selectAll: "選取目前頁面或檢視中的所有文字",
        },
        translateDesc: "使用 AI 翻譯所選文字",
      },
      loading: {
        initializing: "正在初始化...",
        restoringSession: "正在恢復工作階段...",
        fetchingAccessToken: "正在取得存取權杖...",
        loadingDocument: "正在載入文件...",
        ariaLabel: "載入中",
        authenticating: "正在驗證...",
        finalizing: "正在完成...",
      },
      errors: {
        failedToLoadPdf: "PDF 載入失敗",
        failedToLoadEpub: "EPUB 載入失敗",
        unsupportedFileType: "不支援的檔案類型。請上傳 PDF 或 EPUB。",
        errorReadingFile: "讀取檔案錯誤。",
        searchFailed: "搜尋失敗",
        failedToRestoreSession: "無法還原工作階段。",
        failedToInitializeReader: "無法透過權杖初始化閱讀器。",
      },
      readingAssistant: {
        title: "閱讀助手",
        close: "關閉閱讀助手",
        resize: "調整閱讀助手大小",
        resizeHint: "拖曳以調整大小。按兩下可重設。",
        tabsLabel: "閱讀助手分頁",
        tabs: {
          summary: "摘要",
          askAi: "詢問 AI",
          quiz: "測驗",
        },
        status: {
          loading: "正在檢查…",
          processing: "文件仍在為 AI 準備中。請稍後再試。",
          unavailable: "此文件不支援 AI 功能。",
          failed: "文件處理失敗。AI 功能無法使用。",
          error: "無法載入 AI 功能。{{message}}",
        },
        summary: {
          typesLabel: "摘要類型",
          types: {
            quick: "快速摘要",
            detailed: "詳細摘要",
            chapter: "分章摘要",
          },
          cardTitles: {
            quick: "快速摘要",
            detailed: "詳細摘要",
            chapter: "分章摘要",
          },
          welcomeTitle: "閱讀助手",
          welcome: "歡迎使用 AI 閱讀體驗。準備好後請選擇下方摘要選項。",
          loading: "正在產生摘要",
          error: "無法產生摘要。{{message}}",
          empty: "選擇摘要類型以產生。",
          chooseChapter: "在下方選擇章節以產生摘要。",
          chapterListLabel: "章節",
          noChapters: "此文件沒有可用章節。",
          backToTypes: "返回",
          regenerate: "重新產生",
        },
        askAi: {
          placeholder: "詢問有關本書的任何問題...",
          submit: "傳送問題",
          empty: "提出問題以開始對話。",
          sending: "思考中",
          error: "無法取得回覆。{{message}}",
          export: "匯出",
          newChat: "新對話",
        },
        quiz: {
          title: "參加測驗",
          subtitle: "選擇要測驗的範圍。",
          cta: "開始測驗",
          loading: "正在產生測驗",
          error: "無法產生測驗。{{message}}",
          modalTitle: "AI 測驗",
          disclaimer: "AI 產生內容，僅供參考。",
          close: "關閉測驗",
          checkAnswer: "檢查答案",
          explanation: "說明",
          previous: "上一題",
          next: "下一題",
          finish: "完成",
          progress: "第 {{current}} / {{total}} 題",
          answerRequired: "請回答此題後再繼續。",
          completedTitle: "測驗完成！",
          yourScore: "你的得分",
          completedMessage: "你已成功完成測驗。",
          reattempt: "重新測驗",
          save: "儲存",
          saving: "儲存中…",
          saved: "已儲存",
          saveError: "無法儲存測驗結果。{{message}}",
          deleteError: "無法刪除測驗結果。{{message}}",
          deleteResult: "刪除已儲存的測驗",
          deletedToast: "測驗已刪除",
          recentQuizzes: "最近測驗",
          seeDetails: "查看詳情",
          showDetails: "顯示詳情",
          hideDetails: "隱藏詳情",
          correct: "正確",
          incorrect: "錯誤",
          multipleChoice: "單選題",
          questionStatusAria: "第 {{number}} 題：{{status}}",
          backToDashboard: "測驗面板",
          scopeLabel: "測驗範圍",
          scopeBook: "整本書",
          scopeChapter: "依章節",
          scopePage: "依頁",
          scopePageTitle: "第 {{page}} 頁",
          scoreAria: "得分 {{correct}} / {{total}}",
          answerOptions: "答案選項",
          navigationAria: "測驗導覽",
          noQuestions: "未傳回測驗題目",
          feedback: {
            greatJob: "做得好！",
            goodEffort: "不錯的嘗試！",
            keepPracticing: "繼續練習！",
          },
        },
        menu: {
          preferences: "AI 偏好設定",
          citation: "AI 引用",
          copy: "AI 複製",
          quizzes: "AI 測驗",
          notes: "筆記",
          prefs: {
            aiLanguage: "偏好語言",
            citationEnabled: "顯示引用",
            contextInclusionEnabled: "包含閱讀脈絡",
          },
        },
      },
      pullouts: {
        fallbackTitle: "彈出內容",
        hintLabel: "提示：",
        hintAvailable: "有可用提示",
        expandHint: "展開提示",
        collapseHint: "收合提示",
      },
      publicationDetails: {
        title: "出版物詳情",
        close: "關閉出版物詳情",
        copy: "複製出版物詳情",
        copied: "已複製到剪貼簿",
        description: "簡介",
        noData: "暫無資料",
        empty: "此文件沒有可用的出版物詳情。",

        fields: {
          title: "標題",
          author: "作者",
          code: "編碼",
          type: "類型",
          language: "語言",
          original_publisher: "原出版社",
          series: "叢書",
          edition: "版本",
          pages: "頁數",
          pisbn13: "PISBN13",
          publication_year: "出版年份",
          copyright_year: "版權年份",
          read_direction: "閱讀方向",
          content_type: "內容類型",
        },
      },
    },
  },
  ja: {
    translation: {
      common: {
        cancel: "キャンセル",
        close: "閉じる",
        menu: "メニュー",
        search: "検索",
        bookmarks: "ブックマーク",
        notes: "ノート",
        pages: "ページ",
        tableOfContents: "目次",
        page: "ページ",
        section: "セクション",
        loading: "読み込み中...",
        submit: "送信",
        apply: "適用",
        remove: "削除",
        error: "エラー",
        language: "言語",
        theme: "テーマ",
        light: "ライト",
        dark: "ダーク",
        on: "オン",
        off: "オフ",
        showMore: "もっと表示",
        showLess: "表示を減らす",
        undo: "元に戻す",
        redo: "やり直し",
        underline: "下線",
        highlight: "ハイライト",
        textbox: "テキストボックス",
        document: "ドキュメント",
        back: "戻る",
      },
      toolbar: {
        expand: "ツールバーを展開",
        collapse: "ツールバーを折りたたむ",
        aiAssistant: "AIアシスタントに質問",
        aiAssistantComingSoon: "AIアシスタントに質問（近日公開）",
        searchNotAllowed: "検索は利用できません",
        textToSpeechComingSoon: "テキスト読み上げ（近日公開）",
        addBookmark: "ブックマークを追加",
        removeBookmark: "ブックマークを削除",
        bookmarked: "ブックマーク済み",
        bookmarksNotAllowed: "ブックマークは利用できません",
        moreOptions: "その他のオプション",
        display: "表示",
        lightHint: "明るい背景に暗い文字",
        darkHint: "暗い背景に明るい文字",
        pageView: "ページ表示",
        singlePage: "単ページ",
        singlePageHint: "1ページずつスクロール",
        doublePage: "見開き",
        doublePageHint: "ページを並べて表示",
        view: "カラーモード",
        share: "共有",
        download: "ダウンロード",
        citation: "引用",
        print: "印刷",
        displayMenu: "表示メニュー",
        displayMenuItems: {
          colorMode: "カラーモード",
          fontSize: "文字サイズ",
          fontFamily: "フォント",
          lineHeight: "行間",
          increaseLineHeight: "行間を広げる",
          decreaseLineHeight: "行間を狭める",
          layout: "レイアウト",
          rotate: "回転",
          readingDirection: "読み方向",
          rotateLeft: "左に回転",
          rotateRight: "右に回転",
          ltr: "左から右",
          rtl: "右から左",
          fonts: {
            original: "オリジナル",
            sans: "ゴシック",
            serif: "明朝",
          },
          colors: {
            light: "ライト",
            dark: "ダーク",
            mint: "ミント",
            sepia: "セピア",
          },
        },
      },
      mobile: {
        searchPlaceholder: "キーワード検索...",
        cancelSearch: "検索をキャンセル",
        faq: "FAQ",
      },
      menu: {
        close: "メニューを閉じる",
        documentPageCount: "ページ {{current}} / {{total}}",
      },
      rightToolbar: {
        showToc: "目次を表示",
        hideToc: "目次を非表示",
        showPagesThumbnails: "ページサムネイルを表示",
        hidePagesThumbnails: "ページサムネイルを非表示",
        showBookmarks: "ブックマークを表示",
        hideBookmarks: "ブックマークを非表示",
        info: "出版物情報",
        showPublicationDetails: "出版物の詳細を表示",
        hidePublicationDetails: "出版物の詳細を非表示",
        askAi: "AIに質問",
        readingGroup: "読書グループ",
        showNotes: "ノートを表示",
        hideNotes: "ノートを非表示",
        myNotebook: "マイノートブック",
        clickToEnterPage: "クリックしてページ番号を入力",
        currentPageLabel: "現在のページ {{current}}。クリックして変更。",
        previousPage: "前のページ",
        nextPage: "次のページ",
        zoomOut: "縮小",
        zoomIn: "拡大",
        resetZoom: "ズームをリセット",
        resetZoomTitle: "ズームを100%にリセット",
        decreaseFontSize: "フォントサイズを減らす",
        increaseFontSize: "フォントサイズを増やす",
        resetFontSize: "フォントサイズをリセット",
        resetFontSizeTitle: "フォントサイズを 100% にリセット",
        viewModeOptions: "表示オプション",
        fitToWidth: "幅に合わせる",
        fitToPage: "ページに合わせる",
        enterFullscreen: "全画面表示",
        exitFullscreen: "全画面表示を終了",
        enterPageNumber: "ページ番号を入力",
        pageInputPlaceholder: "{{min}}-{{max}}",
        pageInputTitle: "ページ番号を入力 ({{min}}-{{max}})",
        pageInputInvalid: "有効なページ番号を入力してください",
        pageInputOutOfRange: "ページは1〜{{total}}の範囲です",
        showReadingAssistant: "リーディングアシスタントを表示",
        hideReadingAssistant: "リーディングアシスタントを非表示",
      },
      floatingToolbar: {
        ariaLabel: "フローティングツールバー",
        dragToMove: "ドラッグして移動",
        dragToolbar: "ツールバーをドラッグ",
        notesOn: "ノートをオン",
        notesOff: "ノートをオフ",
        notesNotAllowed: "ノートは利用できません",
        notesOnLabel: "ノート: オン",
        notesOffLabel: "ノート: オフ",
        drawingOn: "描画をオン",
        drawingOff: "描画をオフ",
        drawingNotAllowed: "描画は利用できません",
        drawingOnLabel: "描画: オン",
        drawingOffLabel: "描画: オフ",
        textBoxComingSoon: "テキストボックス（近日公開）",
        textboxNotAllowed: "Text box not allowed",
        textboxOn: "テキストボックスをオン",
        textboxOff: "テキストボックスをオフ",
        textboxOnLabel: "テキストボックス: オン",
        textboxOffLabel: "テキストボックス: オフ",
        highlightOn: "ハイライトをオン",
        highlightOff: "ハイライトをオフ",
        highlightsNotAllowed: "ハイライトは利用できません",
        highlightOnLabel: "ハイライト: オン",
        highlightOffLabel: "ハイライト: オフ",
        underlineOn: "下線をオン",
        underlineOff: "下線をオフ",
        underlineOnLabel: "下線: オン",
        underlineOffLabel: "下線: オフ",
        highlightColorLabel: "ハイライトの色",
        colorRed: "赤",
        colorOrange: "オレンジ",
        colorYellow: "黄色",
        colorGreen: "緑",
        colorLightBlue: "水色",
        colorPurple: "紫",
        underlinesNotAllowed: "下線は利用できません",
        undo: "元に戻す ({{ctrl}}+Z)",
        redo: "やり直し ({{ctrl}}+Y)",
        undoCooldown: "元に戻す（お待ちください）",
        redoCooldown: "やり直す（お待ちください）",
      },
      contextMenu: {
        addNote: "メモを追加",
        highlight: "ハイライト",
        underline: "下線",
        copy: "コピー",
        removeHighlight: "ハイライトを削除",
        removeUnderline: "下線を削除",
        searchSelected: "選択した語を検索",
        selectionToolbar: "選択メニュー",
        askAi: "AIに質問",
        share: "共有",
        translate: "翻訳",
        comingSoon: "近日公開",
        translationTitle: "翻訳",
        translating: "翻訳中…",
        translationFailed: "翻訳に失敗しました",
      },
      readerShell: {
        loadingDocument: "ドキュメントを読み込み中...",
        documentControls: "ドキュメント制御",
      },
      emptyState: {
        errorAlt: "エラー",
        documentAlt: "ドキュメント",
        unableToLoad: "ドキュメントを読み込めません",
        noDocument: "ドキュメントが読み込まれていません",
        requestDoc: "開始するにはライブラリからドキュメントをリクエストしてください",
      },
      search: {
        ariaLabel: "検索結果",
        searchResults: "検索結果",
        close: "検索を閉じる",
        placeholder: "ドキュメント内を検索...",
        clear: "検索をクリア",
        searching: "検索中...",
        enterQuery: "ドキュメント内のテキストを検索する語句を入力",
        noResults: "\"{{query}}\" の結果が見つかりません",
        resultsCount_one: "{{count}} 件の結果",
        resultsCount_other: "{{count}} 件の結果",
        matchCount_one: "{{count}} 件の一致",
        matchCount_other: "{{count}} 件の一致",
        navigateToResult: "この結果に移動するにはクリック",
      },
      bookmarks: {
        title: "ブックマーク",
        close: "ブックマークを閉じる",
        loading: "ブックマークを読み込み中...",
        error: "ブックマークの読み込みエラー: {{error}}",
        noItems: "ブックマークはまだありません",
        navigate: "このブックマークに移動するにはクリック",
        remove: "ブックマークを削除",
        removeLabel: "ブックマーク {{label}} を削除",
        navigateLabel: "{{label}} に移動",
        defaultLabel: "ブックマーク {{page}}",
        deleteError: "ブックマークの削除に失敗しました",
      },
      notes: {
        title: "マイノートブック",
        close: "マイノートブックを閉じる",
        navigate: "このノートに移動するにはクリック",
        ariaLabel: "ノート: {{preview}} ページ {{page}} {{created}}",
        createdOn: "{{date}} に作成",
        pageTitle: "ページ {{page}}",
        remove: "ノートを削除",
        removeLabel: "ページ {{page}} のノートを削除",
        none: "ノートはまだありません",
        share: "ノートブックを共有",
        searchPlaceholder: "ここに入力",
        clearSearch: "検索をクリア",
        tabsLabel: "ノートブックのフィルター",
        tabs: {
          all: "すべて",
          highlight: "ハイライト",
          underline: "下線",
          note: "ノート",
        },
        resultsFound_one: "{{count}} 件の結果",
        resultsFound_other: "{{count}} 件の結果",
        copyItem: "項目をコピー",
        shareItem: "項目を共有",
        noItems: "項目はまだありません",
      },
      toc: {
        title: "目次",
        close: "目次を閉じる",
        untitled: "無題のセクション",
        empty: "目次がありません",
        noItems: "目次がありません",
      },
      pages: {
        title: "ページ",
        count_one: "{{count}} ページ",
        count_other: "{{count}} ページ",
        empty: "ページがありません",
        thumbnailAlt: "ページ {{page}}",
        ariaLabel: "ページサムネイル",
      },
      epub: {
        loading: "EPUB を読み込み中...",
        errorTitle: "EPUB の読み込みエラー",
        reload: "ページを再読み込み",
        noteIndicatorTitle: "ノート {{current}} / {{total}}: {{text}}{{suffix}}",
        noteSelectedSuffix: "（選択テキストのノート）",
        noteTitleEdit: "ノートを編集",
        noteTitleAdd: "ノートを追加",
        noteCounter: "（{{current}} / {{total}}）",
        selectedTextLabel: "選択テキスト:",
        notePlaceholderSelected: "選択テキストについてのノートを追加...",
        notePlaceholder: "ノートを入力",
        noteActionSave: "保存",
        noteActionCreate: "作成",
        contextAddNote: "ノートを追加",
        contextHighlight: "ハイライト",
        contextSearch: "選択した単語を検索",
        imageAlt: "画像",
        imageLightboxAria: "拡大画像",
        closeImagePreview: "画像プレビューを閉じる",
      },
      notifications: {
        featureNotAllowed: "この機能は利用できません。",
        featureComingSoon: "この機能はもうすぐ来ます。",
        highlightsNotAvailable: "このドキュメントではハイライトできません。",
        underlinesNotAvailable: "このドキュメントでは下線を引くことはできません。",
        notesNotAvailable: "このドキュメントではノートが利用できません。",
        drawingNotAvailable: "このドキュメントでは描画できません。",
        bookmarksNotAvailable: "このドキュメントではブックマークが利用できません。",
        searchNotAvailable: "このドキュメントでは検索できません。",
        commentsNotAvailable: "このドキュメントではコメントできません。",
        pageOutOfRange: "このページは利用できません。",
        aiAssistantComingSoon: "AI アシスタントは近日公開です。",
        textBoxComingSoon: "テキストボックスは近日公開です。",
        textToSpeechComingSoon: "読み上げは近日公開です。",
        sessionExpired: "セッションの有効期限が切れました。更新して再試行してください。",
        operationFailed: "{{operation}}できませんでした。もう一度お試しください。",
        copyLimitExceeded: "コピーの上限を超えました。{{limit}} 文字のみコピーされました。",
        copyNotAllowed: "この文書ではコピーが許可されていません。",
        operations: {
          saveAiPreferences: "AI設定の保存",
          copyText: "テキストのコピー",
          completeAction: "この操作を完了",
          saveBookmark: "ブックマークの保存",
          deleteBookmark: "ブックマークの削除",
          saveNote: "ノートの保存",
          updateNote: "ノートの更新",
          deleteNote: "ノートの削除",
          saveHighlight: "ハイライトの保存",
          updateHighlight: "ハイライトの更新",
          deleteHighlight: "ハイライトの削除",
          saveUnderline: "下線の保存",
          deleteUnderline: "下線の削除",
          saveDrawing: "描画の保存",
          deleteDrawing: "描画の削除",
          updateTextbox: "テキストボックスの更新",
          deleteTextbox: "テキストボックスの削除",
        },
      },
      faq: {
        open: "FAQ を開く",
        title: "E-Reader の使い方",
      },
      help: {
        close: "ヘルプを閉じる",
        title: "E-Reader ユーザーガイド",
        featuresTab: "機能",
        shortcutsTab: "キーボードショートカット",
        gesturesTab: "タッチジェスチャー",
        gestures: {
          title: "タッチジェスチャー",
          tap: "タップ",
          tapDesc: "項目を選択するかリンクを開きます",
          doubleTap: "ダブルタップ",
          doubleTapDesc: "ズームインまたはズームアウト",
          swipeLeft: "左にスワイプ",
          swipeLeftDesc: "次のページに移動",
          swipeRight: "右にスワイプ",
          swipeRightDesc: "前のページに移動",
          swipeUpDown: "上下にスワイプ",
          swipeUpDownDesc: "ページをスクロール",
          pinchOut: "ピンチアウト（2本指を広げる）",
          pinchIn: "ピンチイン（2本指を閉じる）",
          longPress: "長押し",
          longPressDesc: "テキストを選択するか追加オプションを開きます",
        },
        readingNav: "読書とナビゲーション",
        navigation: "ページナビゲーション",
        navigationDesc: "ページ入力フィールドまたはサムネイルを使用して任意のページにジャンプできます",
        zoomControls: "ズームコントロール",
        zoomControlsDesc: "ズームレベルを調整するか、幅/ページに合わせるモードを選択します",
        search: "検索",
        searchDesc: "ドキュメント内のテキストを検索して移動します",
        displayDesc: "読書の外観とページレイアウトのオプションを変更します",
        publicationDesc: "現在の出版物の詳細を表示します",
        organization: "整理",
        bookmarks: "ブックマーク",
        bookmarksDesc: "重要なページを保存して素早くアクセスできます",
        notes: "メモ",
        notesDesc: "特定のページにテキストメモを追加します",
        annotationTools: "注釈ツール",
        highlights: "ハイライト",
        highlightsDesc: "重要なテキストを強調表示して目立たせます",
        underlineDesc: "重要な箇所をマークするためにテキストに下線を引きます",
        drawing: "描画",
        drawingDesc: "ページに直接フリーハンド注釈を描画します",
        undoRedo: "元に戻す＆やり直す",
        undoRedoDesc: "注釈を元に戻すまたはやり直します",
        comingSoon: "近日公開予定",
        audioReading: "音声読み上げ",
        audioReadingDesc: "テキスト読み上げでドキュメント内容を聞きます",
        aiAssistant: "AIアシスタント",
        aiAssistantDesc: "インテリジェントなインサイトと要約を取得します",
        shortcuts: {
          navigationAccessibility: "ナビゲーションとアクセシビリティ",
          browseForward: "インタラクティブ要素を通して前に進みます",
          browseBackward: "インタラクティブ要素を通して後ろに戻ります",
          activateButton: "フォーカスされたボタンまたはリンクをアクティブ化します",
          selectToggle: "フォーカスされた要素を選択またはトグルします",
          closeDialogs: "開いているダイアログとメニューを閉じます",
          nextPrevPage: "次または前のページ",
          jumpTop: "ドキュメントの開始にジャンプします",
          jumpBottom: "ドキュメントの終わりにジャンプします",
          zoomViewControls: "ズームと表示コントロール",
          zoomIn: "ズームイン",
          zoomOut: "ズームアウト",
          fitWidth: "幅に合わせる",
          fitPage: "ページに合わせる",
          editingAnnotations: "編集と注釈",
          undo: "最後のアクションを元に戻す",
          redo: "最後のアクションをやり直す",
          toggleHighlight: "ハイライトモードを切り替える",
          drawingBrush: "描画ブラシを切り替える",
          toggleNotes: "メモサイドバーを切り替える",
          toggleBookmarks: "ブックマークサイドバーを切り替える",
          openToc: "目次を開く",
          saveBookmark: "ブックマークを保存",
          searchContent: "検索とコンテンツ",
          searchWithin: "ドキュメント内で検索",
          copyText: "選択したテキストをコピー",
          selectAll: "現在のページまたは表示内のテキストをすべて選択",
        },
        translateDesc: "選択したテキストをAIで翻訳します",
      },
      loading: {
        initializing: "初期化中...",
        restoringSession: "セッションを復元中...",
        fetchingAccessToken: "アクセストークンを取得中...",
        loadingDocument: "ドキュメントを読み込み中...",
        ariaLabel: "読み込み中",
        authenticating: "認証中...",
        finalizing: "完了処理中...",
      },
      errors: {
        failedToLoadPdf: "PDF の読み込みに失敗しました",
        failedToLoadEpub: "EPUB の読み込みに失敗しました",
        unsupportedFileType: "対応していないファイル形式です。PDF または EPUB をアップロードしてください。",
        errorReadingFile: "ファイルの読み込みエラー。",
        searchFailed: "検索に失敗しました",
        failedToRestoreSession: "セッションを復元できませんでした。",
        failedToInitializeReader: "トークンからリーダーを初期化できませんでした。",
      },
      readingAssistant: {
        title: "リーディングアシスタント",
        close: "リーディングアシスタントを閉じる",
        resize: "リーディングアシスタントのサイズ変更",
        resizeHint: "ドラッグでサイズ変更。ダブルクリックでリセット。",
        tabsLabel: "リーディングアシスタントのタブ",
        tabs: {
          summary: "要約",
          askAi: "AIに質問",
          quiz: "クイズ",
        },
        status: {
          loading: "確認中…",
          processing: "この文書はまだAI用に準備中です。しばらくしてから再試行してください。",
          unavailable: "この文書ではAI機能を利用できません。",
          failed: "文書の処理に失敗しました。AI機能は利用できません。",
          error: "AI機能を読み込めません。{{message}}",
        },
        summary: {
          typesLabel: "要約タイプ",
          types: {
            quick: "簡易要約",
            detailed: "詳細要約",
            chapter: "章ごとの要約",
          },
          cardTitles: {
            quick: "簡易要約",
            detailed: "詳細要約",
            chapter: "章ごとの要約",
          },
          welcomeTitle: "リーディングアシスタント",
          welcome: "AI読解体験へようこそ。準備ができたら下の要約オプションを選んでください。",
          loading: "要約を生成中",
          error: "要約を生成できませんでした。{{message}}",
          empty: "生成する要約タイプを選択してください。",
          chooseChapter: "下から章を選んで要約を生成します。",
          chapterListLabel: "章",
          noChapters: "この文書に利用できる章はありません。",
          backToTypes: "戻る",
          regenerate: "再生成",
        },
        askAi: {
          placeholder: "この本について何でも質問してください...",
          submit: "質問を送信",
          empty: "会話を始めるには質問してください。",
          sending: "考え中",
          error: "回答を取得できませんでした。{{message}}",
          export: "エクスポート",
          newChat: "新しいチャット",
        },
        quiz: {
          title: "クイズを受ける",
          subtitle: "テストしたい範囲を選んでください。",
          cta: "クイズを開始",
          loading: "クイズを生成中",
          error: "クイズを生成できませんでした。{{message}}",
          modalTitle: "AIクイズ",
          disclaimer: "AI生成コンテンツ。参考用です。",
          close: "クイズを閉じる",
          checkAnswer: "回答を確認",
          explanation: "解説",
          previous: "前へ",
          next: "次の質問",
          finish: "完了",
          progress: "質問 {{current}} / {{total}}",
          answerRequired: "続けるにはこの質問に答えてください。",
          completedTitle: "クイズ完了！",
          yourScore: "あなたのスコア",
          completedMessage: "クイズを正常に完了しました。",
          reattempt: "クイズを再挑戦",
          save: "保存",
          saving: "保存中…",
          saved: "保存済み",
          saveError: "結果を保存できませんでした。{{message}}",
          deleteError: "結果を削除できませんでした。{{message}}",
          deleteResult: "保存したクイズを削除",
          deletedToast: "クイズを削除しました",
          recentQuizzes: "最近のクイズ",
          seeDetails: "詳細を見る",
          showDetails: "詳細を表示",
          hideDetails: "詳細を非表示",
          correct: "正解",
          incorrect: "不正解",
          multipleChoice: "選択式",
          questionStatusAria: "質問 {{number}}: {{status}}",
          backToDashboard: "クイズダッシュボード",
          scopeLabel: "クイズ範囲",
          scopeBook: "本全体",
          scopeChapter: "章ごと",
          scopePage: "ページごと",
          scopePageTitle: "{{page}}ページ",
          scoreAria: "スコア {{correct}} / {{total}}",
          answerOptions: "回答の選択肢",
          navigationAria: "クイズナビゲーション",
          noQuestions: "クイズの質問が返されませんでした",
          feedback: {
            greatJob: "よくできました！",
            goodEffort: "がんばりました！",
            keepPracticing: "練習を続けましょう！",
          },
        },
        menu: {
          preferences: "AI設定",
          citation: "AI引用",
          copy: "AIコピー",
          quizzes: "AIクイズ",
          notes: "ノート",
          prefs: {
            aiLanguage: "優先言語",
            citationEnabled: "引用を表示",
            contextInclusionEnabled: "読書コンテキストを含める",
          },
        },
      },
      pullouts: {
        fallbackTitle: "ポップアップ",
        hintLabel: "ヒント:",
        hintAvailable: "ヒントがあります",
        expandHint: "ヒントを展開",
        collapseHint: "ヒントを折りたたむ",
      },
      publicationDetails: {
        title: "出版物の詳細",
        close: "出版物の詳細を閉じる",
        copy: "出版物の詳細をコピー",
        copied: "クリップボードにコピーしました",
        description: "説明",
        noData: "データなし",
        empty: "この文書には出版物の詳細がありません。",

        fields: {
          title: "タイトル",
          author: "著者",
          code: "コード",
          type: "種類",
          language: "言語",
          original_publisher: "原出版社",
          series: "シリーズ",
          edition: "版",
          pages: "ページ数",
          pisbn13: "PISBN13",
          publication_year: "出版年",
          copyright_year: "著作権年",
          read_direction: "読み方向",
          content_type: "コンテンツタイプ",
        },
      },
    },
  },
  ko: {
    translation: {
      common: {
        cancel: "취소",
        close: "닫기",
        menu: "메뉴",
        search: "검색",
        bookmarks: "북마크",
        notes: "메모",
        pages: "페이지",
        tableOfContents: "목차",
        page: "페이지",
        section: "섹션",
        loading: "로딩 중...",
        submit: "제출",
        apply: "적용",
        remove: "삭제",
        error: "오류",
        language: "언어",
        theme: "테마",
        light: "라이트",
        dark: "다크",
        on: "켜짐",
        off: "꺼짐",
        showMore: "더 보기",
        showLess: "간단히 보기",
        undo: "실행 취소",
        redo: "다시 실행",
        underline: "밑줄",
        highlight: "하이라이트",
        textbox: "텍스트 상자",
        document: "문서",
        back: "뒤로",
      },
      toolbar: {
        expand: "도구 모음 펼치기",
        collapse: "도구 모음 접기",
        aiAssistant: "AI 도우미에게 질문",
        aiAssistantComingSoon: "AI 도우미에게 질문 (출시 예정)",
        searchNotAllowed: "검색 불가",
        textToSpeechComingSoon: "텍스트 음성 변환 (출시 예정)",
        addBookmark: "북마크 추가",
        removeBookmark: "북마크 제거",
        bookmarked: "북마크됨",
        bookmarksNotAllowed: "북마크 사용 불가",
        moreOptions: "추가 옵션",
        display: "화면",
        lightHint: "밝은 배경과 어두운 글자",
        darkHint: "어두운 배경과 밝은 글자",
        pageView: "페이지 보기",
        singlePage: "단일 페이지",
        singlePageHint: "한 번에 한 페이지씩 스크롤",
        doublePage: "두 페이지",
        doublePageHint: "페이지를 나란히 보기",
        view: "색상 모드",
        share: "공유",
        download: "다운로드",
        citation: "인용",
        print: "인쇄",
        displayMenu: "화면 메뉴",
        displayMenuItems: {
          colorMode: "색상 모드",
          fontSize: "글자 크기",
          fontFamily: "글꼴",
          lineHeight: "줄 간격",
          increaseLineHeight: "줄 간격 늘리기",
          decreaseLineHeight: "줄 간격 줄이기",
          layout: "레이아웃",
          rotate: "회전",
          readingDirection: "읽기 방향",
          rotateLeft: "왼쪽으로 회전",
          rotateRight: "오른쪽으로 회전",
          ltr: "왼쪽에서 오른쪽",
          rtl: "오른쪽에서 왼쪽",
          fonts: {
            original: "원본",
            sans: "고딕",
            serif: "명조",
          },
          colors: {
            light: "라이트",
            dark: "다크",
            mint: "민트",
            sepia: "세피아",
          },
        },
      },
      mobile: {
        searchPlaceholder: "키워드 검색...",
        cancelSearch: "검색 취소",
        faq: "FAQ",
      },
      menu: {
        close: "메뉴 닫기",
        documentPageCount: "페이지 {{current}} / {{total}}",
      },
      rightToolbar: {
        showToc: "목차 표시",
        hideToc: "목차 숨기기",
        showPagesThumbnails: "페이지 썸네일 표시",
        hidePagesThumbnails: "페이지 썸네일 숨기기",
        showBookmarks: "북마크 표시",
        hideBookmarks: "북마크 숨기기",
        info: "출판물 정보",
        showPublicationDetails: "출판물 세부정보 표시",
        hidePublicationDetails: "출판물 세부정보 숨기기",
        askAi: "AI에게 질문",
        readingGroup: "독서 그룹",
        showNotes: "메모 표시",
        hideNotes: "메모 숨기기",
        myNotebook: "내 노트북",
        clickToEnterPage: "클릭하여 페이지 번호 입력",
        currentPageLabel: "현재 페이지 {{current}}. 클릭하여 변경.",
        previousPage: "이전 페이지",
        nextPage: "다음 페이지",
        zoomOut: "축소",
        zoomIn: "확대",
        resetZoom: "확대/축소 초기화",
        resetZoomTitle: "확대/축소 100%로 초기화",
        decreaseFontSize: "폰트 크기 감소",
        increaseFontSize: "폰트 크기 증가",
        resetFontSize: "폰트 크기 재설정",
        resetFontSizeTitle: "폰트 크기를 100%로 재설정",
        viewModeOptions: "보기 옵션",
        fitToWidth: "너비에 맞춤",
        fitToPage: "페이지에 맞춤",
        enterFullscreen: "전체 화면",
        exitFullscreen: "전체 화면 종료",
        enterPageNumber: "페이지 번호 입력",
        pageInputPlaceholder: "{{min}}-{{max}}",
        pageInputTitle: "페이지 번호 입력 ({{min}}-{{max}})",
        pageInputInvalid: "유효한 페이지 번호를 입력하세요",
        pageInputOutOfRange: "페이지는 1에서 {{total}} 사이여야 합니다",
        showReadingAssistant: "읽기 도우미 표시",
        hideReadingAssistant: "읽기 도우미 숨기기",
      },
      floatingToolbar: {
        ariaLabel: "플로팅 도구 모음",
        dragToMove: "드래그하여 이동",
        dragToolbar: "도구 모음 드래그",
        notesOn: "메모 켜기",
        notesOff: "메모 끄기",
        notesNotAllowed: "메모 사용 불가",
        notesOnLabel: "메모: 켜짐",
        notesOffLabel: "메모: 꺼짐",
        drawingOn: "그리기 켜기",
        drawingOff: "그리기 끄기",
        drawingNotAllowed: "그리기 사용 불가",
        drawingOnLabel: "그리기: 켜짐",
        drawingOffLabel: "그리기: 꺼짐",
        textBoxComingSoon: "텍스트 상자 (출시 예정)",
        textboxNotAllowed: "Text box not allowed",
        textboxOn: "텍스트 상자 켜기",
        textboxOff: "텍스트 상자 끄기",
        textboxOnLabel: "텍스트 상자: 켜짐",
        textboxOffLabel: "텍스트 상자: 꺼짐",
        highlightOn: "하이라이트 켜기",
        highlightOff: "하이라이트 끄기",
        highlightsNotAllowed: "하이라이트 사용 불가",
        highlightOnLabel: "하이라이트: 켜짐",
        highlightOffLabel: "하이라이트: 꺼짐",
        underlineOn: "밑줄 켜기",
        underlineOff: "밑줄 끄기",
        underlineOnLabel: "밑줄: 켜짐",
        underlineOffLabel: "밑줄: 꺼짐",
        highlightColorLabel: "하이라이트 색상",
        colorRed: "빨간색",
        colorOrange: "주황색",
        colorYellow: "노란색",
        colorGreen: "초록색",
        colorLightBlue: "하늘색",
        colorPurple: "보라색",
        underlinesNotAllowed: "밑줄 사용 불가",
        undo: "실행 취소 ({{ctrl}}+Z)",
        redo: "다시 실행 ({{ctrl}}+Y)",
        undoCooldown: "실행 취소(잠시 기다려 주세요)",
        redoCooldown: "다시 실행(잠시 기다려 주세요)",
      },
      contextMenu: {
        addNote: "메모 추가",
        highlight: "하이라이트",
        underline: "밑줄",
        copy: "복사",
        removeHighlight: "하이라이트 제거",
        removeUnderline: "밑줄 제거",
        searchSelected: "선택한 단어 검색",
        selectionToolbar: "선택 메뉴",
        askAi: "AI에게 질문",
        share: "공유",
        translate: "번역",
        comingSoon: "곧 출시",
        translationTitle: "번역",
        translating: "번역 중…",
        translationFailed: "번역 실패",
      },
      readerShell: {
        loadingDocument: "문서를 불러오는 중...",
        documentControls: "문서 제어",
      },
      emptyState: {
        errorAlt: "오류",
        documentAlt: "문서",
        unableToLoad: "문서를 불러올 수 없습니다",
        noDocument: "문서가 로드되지 않았습니다",
        requestDoc: "시작하려면 라이브러리에서 문서를 요청하세요",
      },
      search: {
        ariaLabel: "검색 결과",
        searchResults: "검색 결과",
        close: "검색 닫기",
        placeholder: "문서에서 검색...",
        clear: "검색 지우기",
        searching: "검색 중...",
        enterQuery: "문서에서 텍스트를 찾기 위해 검색어를 입력하세요",
        noResults: "\"{{query}}\"에 대한 결과가 없습니다",
        resultsCount_one: "{{count}}개의 결과",
        resultsCount_other: "{{count}}개의 결과",
        matchCount_one: "{{count}}개 일치",
        matchCount_other: "{{count}}개 일치",
        navigateToResult: "이 결과로 이동하려면 클릭",
      },
      bookmarks: {
        title: "북마크",
        close: "북마크 닫기",
        loading: "북마크 로딩 중...",
        error: "북마크 로딩 오류: {{error}}",
        noItems: "아직 북마크가 없습니다",
        navigate: "이 북마크로 이동하려면 클릭",
        remove: "북마크 제거",
        removeLabel: "북마크 {{label}} 제거",
        deleteError: "북마크 삭제 실패",
        navigateLabel: "{{label}}(으)로 이동",
        defaultLabel: "북마크 {{page}}",
      },
      notes: {
        title: "내 노트북",
        close: "내 노트북 닫기",
        navigate: "이 메모로 이동하려면 클릭",
        ariaLabel: "메모: {{preview}} 페이지 {{page}} {{created}}",
        createdOn: "{{date}}에 생성",
        pageTitle: "페이지 {{page}}",
        remove: "메모 제거",
        removeLabel: "페이지 {{page}}에서 메모 제거",
        none: "아직 메모가 없습니다",
        noItems: "아직 항목이 없습니다",
        share: "노트북 공유",
        searchPlaceholder: "여기에 입력",
        clearSearch: "검색 지우기",
        tabsLabel: "노트북 필터",
        tabs: {
          all: "전체",
          highlight: "하이라이트",
          underline: "밑줄",
          note: "노트",
        },
        resultsFound_one: "결과 {{count}}개",
        resultsFound_other: "결과 {{count}}개",
        copyItem: "항목 복사",
        shareItem: "항목 공유",
      },
      toc: {
        title: "목차",
        close: "목차 닫기",
        untitled: "제목 없는 섹션",
        empty: "목차가 없습니다",
        noItems: "목차가 없습니다",
        chapter: "장",
      },
      pages: {
        title: "페이지",
        count_one: "{{count}} 페이지",
        count_other: "{{count}} 페이지",
        empty: "사용 가능한 페이지가 없습니다",
        thumbnailAlt: "페이지 {{page}}",
        ariaLabel: "페이지 썸네일",
      },
      epub: {
        loading: "EPUB 로딩 중...",
        errorTitle: "EPUB 로딩 오류",
        reload: "페이지 새로고침",
        noteIndicatorTitle: "메모 {{current}} / {{total}}: {{text}}{{suffix}}",
        noteSelectedSuffix: " (선택된 텍스트 메모)",
        noteTitleEdit: "메모 편집",
        noteTitleAdd: "메모 추가",
        noteCounter: "({{current}} / {{total}})",
        selectedTextLabel: "선택된 텍스트:",
        notePlaceholderSelected: "선택된 텍스트에 대한 메모를 추가하세요...",
        notePlaceholder: "메모 입력",
        noteActionSave: "저장",
        noteActionCreate: "만들기",
        contextAddNote: "메모 추가",
        contextHighlight: "하이라이트",
        contextSearch: "선택한 단어 검색",
        imageAlt: "이미지",
        imageLightboxAria: "확대된 이미지",
        closeImagePreview: "이미지 미리보기 닫기",
      },
      notifications: {
        featureNotAllowed: "이 기능은 사용할 수 없습니다.",
        featureComingSoon: "이 기능은 곧 출시될 예정입니다.",
        highlightsNotAvailable: "이 문서에서는 하이라이트를 사용할 수 없습니다.",
        underlinesNotAvailable: "이 문서에서는 밑줄 기능을 사용할 수 없습니다.",
        notesNotAvailable: "이 문서에서는 메모를 사용할 수 없습니다.",
        drawingNotAvailable: "이 문서에서는 그리기를 사용할 수 없습니다.",
        bookmarksNotAvailable: "이 문서에서는 북마크를 사용할 수 없습니다.",
        searchNotAvailable: "이 문서에서는 검색을 사용할 수 없습니다.",
        commentsNotAvailable: "이 문서에서는 댓글을 사용할 수 없습니다.",
        pageOutOfRange: "이 페이지는 사용할 수 없습니다.",
        aiAssistantComingSoon: "AI 도우미가 곧 제공됩니다.",
        textBoxComingSoon: "텍스트 상자가 곧 제공됩니다.",
        textToSpeechComingSoon: "텍스트 음성 변환이 곧 제공됩니다.",
        sessionExpired: "세션이 만료되었습니다. 새로고침 후 다시 시도하세요.",
        operationFailed: "{{operation}}할 수 없습니다. 다시 시도하세요.",
        copyLimitExceeded: "복사 한도를 초과했습니다. {{limit}}자만 복사되었습니다.",
        copyNotAllowed: "이 문서에서는 복사가 허용되지 않습니다.",
        operations: {
          saveAiPreferences: "AI 환경설정 저장",
          copyText: "텍스트 복사",
          completeAction: "이 작업 완료",
          saveBookmark: "북마크 저장",
          deleteBookmark: "북마크 삭제",
          saveNote: "노트 저장",
          updateNote: "노트 업데이트",
          deleteNote: "노트 삭제",
          saveHighlight: "하이라이트 저장",
          updateHighlight: "하이라이트 업데이트",
          deleteHighlight: "하이라이트 삭제",
          saveUnderline: "밑줄 저장",
          deleteUnderline: "밑줄 삭제",
          saveDrawing: "그림 저장",
          deleteDrawing: "그림 삭제",
          updateTextbox: "텍스트 상자 업데이트",
          deleteTextbox: "텍스트 상자 삭제",
        },
      },
      faq: {
        open: "FAQ 열기",
        title: "E-Reader 사용 방법",
      },
      help: {
        close: "도움말 닫기",
        title: "E-Reader 사용자 가이드",
        featuresTab: "기능",
        shortcutsTab: "키보드 단축키",
        gesturesTab: "터치 제스처",
        gestures: {
          title: "터치 제스처",
          tap: "탭",
          tapDesc: "항목을 선택하거나 링크를 엽니다",
          doubleTap: "더블 탭",
          doubleTapDesc: "확대 또는 축소",
          swipeLeft: "왼쪽으로 스와이프",
          swipeLeftDesc: "다음 페이지로 이동",
          swipeRight: "오른쪽으로 스와이프",
          swipeRightDesc: "이전 페이지로 이동",
          swipeUpDown: "위/아래로 스와이프",
          swipeUpDownDesc: "페이지를 스크롤합니다",
          pinchOut: "핀치 아웃 (두 손가락 벌리기)",
          pinchIn: "핀치 인 (두 손가락 모으기)",
          longPress: "길게 누르기",
          longPressDesc: "텍스트를 선택하거나 추가 옵션을 엽니다",
        },
        readingNav: "읽기 및 탐색",
        navigation: "페이지 탐색",
        navigationDesc: "페이지 입력 필드 또는 썸네일을 사용하여 모든 페이지로 이동합니다",
        zoomControls: "확대/축소 컨트롤",
        zoomControlsDesc: "줌 수준을 조정하거나 너비/페이지에 맞추기 모드를 선택합니다",
        search: "검색",
        searchDesc: "문서의 텍스트를 찾고 탐색합니다",
        displayDesc: "읽기 모양과 페이지 레이아웃 옵션을 변경합니다",
        publicationDesc: "현재 출판물의 세부정보를 봅니다",
        organization: "구성",
        bookmarks: "책갈피",
        bookmarksDesc: "빠른 액세스를 위해 중요한 페이지를 저장합니다",
        notes: "메모",
        notesDesc: "특정 페이지에 텍스트 메모를 추가합니다",
        annotationTools: "주석 도구",
        highlights: "강조",
        highlightsDesc: "중요한 텍스트를 강조하여 돋보이게 합니다",
        underlineDesc: "핵심 구절을 표시하기 위해 텍스트에 밑줄을 긋습니다",
        drawing: "그리기",
        drawingDesc: "페이지에 직접 자유형 주석을 그립니다",
        undoRedo: "실행 취소 및 다시 실행",
        undoRedoDesc: "주석을 실행 취소하거나 다시 실행합니다",
        comingSoon: "곧 출시",
        audioReading: "음성 읽기",
        audioReadingDesc: "텍스트 음성 변환으로 문서 내용을 듣십시오",
        aiAssistant: "AI 어시스턴트",
        aiAssistantDesc: "지능형 인사이트 및 요약을 받으십시오",
        shortcuts: {
          navigationAccessibility: "탐색 및 접근성",
          browseForward: "대화형 요소를 통해 앞으로 이동합니다",
          browseBackward: "대화형 요소를 통해 뒤로 이동합니다",
          activateButton: "포커스된 버튼 또는 링크를 활성화합니다",
          selectToggle: "포커스된 요소를 선택하거나 전환합니다",
          closeDialogs: "열린 대화 상자 및 메뉴를 닫습니다",
          nextPrevPage: "다음 또는 이전 페이지",
          jumpTop: "문서 시작으로 이동합니다",
          jumpBottom: "문서 끝으로 이동합니다",
          zoomViewControls: "확대/축소 및 보기 컨트롤",
          zoomIn: "확대",
          zoomOut: "축소",
          fitWidth: "너비에 맞추기",
          fitPage: "페이지에 맞추기",
          editingAnnotations: "편집 및 주석",
          undo: "마지막 작업 실행 취소",
          redo: "마지막 작업 다시 실행",
          toggleHighlight: "강조 모드 전환",
          drawingBrush: "그리기 브러시 전환",
          toggleNotes: "메모 사이드바 전환",
          toggleBookmarks: "책갈피 사이드바 전환",
          openToc: "목차 열기",
          saveBookmark: "책갈피 저장",
          searchContent: "검색 및 콘텐츠",
          searchWithin: "문서 내에서 검색",
          copyText: "선택한 텍스트 복사",
          selectAll: "현재 페이지 또는 보기의 모든 텍스트 선택",
        },
        translateDesc: "선택한 텍스트를 AI로 번역합니다",
      },
      loading: {
        initializing: "초기화 중...",
        restoringSession: "세션 복원 중...",
        fetchingAccessToken: "액세스 토큰 가져오는 중...",
        loadingDocument: "문서 로딩 중...",
        ariaLabel: "로딩 중",
        authenticating: "인증 중...",
        finalizing: "마무리 중...",
      },
      landingPage: {
        uploadTitle: "문서 업로드",
        uploadSubtitle: "여기에 PDF 또는 EPUB 파일을 끌어다 놓거나 클릭하여 업로드",
        supportedFormats: "지원되는 형식: PDF, EPUB",
        uploadAriaLabel: "PDF 또는 EPUB 파일 업로드",
      },
      errors: {
        failedToLoadPdf: "PDF 로드 실패",
        failedToLoadEpub: "EPUB 로드 실패",
        unsupportedFileType: "지원되지 않는 파일 형식입니다. PDF 또는 EPUB를 업로드하세요.",
        errorReadingFile: "파일 읽기 오류.",
        searchFailed: "검색 실패",
        failedToRestoreSession: "세션을 복원하지 못했습니다.",
        failedToInitializeReader: "토큰으로 리더를 초기화하지 못했습니다.",
      },
      readingAssistant: {
        title: "읽기 도우미",
        close: "읽기 도우미 닫기",
        resize: "읽기 도우미 크기 조절",
        resizeHint: "드래그하여 크기를 조절하세요. 더블 클릭하면 초기화됩니다.",
        tabsLabel: "읽기 도우미 탭",
        tabs: {
          summary: "요약",
          askAi: "AI에게 질문",
          quiz: "퀴즈",
        },
        status: {
          loading: "확인 중…",
          processing: "이 문서는 아직 AI용으로 준비 중입니다. 잠시 후 다시 시도하세요.",
          unavailable: "이 문서에서는 AI 기능을 사용할 수 없습니다.",
          failed: "문서 처리에 실패했습니다. AI 기능을 사용할 수 없습니다.",
          error: "AI 기능을 불러올 수 없습니다. {{message}}",
        },
        summary: {
          typesLabel: "요약 유형",
          types: {
            quick: "간단 요약",
            detailed: "상세 요약",
            chapter: "장별 요약",
          },
          cardTitles: {
            quick: "간단 요약",
            detailed: "상세 요약",
            chapter: "장별 요약",
          },
          welcomeTitle: "읽기 도우미",
          welcome: "AI 읽기 경험에 오신 것을 환영합니다. 준비가 되면 아래 요약 옵션을 선택하세요.",
          loading: "요약 생성 중",
          error: "요약을 생성할 수 없습니다. {{message}}",
          empty: "생성할 요약 유형을 선택하세요.",
          chooseChapter: "아래에서 장을 선택해 요약을 생성하세요.",
          chapterListLabel: "장",
          noChapters: "이 문서에 사용 가능한 장이 없습니다.",
          backToTypes: "뒤로",
          regenerate: "다시 생성",
        },
        askAi: {
          placeholder: "이 책에 대해 무엇이든 물어보세요...",
          submit: "질문 보내기",
          empty: "대화를 시작하려면 질문하세요.",
          sending: "생각 중",
          error: "응답을 받지 못했습니다. {{message}}",
          export: "내보내기",
          newChat: "새 채팅",
        },
        quiz: {
          title: "퀴즈 풀기",
          subtitle: "테스트할 범위를 선택하세요.",
          cta: "퀴즈 시작",
          loading: "퀴즈 생성 중",
          error: "퀴즈를 생성할 수 없습니다. {{message}}",
          modalTitle: "AI 퀴즈",
          disclaimer: "AI 생성 콘텐츠, 참고용입니다.",
          close: "퀴즈 닫기",
          checkAnswer: "답 확인",
          explanation: "해설",
          previous: "이전",
          next: "다음 문제",
          finish: "완료",
          progress: "문제 {{current}} / {{total}}",
          answerRequired: "계속하려면 이 문제에 답하세요.",
          completedTitle: "퀴즈 완료!",
          yourScore: "내 점수",
          completedMessage: "퀴즈를 성공적으로 완료했습니다.",
          reattempt: "퀴즈 다시 풀기",
          save: "저장",
          saving: "저장 중…",
          saved: "저장됨",
          saveError: "결과를 저장할 수 없습니다. {{message}}",
          deleteError: "결과를 삭제할 수 없습니다. {{message}}",
          deleteResult: "저장된 퀴즈 삭제",
          deletedToast: "퀴즈가 삭제되었습니다",
          recentQuizzes: "최근 퀴즈",
          seeDetails: "세부정보 보기",
          showDetails: "세부정보 표시",
          hideDetails: "세부정보 숨기기",
          correct: "정답",
          incorrect: "오답",
          multipleChoice: "객관식",
          questionStatusAria: "문제 {{number}}: {{status}}",
          backToDashboard: "퀴즈 대시보드",
          scopeLabel: "퀴즈 범위",
          scopeBook: "책 전체",
          scopeChapter: "장별",
          scopePage: "페이지별",
          scopePageTitle: "{{page}}페이지",
          scoreAria: "점수 {{correct}} / {{total}}",
          answerOptions: "답변 선택지",
          navigationAria: "퀴즈 탐색",
          noQuestions: "퀴즈 문제가 반환되지 않았습니다",
          feedback: {
            greatJob: "잘했어요!",
            goodEffort: "좋은 시도예요!",
            keepPracticing: "계속 연습하세요!",
          },
        },
        menu: {
          preferences: "AI 환경설정",
          citation: "AI 인용",
          copy: "AI 복사",
          quizzes: "AI 퀴즈",
          notes: "노트",
          prefs: {
            aiLanguage: "선호 언어",
            citationEnabled: "인용 표시",
            contextInclusionEnabled: "읽기 맥락 포함",
          },
        },
      },
      pullouts: {
        fallbackTitle: "팝업",
        hintLabel: "힌트:",
        hintAvailable: "힌트 있음",
        expandHint: "힌트 펼치기",
        collapseHint: "힌트 접기",
      },
      publicationDetails: {
        title: "출판물 세부정보",
        close: "출판물 세부정보 닫기",
        copy: "출판물 세부정보 복사",
        copied: "클립보드에 복사됨",
        description: "설명",
        noData: "데이터 없음",
        empty: "이 문서에 대한 출판물 세부정보가 없습니다.",

        fields: {
          title: "제목",
          author: "저자",
          code: "코드",
          type: "유형",
          language: "언어",
          original_publisher: "원 출판사",
          series: "시리즈",
          edition: "판",
          pages: "쪽수",
          pisbn13: "PISBN13",
          publication_year: "출판 연도",
          copyright_year: "저작권 연도",
          read_direction: "읽기 방향",
          content_type: "콘텐츠 유형",
        },
      },
    },
  },
  my: {
    translation: {
      common: {
        cancel: "ပယ်ဖျက်",
        close: "ပိတ်",
        menu: "မီနူး",
        search: "ရှာဖွေ",
        bookmarks: "စာမျက်နှာမှတ်သား",
        notes: "မှတ်စု",
        pages: "စာမျက်နှာများ",
        tableOfContents: "မာတိကာ",
        page: "စာမျက်နှာ",
        section: "အပိုင်း",
        loading: "တင်နေသည်...",
        submit: "ပို့မည်",
        apply: "အသုံးပြုရန်",
        remove: "ဖယ်ရှား",
        error: "အမှား",
        language: "ဘာသာစကား",
        theme: "အပြင်အဆင်",
        light: "အလင်း",
        dark: "မှောင်",
        on: "ဖွင့်",
        off: "ပိတ်",
        showMore: "နောက်ထပ်ပြ",
        showLess: "နည်းပြီးပြ",
        undo: "မလုပ်တော့",
        redo: "ပြန်လုပ်",
        underline: "အောက်ကြောင်း",
        highlight: "အလင်းပြ",
        document: "စာရွက်စာတမ်း",
        back: "နောက်သို့",
      },
      toolbar: {
        expand: "ကိရိယာဘားကို ဖြန့်ရန်",
        collapse: "ကိရိယာဘားကို ချုံ့ရန်",
        aiAssistant: "AI အကူအညီကို မေးမြန်းရန်",
        aiAssistantComingSoon: "AI အကူအညီ (မကြာမီ)",
        searchNotAllowed: "ရှာဖွေရန် မခွင့်ပြုပါ",
        textToSpeechComingSoon: "စာသားမှ အသံ (မကြာမီ)",
        addBookmark: "စာမျက်နှာမှတ်သား ထည့်ရန်",
        removeBookmark: "စာမျက်နှာမှတ်သား ဖယ်ရန်",
        bookmarked: "စာမျက်နှာမှတ်သား ပြုထားသည်",
        bookmarksNotAllowed: "စာမျက်နှာမှတ်သား မရနိုင်ပါ",
        moreOptions: "နောက်ထပ်ရွေးချယ်မှုများ",
        display: "ပြသမှု",
        lightHint: "အလင်းနောက်ခံနှင့် မဲစာသား",
        darkHint: "မှောင်နောက်ခံနှင့် အလင်းစာသား",
        pageView: "စာမျက်နှာမြင်ကွင်း",
        singlePage: "တစ်မျက်နှာ",
        singlePageHint: "တစ်ကြိမ်တစ်မျက်နှာ စာမျက်နှာရွှေ့",
        doublePage: "နှစ်မျက်နှာ",
        doublePageHint: "စာမျက်နှာများကို ဘေးဘက်တန်းတန်း မြင်ရန်",
        view: "အရောင်မုဒ်",
        share: "မျှဝေရန်",
        download: "ဒေါင်းလုဒ်",
        citation: "ကိုးကား",
        print: "ပရင့်",
        displayMenu: "ပြသမှု မီနူး",
        displayMenuItems: {
          colorMode: "အရောင်မုဒ်",
          fontSize: "စာလုံးအရွယ်",
          fontFamily: "စာလုံးပုံစံ",
          lineHeight: "လိုင်းအမြင့်",
          increaseLineHeight: "လိုင်းအမြင့် တိုးရန်",
          decreaseLineHeight: "လိုင်းအမြင့် လျှော့ရန်",
          layout: "အပြင်အဆင်",
          rotate: "လှည့်ရန်",
          readingDirection: "စာဖတ်ဦးတည်ချက်",
          rotateLeft: "ဘယ်သို့ လှည့်ရန်",
          rotateRight: "ညာသို့ လှည့်ရန်",
          ltr: "ဘယ်မှ ညာ",
          rtl: "ညာမှ ဘယ်",
          fonts: {
            original: "မူရင်း",
            sans: "Sans",
            serif: "Serif",
          },
          colors: {
            light: "အလင်း",
            dark: "အမှောင်",
            mint: "Mint",
            sepia: "Sepia",
          },
        },
      },
      mobile: {
        searchPlaceholder: "သော့ချက်စာလုံးရှာဖွေရန်...",
        cancelSearch: "ရှာဖွေမှု ပယ်ဖျက်ရန်",
        faq: "မေးလေ့ရှိသော မေးခွန်းများ",
      },
      menu: {
        close: "မီနူး ပိတ်ရန်",
        documentPageCount: "စာမျက်နှာ {{current}} / {{total}}",
      },
      rightToolbar: {
        showToc: "မာတိကာ ပြရန်",
        hideToc: "မာတိကာ ဖျောက်ရန်",
        showPagesThumbnails: "စာမျက်နှာ အကြိုပြ ကြည့်ရန်",
        hidePagesThumbnails: "စာမျက်နှာ အကြိုပြ ဖျောက်ရန်",
        showBookmarks: "စာမျက်နှာမှတ်သားများ ပြရန်",
        hideBookmarks: "စာမျက်နှာမှတ်သားများ ဖျောက်ရန်",
        info: "ထုတ်ဝေမှုအချက်အလက်",
        showPublicationDetails: "ထုတ်ဝေမှု အသေးစိတ် ပြရန်",
        hidePublicationDetails: "ထုတ်ဝေမှု အသေးစိတ် ဖျောက်ရန်",
        askAi: "AI ကိုမေးပါ",
        readingGroup: "စာဖတ်အဖွဲ့",
        showNotes: "မှတ်စုများ ပြရန်",
        hideNotes: "မှတ်စုများ ဖျောက်ရန်",
        myNotebook: "ကျွန်ုပ်၏ မှတ်စုစာအုပ်",
        clickToEnterPage: "စာမျက်နှာ နံပါတ်ရိုက်ရန် နှိပ်ပါ",
        currentPageLabel: "လက်ရှိစာမျက်နှာ {{current}}။ ပြောင်းရန် နှိပ်ပါ။",
        previousPage: "ယခင်စာမျက်နှာ",
        nextPage: "နောက်စာမျက်နှာ",
        zoomOut: "ချုံ့",
        zoomIn: "ကြီး",
        resetZoom: "ချုံ့/ကြီး ကို ပြန်ထားရန်",
        resetZoomTitle: "ချုံ့/ကြီး 100% သို့ ပြန်ထားရန်",
        decreaseFontSize: "ဖောင့်အရွယ်လျှော့ရန်",
        increaseFontSize: "ဖောင့်အရွယ်တိုးရန်",
        resetFontSize: "ဖောင့်အရွယ်ကို ပြန်လည်သတ်မှတ်ရန်",
        resetFontSizeTitle: "ဖောင့်အရွယ်ကို 100% သို့ ပြန်လည်သတ်မှတ်ရန်",
        viewModeOptions: "မြင်ကွင်းရွေးချယ်မှုများ",
        fitToWidth: "အကျယ်နဲ့ ကိုက်ညီ",
        fitToPage: "စာမျက်နှာနဲ့ ကိုက်ညီ",
        enterFullscreen: "အပြည့်မျက်နှာပြင်",
        exitFullscreen: "အပြည့်မျက်နှာပြင် ထွက်ရန်",
        enterPageNumber: "စာမျက်နှာ နံပါတ်ထည့်ပါ",
        pageInputPlaceholder: "{{min}}-{{max}}",
        pageInputTitle: "စာမျက်နှာနံပါတ် ထည့်ပါ ({{min}}-{{max}})",
        pageInputInvalid: "မှန်ကန်သော စာမျက်နှာနံပါတ်ကို ထည့်ပါ",
        pageInputOutOfRange: "စာမျက်နှာသည် 1 မှ {{total}} အတွင်း ဖြစ်ရမည်",
        showReadingAssistant: "စာဖတ်အကူအညီကို ပြရန်",
        hideReadingAssistant: "စာဖတ်အကူအညီကို ဖုံးရန်",
      },
      floatingToolbar: {
        ariaLabel: "အမြင့်ကျသော ကိရိယာဘား",
        dragToMove: "ရွှေ့ရန် ဆွဲပါ",
        dragToolbar: "ကိရိယာဘား ဆွဲရန်",
        notesOn: "မှတ်စု ဖွင့်ရန်",
        notesOff: "မှတ်စု ပိတ်ရန်",
        notesNotAllowed: "မှတ်စု မရနိုင်ပါ",
        notesOnLabel: "မှတ်စု: ဖွင့်",
        notesOffLabel: "မှတ်စု: ပိတ်",
        drawingOn: "ဆွဲချက် ဖွင့်ရန်",
        drawingOff: "ဆွဲချက် ပိတ်ရန်",
        drawingNotAllowed: "ဆွဲချက် မရနိုင်ပါ",
        drawingOnLabel: "ဆွဲချက်: ဖွင့်",
        drawingOffLabel: "ဆွဲချက်: ပိတ်",
        textBoxComingSoon: "စာသားအကွက် (မကြာမီ)",
        textboxNotAllowed: "Text box not allowed",
        textboxOn: "စာသားအကွက် ဖွင့်ရန်",
        textboxOff: "စာသားအကွက် ပိတ်ရန်",
        textboxOnLabel: "စာသားအကွက်: ဖွင့်",
        textboxOffLabel: "စာသားအကွက်: ပိတ်",
        highlightOn: "ပြသချက် ဖွင့်ရန်",
        highlightOff: "ပြသချက် ပိတ်ရန်",
        highlightsNotAllowed: "ပြသချက် မရနိုင်ပါ",
        highlightOnLabel: "ပြသချက်: ဖွင့်",
        highlightOffLabel: "ပြသချက်: ပိတ်",
        underlineOn: "အောက်ကြောင်း ဖွင့်ရန်",
        underlineOff: "အောက်ကြောင်း ပိတ်ရန်",
        underlineOnLabel: "အောက်ကြောင်း: ဖွင့်",
        underlineOffLabel: "အောက်ကြောင်း: ပိတ်",
        highlightColorLabel: "ပြသချက် အရောင်",
        colorRed: "အနီ",
        colorOrange: "လိမ္မော်",
        colorYellow: "အဝါရောင်",
        colorGreen: "အစိမ်း",
        colorLightBlue: "အပြာနု",
        colorPurple: "ခရမ်း",
        underlinesNotAllowed: "အောက်ကြောင်း မရနိုင်ပါ",
        undo: "မလုပ်တော့ ({{ctrl}}+Z)",
        redo: "ပြန်လုပ် ({{ctrl}}+Y)",
        undoCooldown: "ပြန်ဖျက်ရန် (ခဏစောင့်ပါ)",
        redoCooldown: "ပြန်လုပ်ရန် (ခဏစောင့်ပါ)",
      },
      contextMenu: {
        addNote: "မှတ်စု ထည့်ရန်",
        highlight: "ပြသချက်",
        underline: "အောက်ကြောင်း",
        copy: "ကူးယူ",
        removeHighlight: "ပြသချက် ဖယ်ရန်",
        removeUnderline: "အောက်ကြောင်း ဖယ်ရန်",
        searchSelected: "ရွေးချယ်ထားသော စာလုံး ရှာရန်",
        selectionToolbar: "ရွေးချယ်မှု မီနူး",
        askAi: "AI ကိုမေးပါ",
        share: "မျှဝေရန်",
        translate: "ဘာသာပြန်ရန်",
        comingSoon: "မကြာမီ လာမည်",
        translationTitle: "ဘာသာပြန်",
        translating: "ဘာသာပြန်နေသည်…",
        translationFailed: "ဘာသာပြန်မအောင်မြင်ပါ",
      },
      readerShell: {
        loadingDocument: "စာရွက်စာတမ်း တင်နေသည်...",
        documentControls: "စာရွက်စာတမ်း ကွန်ထရိုးများ",
      },
      emptyState: {
        errorAlt: "အမှား",
        documentAlt: "စာရွက်စာတမ်း",
        unableToLoad: "စာရွက်စာတမ်း မတင်နိုင်ပါ",
        noDocument: "စာရွက်စာတမ်း မတင်ရသေးပါ",
        requestDoc: "စတင်ရန် သင့်စာကြည့်တိုက်မှ စာရွက်စာတမ်း တောင်းပါ",
      },
      search: {
        ariaLabel: "ရှာဖွေမှုရလဒ်များ",
        searchResults: "ရှာဖွေမှုရလဒ်များ",
        close: "ရှာဖွေမှု ပိတ်ရန်",
        placeholder: "စာရွက်စာတမ်းအတွင်း ရှာရန်...",
        clear: "ရှာဖွေမှု ရှင်းလင်းရန်",
        searching: "ရှာဖွေနေသည်...",
        enterQuery: "စာရွက်စာတမ်းအတွင်း စာသားကို ရှာရန် စာရိုက်ထည့်ပါ",
        noResults: "\"{{query}}\" အတွက် ရလဒ်မတွေ့ပါ",
        resultsCount_one: "ရလဒ် {{count}} ခု တွေ့ရှိသည်",
        resultsCount_other: "ရလဒ် {{count}} ခု တွေ့ရှိသည်",
        matchCount_one: "{{count}} ခု တိုက်ဆိုင်",
        matchCount_other: "{{count}} ခု တိုက်ဆိုင်",
        navigateToResult: "ဒီရလဒ်သို့ သွားရန် နှိပ်ပါ",
      },
      bookmarks: {
        title: "စာမျက်နှာမှတ်သား",
        close: "စာမျက်နှာမှတ်သားများ ပိတ်ရန်",
        loading: "စာမျက်နှာမှတ်သားများ တင်နေသည်...",
        error: "စာမျက်နှာမှတ်သား တင်ရာတွင် အမှား: {{error}}",
        noItems: "စာမျက်နှာမှတ်သား မရှိသေးပါ",
        navigate: "ဒီစာမျက်နှာမှတ်သားသို့ သွားရန် နှိပ်ပါ",
        remove: "စာမျက်နှာမှတ်သား ဖယ်ရန်",
        removeLabel: "စာမျက်နှာမှတ်သား {{label}} ဖယ်ရန်",
        deleteError: "စာမျက်နှာမှတ်သား ဖျက်မရပါ",
        navigateLabel: "{{label}} သို့ သွားရန်",
        defaultLabel: "စာမျက်နှာမှတ်သား {{page}}",
      },
      notes: {
        title: "ကျွန်ုပ်၏ မှတ်စုစာအုပ်",
        close: "ကျွန်ုပ်၏ မှတ်စုစာအုပ် ပိတ်ရန်",
        navigate: "ဒီမှတ်စုသို့ သွားရန် နှိပ်ပါ",
        ariaLabel: "မှတ်စု: {{preview}} စာမျက်နှာ {{page}} {{created}}",
        createdOn: "{{date}} တွင် ဖန်တီး",
        pageTitle: "စာမျက်နှာ {{page}}",
        remove: "မှတ်စု ဖယ်ရန်",
        removeLabel: "စာမျက်နှာ {{page}} မှ မှတ်စု ဖယ်ရန်",
        none: "မှတ်စု မရှိသေးပါ",
        noItems: "အချက်အလက် မရှိသေးပါ",
        share: "မှတ်စုစာအုပ် မျှဝေရန်",
        searchPlaceholder: "ဤနေရာတွင် ရိုက်ပါ",
        clearSearch: "ရှာဖွေမှု ရှင်းရန်",
        tabsLabel: "မှတ်စုစာအုပ် စစ်ထုတ်မှုများ",
        tabs: {
          all: "အားလုံး",
          highlight: "အသားပေး",
          underline: "မျဉ်းသား",
          note: "မှတ်စု",
        },
        resultsFound_one: "ရလဒ် {{count}} ခု တွေ့ရှိ",
        resultsFound_other: "ရလဒ် {{count}} ခု တွေ့ရှိ",
        copyItem: "အချက်အလက် ကူးယူရန်",
        shareItem: "အချက်အလက် မျှဝေရန်",
      },
      toc: {
        title: "မာတိကာ",
        close: "မာတိကာ ပိတ်ရန်",
        untitled: "ခေါင်းစဉ်မရှိ အပိုင်း",
        empty: "မာတိကာ မရနိုင်ပါ",
        noItems: "မာတိကာ မရနိုင်ပါ",
        chapter: "အခန်း",
      },
      pages: {
        title: "စာမျက်နှာများ",
        count_one: "စာမျက်နှာ {{count}}",
        count_other: "စာမျက်နှာ {{count}}",
        empty: "စာမျက်နှာ မရနိုင်ပါ",
        thumbnailAlt: "စာမျက်နှာ {{page}}",
        ariaLabel: "စာမျက်နှာ အကြိုပြ",
      },
      epub: {
        loading: "EPUB တင်နေသည်...",
        errorTitle: "EPUB တင်ရာတွင် အမှား",
        reload: "စာမျက်နှာကို ပြန်တင်ရန်",
        noteIndicatorTitle: "မှတ်စု {{current}} / {{total}}: {{text}}{{suffix}}",
        noteSelectedSuffix: " (ရွေးချယ်ထားသော စာသားမှတ်စု)",
        noteTitleEdit: "မှတ်စု တည်းဖြတ်ရန်",
        noteTitleAdd: "မှတ်စု ထည့်ရန်",
        noteCounter: "({{current}} / {{total}})",
        selectedTextLabel: "ရွေးချယ်ထားသော စာသား:",
        notePlaceholderSelected: "ရွေးချယ်ထားသော စာသားအတွက် မှတ်စုထည့်ပါ...",
        notePlaceholder: "မှတ်စု ရိုက်ပါ",
        noteActionSave: "သိမ်းဆည်းရန်",
        noteActionCreate: "ဖန်တီးရန်",
        contextAddNote: "မှတ်စု ထည့်ရန်",
        contextHighlight: "အလင်းပြ",
        contextSearch: "ရွေးချယ်ထားသော စာလုံးကို ရှာရန်",
        imageAlt: "ပုံ",
        imageLightboxAria: "ချဲ့ထားသော ပုံ",
        closeImagePreview: "ပုံ အကြိုကြည့်ရှုမှု ပိတ်ရန်",
      },
      notifications: {
        featureNotAllowed: "ဤအင်္ဂါရပ် မရနိုင်ပါ။",
        featureComingSoon: "ဤအင်္ဂါရပ် မကြာမီ လာပါလိမ့်မည်။",
        highlightsNotAvailable: "ဤစာရွက်စာတမ်းတွင် အလင်းပြ မရနိုင်ပါ။",
        underlinesNotAvailable: "ဤစာရွက်စာတမ်းတွင် အောက်ကြောင်းထိုး မရနိုင်ပါ။",
        notesNotAvailable: "ဤစာရွက်စာတမ်းတွင် မှတ်စု မရနိုင်ပါ။",
        drawingNotAvailable: "ဤစာရွက်စာတမ်းတွင် ဆွဲချက် မရနိုင်ပါ။",
        bookmarksNotAvailable: "ဤစာရွက်စာတမ်းတွင် စာမျက်နှာမှတ်သား မရနိုင်ပါ။",
        searchNotAvailable: "ဤစာရွက်စာတမ်းတွင် ရှာဖွေမှု မရနိုင်ပါ။",
        commentsNotAvailable: "ဤစာရွက်စာတမ်းတွင် မှတ်ချက် မရနိုင်ပါ။",
        pageOutOfRange: "ဤစာမျက်နှာ မရနိုင်ပါ။",
        aiAssistantComingSoon: "AI အကူအညီ မကြာမီ လာမည်။",
        textBoxComingSoon: "စာသားအကွက် မကြာမီ လာမည်။",
        textToSpeechComingSoon: "စာသားမှ အသံ မကြာမီ လာမည်။",
        sessionExpired: "ဆက်သွယ်မှုကာလ သက်တမ်းကုန်သွားပြီ။ ပြန်လည်မွမ်းမံပြီး ထပ်စမ်းပါ။",
        operationFailed: "{{operation}} မလုပ်နိုင်ပါ။ ထပ်မံစမ်းကြည့်ပါ။",
        copyLimitExceeded: "ကူးယူမှု ကန့်သတ်ချက် ကျော်လွန်သွားပါပြီ။ {{limit}} လုံးသာ ကူးယူထားသည်။",
        copyNotAllowed: "ဤစာရွက်စာတမ်းအတွက် ကူးယူခွင့် မရှိပါ။",
        operations: {
          saveAiPreferences: "AI ဦးစားပေးများ သိမ်းရန်",
          copyText: "စာသား ကူးယူရန်",
          completeAction: "ဤလုပ်ဆောင်ချက် ပြီးမြောက်ရန်",
          saveBookmark: "စာမျက်နှာမှတ်သား သိမ်းရန်",
          deleteBookmark: "စာမျက်နှာမှတ်သား ဖျက်ရန်",
          saveNote: "မှတ်စု သိမ်းရန်",
          updateNote: "မှတ်စု အပ်ဒိတ်လုပ်ရန်",
          deleteNote: "မှတ်စု ဖျက်ရန်",
          saveHighlight: "အသားပေး သိမ်းရန်",
          updateHighlight: "အသားပေး အပ်ဒိတ်လုပ်ရန်",
          deleteHighlight: "အသားပေး ဖျက်ရန်",
          saveUnderline: "မျဉ်းသား သိမ်းရန်",
          deleteUnderline: "မျဉ်းသား ဖျက်ရန်",
          saveDrawing: "ပုံဆွဲ သိမ်းရန်",
          deleteDrawing: "ပုံဆွဲ ဖျက်ရန်",
          updateTextbox: "စာသားအကွက် အပ်ဒိတ်လုပ်ရန်",
          deleteTextbox: "စာသားအကွက် ဖျက်ရန်",
        },
      },
      faq: {
        open: "FAQ ဖွင့်ရန်",
        title: "E-Reader အသုံးပြုပုံ",
      },
      help: {
        close: "အကူအညီ ပိတ်ရန်",
        title: "E-Reader အသုံးပြုမည့် လမ်းညွှန်",
        featuresTab: "အင်္ဂါရပ်များ",
        shortcutsTab: "ကီးဘုတ် ဖိနှိပ်လျှင်",
        gesturesTab: "ထိဆက်မှု လှုပ်ရှားမှု",
        gestures: {
          title: "ထိဆက်မှု လှုပ်ရှားမှု",
          tap: "ထိပါ",
          tapDesc: "အရာတစ်ခုကို ရွေးချယ်ပါ သို့မဟုတ် လင့်ခ်ဖွင့်ပါ",
          doubleTap: "နှစ်ချက်ထိပါ",
          doubleTapDesc: "ကျယ်/ကျစ်",
          swipeLeft: "ဘယ်ဘက်သို့ ဆွဲပေးပါ",
          swipeLeftDesc: "နောက်တစ်မျက်နှာသို့ သွားပါ",
          swipeRight: "ညာဘက်သို့ ဆွဲပေးပါ",
          swipeRightDesc: "ရှေ့တစ်မျက်နှာသို့ သွားပါ",
          swipeUpDown: "အပေါ်/အောက်သို့ ဆွဲပေးပါ",
          swipeUpDownDesc: "စာမျက်နှာကို လှည့်ပါ",
          pinchOut: "ပွမြှင့် (လက်နှစ်ချောင်းနှီး)",
          pinchIn: "ကန့်သတ် (လက်နှစ်ချောင်းနီး)",
          longPress: "ရှည်လျားစွာ ဖိမိပါ",
          longPressDesc: "စာသားကို ရွေးချယ်ပါ သို့မဟုတ် နောက်ထပ်ရွေးချယ်စရာများ ဖွင့်ပါ",
        },
        readingNav: "ဖတ်ခြင်း & နေရာခွင့်",
        navigation: "စာမျက်နှာ နေရာခွင့်",
        navigationDesc: "စာမျက်နှာ ထည့်သွင်းခွင့် အကွက် သို့မဟုတ် ပုံမှန်များကို သုံးရန် မည်သည့် စာမျက်နှာသို့မျ ခုန်လုံးနိုင်သည်",
        zoomControls: "ချဲ့ကားခြင်း ထိန်းချုပ်မှုများ",
        zoomControlsDesc: "ချဲ့ကားမှု အဆင့်ကို ချိန်ညှိ သို့မဟုတ် အနံ/စာမျက်နှာ ကိုက်ညီခြင်း ပုံစံကို ရွေးချယ်ပါ",
        search: "ရှာဖွေခြင်း",
        searchDesc: "စာရွက်စာတမ်းမှ စာသားကို ရှာဖွေ နှင့် သွားလာခြင်း",
        displayDesc: "ဖတ်ရှုမှု ပုံစံနှင့် စာမျက်နှာ အပြင်အဆင် ရွေးချယ်မှုများကို ပြောင်းပါ",
        publicationDesc: "လက်ရှိ ထုတ်ဝေမှုအကြောင်း အသေးစိတ်ကြည့်ရှုပါ",
        organization: "အဖွဲ့အစည်းဆောင်ရွက်ခြင်း",
        bookmarks: "စာမျက်နှာမှတ်သား",
        bookmarksDesc: "လျင်မြန်သော အသုံးပြုမှုအတွက် အရေးကြီးသော စာမျက်နှာများကို သိမ်းဆည်းပါ",
        notes: "မှတ်စုများ",
        notesDesc: "တည်ဆောက်ထားသော စာမျက်နှာများသို့ စာသားမှတ်စုများထည့်သွင်းပါ",
        annotationTools: "အဒီထိုင်မှုကြောင်း ကိရိယာများ",
        highlights: "အလင်းပြများ",
        highlightsDesc: "အရေးကြီးသော စာသားကို အလင်းပြပြီး ထင်ရှားစေပါ",
        underlineDesc: "အဓိက စာပိုဒ်များကို မှတ်သားရန် စာသားကို အောက်မျဉ်းဆွဲပါ",
        drawing: "ဆွဲချက်",
        drawingDesc: "စာမျက်နှာများ ပေါ်တွင် အလွတ်လက်ဆွဲချက် အဒီချက်များ ဆွဲပါ",
        undoRedo: "ယခင်သို့ ပြန်ဆောင်ရွက်ခြင်း & ထပ်မံ ပြုလုပ်ခြင်း",
        undoRedoDesc: "သင့်သည်အဒီချက်များကို ယခင်သို့ပြန် သို့မဟုတ် ထပ်မံပြုလုပ်ပါ",
        comingSoon: "မကြာမီ လာမည်",
        audioReading: "အသံ ဖတ်ခြင်း",
        audioReadingDesc: "စာသားမှ အသံ အသုံးပြု၍ စာရွက်စာတမ်း အကြောင်းအရာကို နားထောင်ပါ",
        aiAssistant: "AI အကူအညီ",
        aiAssistantDesc: "ဉာဏ်ရည်ကျ ထိုးထွင်းသိမြင်မှုများ နှင့် အကျဉ်းချုပ် ရယူပါ",
        shortcuts: {
          navigationAccessibility: "နေရာခွင့် & အသုံးပြုနိုင်သမျှ",
          browseForward: "အပြန်အလှန် အရာများ အကျကြည့်ရှုခြင်း",
          browseBackward: "အပြန်အလှန် အရာများ နောက်တစ်ခါ ကြည့်ရှုခြင်း",
          activateButton: "အလယ်ဂဌုံ ခလုတ်သို့မဟုတ် ဆက်သွယ်ချက်ကို သုံးစွဲခြင်း",
          selectToggle: "အလယ်ဂဌုံ အရာကို ရွေးချယ်ခြင်း သို့မဟုတ် ငင်းကျခြင်း",
          closeDialogs: "ဖွင့်နေသော ဆွေးနွေးမှုများ နှင့် စာရင်းများ ပိတ်ခြင်း",
          nextPrevPage: "နောက်စာမျက်နှာ သို့မဟုတ် ကျေးဇူးအခြို",
          jumpTop: "စာရွက်စာတမ်း စတင်ခြင်းသို့ ခုန်လုံးခြင်း",
          jumpBottom: "စာရွက်စာတမ်း အဆုံးသို့ ခုန်လုံးခြင်း",
          zoomViewControls: "ချဲ့ကားခြင်း & မြင်ကွင်းထိန်းချုပ်မှုများ",
          zoomIn: "ချဲ့ကားခြင်း",
          zoomOut: "အကျုံးချခြင်း",
          fitWidth: "အနံအတိုင်း ကိုက်ညီခြင်း",
          fitPage: "စာမျက်နှာအတိုင်း ကိုက်ညီခြင်း",
          editingAnnotations: "ပြင်ဆင်ခြင်း & အဒီချက်",
          undo: "နောက်ဆုံး လုပ်ဆောင်မှုကို ယခင်သို့ပြန်ခြင်း",
          redo: "နောက်ဆုံး လုပ်ဆောင်မှုကို ထပ်မံပြုလုပ်ခြင်း",
          toggleHighlight: "အလင်းပြ ပုံစံကို ငင်းကျခြင်း",
          drawingBrush: "ဆွဲချက် တုတ်ကို ငင်းကျခြင်း",
          toggleNotes: "မှတ်စု ဘေးဖြစ်ခြင်းကို ငင်းကျခြင်း",
          toggleBookmarks: "စာမျက်နှာမှတ်သား ဘေးဖြစ်ခြင်းကို ငင်းကျခြင်း",
          openToc: "အပြည့်အစုံအငယ်များကိုဖွင့်ခြင်း",
          saveBookmark: "စာမျက်နှာမှတ်သားသိမ်းဆည်းခြင်း",
          searchContent: "ရှာဖွေခြင်း & အကြောင်းအရာ",
          searchWithin: "စာရွက်စာတမ်းအတွင်း ရှာဖွေခြင်း",
          copyText: "ရွေးချယ်ထားသော စာသား ကူးယူခြင်း",
          selectAll: "လက်ရှိစာမျက်နှာ သို့မဟုတ် မြင်ကွင်းရှိ စာသားအားလုံးကို ရွေးချယ်ပါ",
        },
        translateDesc: "ရွေးထားသော စာသားကို AI ဖြင့် ဘာသာပြန်ပါ",
      },
      loading: {
        initializing: "စတင်နေသည်...",
        restoringSession: "ဆက်ရှင် ပြန်လည်ပြုပြင်နေသည်...",
        fetchingAccessToken: "အသုံးပြုခွင့် တိုကင် ရယူနေသည်...",
        loadingDocument: "စာရွက်စာတမ်း တင်နေသည်...",
        ariaLabel: "ဖွင့်နေသည်",
        authenticating: "အထောက်အထား စစ်ဆေးနေသည်...",
        finalizing: "နောက်ဆုံးလုပ်ဆောင်နေသည်...",
      },
      errors: {
        failedToLoadPdf: "PDF မတင်နိုင်ပါ",
        failedToLoadEpub: "EPUB မတင်နိုင်ပါ",
        unsupportedFileType: "မထောက်ပံ့သော ဖိုင်အမျိုးအစား။ PDF သို့ EPUB တင်ပါ။",
        errorReadingFile: "ဖိုင်ဖတ်ရာတွင် အမှား ဖြစ်ခဲ့သည်။",
        searchFailed: "ရှာဖွေမှု မအောင်မြင်ပါ",
        failedToRestoreSession: "ဆက်ရှင် ပြန်မရနိုင်ပါ။",
        failedToInitializeReader: "တိုကင်မှ ဖတ်ရှုကိရိယာ စတင်မရပါ။",
      },
      readingAssistant: {
        title: "စာဖတ်အကူအညီ",
        close: "စာဖတ်အကူအညီကို ပိတ်ရန်",
        resize: "စာဖတ်အကူအညီ အရွယ်အစားပြောင်းရန်",
        resizeHint: "အရွယ်အစားပြောင်းရန် ဖိဆွဲပါ။ ပြန်သတ်မှတ်ရန် နှစ်ချက်နှိပ်ပါ။",
        tabsLabel: "စာဖတ်အကူအညီ တက်ဘ်များ",
        tabs: {
          summary: "အနှစ်ချုပ်",
          askAi: "AI ကိုမေးပါ",
          quiz: "ပဟေဠိ",
        },
        status: {
          loading: "စစ်ဆေးနေသည်…",
          processing: "ဤစာရွက်သည် AI အတွက် ပြင်ဆင်နေဆဲဖြစ်သည်။ ခဏအကြာတွင် ထပ်မံကြိုးစားပါ။",
          unavailable: "ဤစာရွက်အတွက် AI လုပ်ဆောင်ချက်များ မရရှိနိုင်ပါ။",
          failed: "စာရွက်လုပ်ဆောင်မှု မအောင်မြင်ပါ။ AI လုပ်ဆောင်ချက်များ မရရှိနိုင်ပါ။",
          error: "AI လုပ်ဆောင်ချက်များ ဖွင့်မရပါ။ {{message}}",
        },
        summary: {
          typesLabel: "အနှစ်ချုပ် အမျိုးအစား",
          types: {
            quick: "အနှစ်ချုပ် အမြန်",
            detailed: "အနှစ်ချုပ် အသေးစိတ်",
            chapter: "အခန်းအလိုက် အနှစ်ချုပ်",
          },
          cardTitles: {
            quick: "အနှစ်ချုပ် အမြန်",
            detailed: "အနှစ်ချုပ် အသေးစိတ်",
            chapter: "အခန်းအလိုက် အနှစ်ချုပ်",
          },
          welcomeTitle: "စာဖတ်အကူအညီ",
          welcome: "AI စာဖတ်အတွေ့အကြုံမှ ကြိုဆိုပါသည်။ အဆင်သင့်ဖြစ်သောအခါ အနှစ်ချုပ် ရွေးချယ်ပါ။",
          loading: "အနှစ်ချုပ် ဖန်တီးနေသည်",
          error: "အနှစ်ချုပ် ဖန်တီးမရပါ။ {{message}}",
          empty: "ဖန်တီးရန် အနှစ်ချုပ် အမျိုးအစား ရွေးပါ။",
          chooseChapter: "အနှစ်ချုပ်ဖန်တီးရန် အောက်တွင် အခန်းရွေးပါ။",
          chapterListLabel: "အခန်းများ",
          noChapters: "ဤစာရွက်အတွက် အခန်းများ မရှိပါ။",
          backToTypes: "နောက်သို့",
          regenerate: "ပြန်ဖန်တီးရန်",
        },
        askAi: {
          placeholder: "ဤစာအုပ်အကြောင်း မေးချင်သည်များကို မေးပါ...",
          submit: "မေးခွန်း ပို့ရန်",
          empty: "စကားပြောရန် မေးခွန်းတစ်ခု မေးပါ။",
          sending: "စဉ်းစားနေသည်",
          error: "အဖြေ မရရှိပါ။ {{message}}",
          export: "တင်ပို့ရန်",
          newChat: "စကားပြော အသစ်",
        },
        quiz: {
          title: "ပဟေဠိ ဖြေရန်",
          subtitle: "စမ်းသပ်လိုသည့် အပိုင်းကို ရွေးပါ။",
          cta: "ပဟေဠိ စတင်ရန်",
          loading: "ပဟေဠိ ဖန်တီးနေသည်",
          error: "ပဟေဠိ ဖန်တီးမရပါ။ {{message}}",
          modalTitle: "AI ပဟေဠိ",
          disclaimer: "AI ဖန်တီးထားသော အကြောင်းအရာ၊ ကိုးကားရန်သာ။",
          close: "ပဟေဠိ ပိတ်ရန်",
          checkAnswer: "အဖြေ စစ်ရန်",
          explanation: "ရှင်းလင်းချက်",
          previous: "ယခင်",
          next: "နောက်မေးခွန်း",
          finish: "ပြီးဆုံးရန်",
          progress: "မေးခွန်း {{current}} / {{total}}",
          answerRequired: "ဆက်ရန် ဤမေးခွန်းကို ဖြေပါ။",
          completedTitle: "ပဟေဠိ ပြီးဆုံးပါပြီ!",
          yourScore: "သင့်ရမှတ်",
          completedMessage: "ပဟေဠိကို အောင်မြင်စွာ ပြီးဆုံးပါပြီ။",
          reattempt: "ပဟေဠိ ပြန်ဖြေရန်",
          save: "သိမ်းရန်",
          saving: "သိမ်းနေသည်…",
          saved: "သိမ်းပြီး",
          saveError: "ရလဒ် သိမ်းမရပါ။ {{message}}",
          deleteError: "ရလဒ် ဖျက်မရပါ။ {{message}}",
          deleteResult: "သိမ်းထားသော ပဟေဠိ ဖျက်ရန်",
          deletedToast: "ပဟေဠိ ဖျက်ပြီး",
          recentQuizzes: "မကြာသေးမီ ပဟေဠိများ",
          seeDetails: "အသေးစိတ် ကြည့်ရန်",
          showDetails: "အသေးစိတ် ပြရန်",
          hideDetails: "အသေးစိတ် ဖုံးရန်",
          correct: "မှန်",
          incorrect: "မှား",
          multipleChoice: "ရွေးချယ်မှု များ",
          questionStatusAria: "မေးခွန်း {{number}}: {{status}}",
          backToDashboard: "ပဟေဠိ ဒက်ရှ်ဘုတ်",
          scopeLabel: "ပဟေဠိ အတိုင်းအတာ",
          scopeBook: "စာအုပ်အလိုက်",
          scopeChapter: "အခန်းအလိုက်",
          scopePage: "စာမျက်နှာအလိုက်",
          scopePageTitle: "စာမျက်နှာ {{page}}",
          scoreAria: "ရမှတ် {{correct}} / {{total}}",
          answerOptions: "အဖြေ ရွေးချယ်မှုများ",
          navigationAria: "ပဟေဠိ လမ်းညွှန်",
          noQuestions: "ပဟေဠိ မေးခွန်းများ ပြန်မရပါ",
          feedback: {
            greatJob: "ကောင်းလိုက်တာ!",
            goodEffort: "ကြိုးစားမှု ကောင်းပါတယ်!",
            keepPracticing: "ဆက်လက် လေ့ကျင့်ပါ!",
          },
        },
        menu: {
          preferences: "AI ဦးစားပေးများ",
          citation: "AI ကိုးကား",
          copy: "AI ကူးယူ",
          quizzes: "AI ပဟေဠိများ",
          notes: "မှတ်စုများ",
          prefs: {
            aiLanguage: "နှစ်သက်သော ဘာသာစကား",
            citationEnabled: "ကိုးကားချက်များ ပြရန်",
            contextInclusionEnabled: "စာဖတ် အကြောင်းအရာ ထည့်သွင်းရန်",
          },
        },
      },
      pullouts: {
        fallbackTitle: "ပေါ့ပ်အပ်",
        hintLabel: "အကြံပြုချက်:",
        hintAvailable: "အကြံပြုချက် ရှိသည်",
        expandHint: "အကြံပြုချက် ချဲ့ရန်",
        collapseHint: "အကြံပြုချက် ခေါက်ရန်",
      },
      publicationDetails: {
        title: "ထုတ်ဝေမှု အသေးစိတ်",
        close: "ထုတ်ဝေမှု အသေးစိတ် ပိတ်ရန်",
        copy: "ထုတ်ဝေမှု အသေးစိတ် ကူးယူရန်",
        copied: "ကလစ်ဘုတ်သို့ ကူးပြီး",
        description: "ဖော်ပြချက်",
        noData: "ဒေတာ မရှိပါ",
        empty: "ဤစာရွက်အတွက် ထုတ်ဝေမှု အသေးစိတ် မရှိပါ။",

        fields: {
          title: "ခေါင်းစဉ်",
          author: "စာရေးသူ",
          code: "ကုဒ်",
          type: "အမျိုးအစား",
          language: "ဘာသာစကား",
          original_publisher: "မူရင်းထုတ်ဝေသူ",
          series: "စီးရီး",
          edition: "ထုတ်ဝေမှု",
          pages: "စာမျက်နှာများ",
          pisbn13: "PISBN13",
          publication_year: "ထုတ်ဝေသည့်နှစ်",
          copyright_year: "မူပိုင်ခွင့်နှစ်",
          read_direction: "ဖတ်ရှုသည့်ဦးတည်ချက်",
          content_type: "အကြောင်းအရာအမျိုးအစား",
        },
      },
    },
  },
  hi: {
    translation: {
      common: {
        cancel: "रद्द करें",
        close: "बंद करें",
        menu: "मेन्यू",
        search: "खोजें",
        bookmarks: "बुकमार्क",
        notes: "नोट्स",
        pages: "पृष्ठ",
        tableOfContents: "विषय सूची",
        page: "पृष्ठ",
        section: "अनुभाग",
        loading: "लोड हो रहा है...",
        submit: "सबमिट",
        apply: "लागू करें",
        remove: "हटाएँ",
        error: "त्रुटि",
        language: "भाषा",
        theme: "थीम",
        light: "हल्का",
        dark: "गहरा",
        on: "चालू",
        off: "बंद",
        showMore: "और दिखाएँ",
        showLess: "कम दिखाएँ",
        undo: "पूर्ववत करें",
        redo: "फिर करें",
        underline: "रेखांकित",
        highlight: "हाइलाइट",
        textbox: "टेक्स्ट बॉक्स",
        document: "दस्तावेज़",
        back: "वापस",
      },
      toolbar: {
        expand: "टूलबार फैलाएँ",
        collapse: "टूलबार संक्षिप्त करें",
        aiAssistant: "AI सहायक से पूछें",
        aiAssistantComingSoon: "AI सहायक से पूछें (जल्द आ रहा है)",
        searchNotAllowed: "खोज अनुमत नहीं है",
        textToSpeechComingSoon: "टेक्स्ट-टू-स्पीच (जल्द आ रहा है)",
        addBookmark: "बुकमार्क जोड़ें",
        removeBookmark: "बुकमार्क हटाएँ",
        bookmarked: "बुकमार्क किया गया",
        bookmarksNotAllowed: "बुकमार्क अनुमत नहीं हैं",
        moreOptions: "अधिक विकल्प",
        display: "प्रदर्शन",
        lightHint: "हल्का बैकग्राउंड और गहरा टेक्स्ट",
        darkHint: "गहरा बैकग्राउंड और हल्का टेक्स्ट",
        pageView: "पृष्ठ दृश्य",
        singlePage: "एकल पृष्ठ",
        singlePageHint: "एक बार में एक पृष्ठ स्क्रॉल करें",
        doublePage: "दो पृष्ठ",
        doublePageHint: "पृष्ठों को साथ-साथ देखें",
        view: "रंग मोड",
        share: "साझा करें",
        download: "डाउनलोड",
        citation: "उद्धरण",
        print: "प्रिंट",
        displayMenu: "डिस्प्ले मेनू",
        displayMenuItems: {
          colorMode: "रंग मोड",
          fontSize: "फ़ॉन्ट आकार",
          fontFamily: "फ़ॉन्ट",
          lineHeight: "लाइन ऊँचाई",
          increaseLineHeight: "लाइन ऊँचाई बढ़ाएँ",
          decreaseLineHeight: "लाइन ऊँचाई घटाएँ",
          layout: "लेआउट",
          rotate: "घुमाएँ",
          readingDirection: "पढ़ने की दिशा",
          rotateLeft: "बाएँ घुमाएँ",
          rotateRight: "दाएँ घुमाएँ",
          ltr: "बाएँ से दाएँ",
          rtl: "दाएँ से बाएँ",
          fonts: {
            original: "मूल",
            sans: "Sans",
            serif: "Serif",
          },
          colors: {
            light: "हल्का",
            dark: "गहरा",
            mint: "मिंट",
            sepia: "सीपिया",
          },
        },
      },
      mobile: {
        searchPlaceholder: "कीवर्ड खोजें...",
        cancelSearch: "खोज रद्द करें",
        faq: "सामान्य प्रश्न",
      },
      menu: {
        close: "मेन्यू बंद करें",
        documentPageCount: "पृष्ठ {{current}} में से {{total}}",
      },
      rightToolbar: {
        showToc: "विषय सूची दिखाएँ",
        hideToc: "विषय सूची छिपाएँ",
        showPagesThumbnails: "पृष्ठ थंबनेल दिखाएँ",
        hidePagesThumbnails: "पृष्ठ थंबनेल छिपाएँ",
        showBookmarks: "बुकमार्क दिखाएँ",
        hideBookmarks: "बुकमार्क छिपाएँ",
        info: "प्रकाशन जानकारी",
        showPublicationDetails: "प्रकाशन विवरण दिखाएँ",
        hidePublicationDetails: "प्रकाशन विवरण छिपाएँ",
        askAi: "AI से पूछें",
        readingGroup: "पठन समूह",
        showNotes: "नोट्स दिखाएँ",
        hideNotes: "नोट्स छिपाएँ",
        myNotebook: "मेरी नोटबुक",
        clickToEnterPage: "पृष्ठ संख्या दर्ज करने के लिए क्लिक करें",
        currentPageLabel: "वर्तमान पृष्ठ {{current}}। बदलने के लिए क्लिक करें।",
        previousPage: "पिछला पृष्ठ",
        nextPage: "अगला पृष्ठ",
        zoomOut: "ज़ूम आउट",
        zoomIn: "ज़ूम इन",
        resetZoom: "ज़ूम रीसेट करें",
        resetZoomTitle: "ज़ूम 100% पर रीसेट करें",
        decreaseFontSize: "फॉन्ट आकार कम करना",
        increaseFontSize: "फॉन्ट आकार बढ़ाना",
        resetFontSize: "फॉन्ट आकार रीसेट करें",
        resetFontSizeTitle: "फॉन्ट आकार को 100% पर रीसेट करें",
        viewModeOptions: "दृश्य विकल्प",
        fitToWidth: "चौड़ाई के अनुसार फिट करें",
        fitToPage: "पृष्ठ के अनुसार फिट करें",
        enterFullscreen: "फुलस्क्रीन करें",
        exitFullscreen: "फुलस्क्रीन से बाहर निकलें",
        enterPageNumber: "पृष्ठ संख्या दर्ज करें",
        pageInputPlaceholder: "{{min}}-{{max}}",
        pageInputTitle: "पृष्ठ संख्या दर्ज करें ({{min}}-{{max}})",
        pageInputInvalid: "कृपया वैध पृष्ठ संख्या दर्ज करें",
        pageInputOutOfRange: "पृष्ठ 1 और {{total}} के बीच होना चाहिए",
        showReadingAssistant: "रीडिंग असिस्टेंट दिखाएँ",
        hideReadingAssistant: "रीडिंग असिस्टेंट छिपाएँ",
      },
      floatingToolbar: {
        ariaLabel: "फ्लोटिंग टूलबार",
        dragToMove: "स्थानांतरित करने के लिए खींचें",
        dragToolbar: "टूलबार खींचें",
        notesOn: "नोट्स चालू करें",
        notesOff: "नोट्स बंद करें",
        notesNotAllowed: "नोट्स उपलब्ध नहीं हैं",
        notesOnLabel: "नोट्स: चालू",
        notesOffLabel: "नोट्स: बंद",
        drawingOn: "ड्रॉइंग चालू करें",
        drawingOff: "ड्रॉइंग बंद करें",
        drawingNotAllowed: "ड्रॉइंग उपलब्ध नहीं है",
        drawingOnLabel: "ड्रॉइंग: चालू",
        drawingOffLabel: "ड्रॉइंग: बंद",
        textBoxComingSoon: "टेक्स्ट बॉक्स (जल्द आ रहा है)",
        textboxNotAllowed: "Text box not allowed",
        textboxOn: "टेक्स्ट बॉक्स चालू करें",
        textboxOff: "टेक्स्ट बॉक्स बंद करें",
        textboxOnLabel: "टेक्स्ट बॉक्स: चालू",
        textboxOffLabel: "टेक्स्ट बॉक्स: बंद",
        highlightOn: "हाइलाइट चालू करें",
        highlightOff: "हाइलाइट बंद करें",
        highlightsNotAllowed: "हाइलाइट उपलब्ध नहीं है",
        highlightOnLabel: "हाइलाइट: चालू",
        highlightOffLabel: "हाइलाइट: बंद",
        underlineOn: "रेखांकित चालू करें",
        underlineOff: "रेखांकित बंद करें",
        underlineOnLabel: "रेखांकित: चालू",
        underlineOffLabel: "रेखांकित: बंद",
        highlightColorLabel: "हाइलाइट रंग",
        colorRed: "लाल",
        colorOrange: "नारंगी",
        colorYellow: "पीला",
        colorGreen: "हरा",
        colorLightBlue: "हल्का नीला",
        colorPurple: "बैंगनी",
        underlinesNotAllowed: "रेखांकन उपलब्ध नहीं है",
        undo: "पूर्ववत करें ({{ctrl}}+Z)",
        redo: "फिर करें ({{ctrl}}+Y)",
        undoCooldown: "पूर्ववत करें (कृपया प्रतीक्षा करें)",
        redoCooldown: "फिर से करें (कृपया प्रतीक्षा करें)",
      },
      contextMenu: {
        addNote: "नोट जोड़ें",
        highlight: "हाइलाइट",
        underline: "रेखांकित",
        copy: "कॉपी",
        removeHighlight: "हाइलाइट हटाएं",
        removeUnderline: "रेखांकन हटाएं",
        searchSelected: "चयनित शब्द खोजें",
        selectionToolbar: "चयन मेनू",
        askAi: "AI से पूछें",
        share: "शेयर करें",
        translate: "अनुवाद करें",
        comingSoon: "जल्द आ रहा है",
        translationTitle: "अनुवाद",
        translating: "अनुवाद हो रहा है…",
        translationFailed: "अनुवाद विफल",
      },
      readerShell: {
        loadingDocument: "दस्तावेज़ लोड हो रहा है...",
        documentControls: "दस्तावेज़ नियंत्रण",
      },
      emptyState: {
        errorAlt: "त्रुटि",
        documentAlt: "दस्तावेज़",
        unableToLoad: "दस्तावेज़ लोड नहीं हो सका",
        noDocument: "कोई दस्तावेज़ लोड नहीं है",
        requestDoc: "शुरू करने के लिए अपनी लाइब्रेरी से दस्तावेज़ अनुरोध करें",
      },
      search: {
        ariaLabel: "खोज परिणाम",
        searchResults: "खोज परिणाम",
        close: "खोज बंद करें",
        placeholder: "दस्तावेज़ में खोजें...",
        clear: "खोज साफ करें",
        searching: "खोज रहे हैं...",
        enterQuery: "दस्तावेज़ में टेक्स्ट खोजने के लिए क्वेरी दर्ज करें",
        noResults: "\"{{query}}\" के लिए कोई परिणाम नहीं मिले",
        resultsCount_one: "{{count}} परिणाम मिले",
        resultsCount_other: "{{count}} परिणाम मिले",
        matchCount_one: "{{count}} मिलान",
        matchCount_other: "{{count}} मिलान",
        navigateToResult: "इस परिणाम पर जाने के लिए क्लिक करें",
      },
      bookmarks: {
        title: "बुकमार्क",
        close: "बुकमार्क बंद करें",
        loading: "बुकमार्क लोड हो रहे हैं...",
        error: "बुकमार्क लोड करने में त्रुटि: {{error}}",
        noItems: "अभी कोई बुकमार्क नहीं",
        navigate: "इस बुकमार्क पर जाने के लिए क्लिक करें",
        remove: "बुकमार्क हटाएँ",
        removeLabel: "बुकमार्क हटाएँ {{label}}",
        deleteError: "बुकमार्क हटाने में विफल",
        navigateLabel: "{{label}} पर जाएँ",
        defaultLabel: "बुकमार्क {{page}}",
      },
      notes: {
        title: "मेरी नोटबुक",
        close: "मेरी नोटबुक बंद करें",
        navigate: "इस नोट पर जाने के लिए क्लिक करें",
        ariaLabel: "नोट: {{preview}} पृष्ठ {{page}} {{created}}",
        createdOn: "{{date}} को बनाया गया",
        pageTitle: "पृष्ठ {{page}}",
        remove: "नोट हटाएँ",
        removeLabel: "पृष्ठ {{page}} से नोट हटाएँ",
        none: "अभी कोई नोट नहीं",
        noItems: "अभी कोई आइटम नहीं",
        share: "नोटबुक साझा करें",
        searchPlaceholder: "यहाँ लिखें",
        clearSearch: "खोज साफ़ करें",
        tabsLabel: "नोटबुक फ़िल्टर",
        tabs: {
          all: "सभी",
          highlight: "हाइलाइट",
          underline: "अंडरलाइन",
          note: "नोट",
        },
        resultsFound_one: "{{count}} परिणाम मिला",
        resultsFound_other: "{{count}} परिणाम मिले",
        copyItem: "आइटम कॉपी करें",
        shareItem: "आइटम साझा करें",
      },
      toc: {
        title: "विषय सूची",
        close: "विषय सूची बंद करें",
        untitled: "शीर्षक रहित अनुभाग",
        empty: "कोई विषय सूची उपलब्ध नहीं",
        noItems: "कोई विषय सूची उपलब्ध नहीं",
        chapter: "अध्याय",
      },
      pages: {
        title: "पृष्ठ",
        count_one: "{{count}} पृष्ठ",
        count_other: "{{count}} पृष्ठ",
        empty: "कोई पृष्ठ उपलब्ध नहीं",
        thumbnailAlt: "पृष्ठ {{page}}",
        ariaLabel: "पृष्ठ थंबनेल",
      },
      epub: {
        loading: "EPUB लोड हो रहा है...",
        errorTitle: "EPUB लोड करने में त्रुटि",
        reload: "पृष्ठ पुनः लोड करें",
        noteIndicatorTitle: "नोट {{current}} / {{total}}: {{text}}{{suffix}}",
        noteSelectedSuffix: " (चयनित टेक्स्ट नोट)",
        noteTitleEdit: "नोट संपादित करें",
        noteTitleAdd: "नोट जोड़ें",
        noteCounter: "({{current}} / {{total}})",
        selectedTextLabel: "चयनित टेक्स्ट:",
        notePlaceholderSelected: "चयनित टेक्स्ट के बारे में नोट जोड़ें...",
        notePlaceholder: "नोट लिखें",
        noteActionSave: "सहेजें",
        noteActionCreate: "बनाएं",
        contextAddNote: "नोट जोड़ें",
        contextHighlight: "हाइलाइट",
        contextSearch: "चयनित शब्द खोजें",
        imageAlt: "छवि",
        imageLightboxAria: "बड़ी छवि",
        closeImagePreview: "छवि पूर्वावलोकन बंद करें",
      },
      notifications: {
        featureNotAllowed: "यह सुविधा उपलब्ध नहीं है।",
        featureComingSoon: "यह सुविधा जल्द ही आ रही है।",
        highlightsNotAvailable: "इस दस्तावेज़ के लिए हाइलाइट उपलब्ध नहीं है।",
        underlinesNotAvailable: "इस दस्तावेज़ के लिए अंडरलाइन उपलब्ध नहीं है।",
        notesNotAvailable: "इस दस्तावेज़ के लिए नोट्स उपलब्ध नहीं हैं।",
        drawingNotAvailable: "इस दस्तावेज़ के लिए ड्रॉइंग उपलब्ध नहीं है।",
        bookmarksNotAvailable: "इस दस्तावेज़ के लिए बुकमार्क उपलब्ध नहीं हैं।",
        searchNotAvailable: "इस दस्तावेज़ के लिए खोज उपलब्ध नहीं है।",
        commentsNotAvailable: "इस दस्तावेज़ के लिए टिप्पणियाँ उपलब्ध नहीं हैं।",
        pageOutOfRange: "यह पृष्ठ उपलब्ध नहीं है।",
        aiAssistantComingSoon: "AI सहायक जल्द आ रहा है।",
        textBoxComingSoon: "टेक्स्ट बॉक्स जल्द आ रहे हैं।",
        textToSpeechComingSoon: "टेक्स्ट-टू-स्पीच जल्द आ रहा है।",
        sessionExpired: "आपका सत्र समाप्त हो गया है। कृपया रीफ्रेश करें और फिर से प्रयास करें।",
        operationFailed: "{{operation}} नहीं कर सके। कृपया पुनः प्रयास करें।",
        copyLimitExceeded: "कॉपी सीमा पार हो गई। केवल {{limit}} अक्षर कॉपी किए गए।",
        copyNotAllowed: "इस दस्तावेज़ के लिए कॉपी करने की अनुमति नहीं है।",
        operations: {
          saveAiPreferences: "AI प्राथमिकताएँ सहेजें",
          copyText: "टेक्स्ट कॉपी करें",
          completeAction: "यह क्रिया पूरी करें",
          saveBookmark: "बुकमार्क सहेजें",
          deleteBookmark: "बुकमार्क हटाएँ",
          saveNote: "नोट सहेजें",
          updateNote: "नोट अपडेट करें",
          deleteNote: "नोट हटाएँ",
          saveHighlight: "हाइलाइट सहेजें",
          updateHighlight: "हाइलाइट अपडेट करें",
          deleteHighlight: "हाइलाइट हटाएँ",
          saveUnderline: "अंडरलाइन सहेजें",
          deleteUnderline: "अंडरलाइन हटाएँ",
          saveDrawing: "ड्रॉइंग सहेजें",
          deleteDrawing: "ड्रॉइंग हटाएँ",
          updateTextbox: "टेक्स्ट बॉक्स अपडेट करें",
          deleteTextbox: "टेक्स्ट बॉक्स हटाएँ",
        },
      },
      faq: {
        open: "FAQ खोलें",
        title: "E-Reader का उपयोग कैसे करें",
      },
      help: {
        close: "सहायता बंद करें",
        title: "ई-रीडर उपयोगकर्ता गाइड",
        featuresTab: "सुविधाएं",
        shortcutsTab: "कीबोर्ड शॉर्टकट",
        gesturesTab: "टच जेस्चर",
        gestures: {
          title: "टच जेस्चर",
          tap: "टैप",
          tapDesc: "किसी आइटम का चयन करें या लिंक खोलें",
          doubleTap: "डबल टैप",
          doubleTapDesc: "ज़ूम इन या ज़ूम आउट",
          swipeLeft: "बाएं स्वाइप करें",
          swipeLeftDesc: "अगले पृष्ठ पर जाएँ",
          swipeRight: "दाएं स्वाइप करें",
          swipeRightDesc: "पिछले पृष्ठ पर जाएँ",
          swipeUpDown: "ऊपर/नीचे स्वाइप करें",
          swipeUpDownDesc: "पृष्ठ को स्क्रॉल करें",
          pinchOut: "पिंच आउट (दो उंगलियाँ फैलाएँ)",
          pinchIn: "पिंच इन (दो उंगलियाँ जोड़ें)",
          longPress: "लंबा दबाएँ",
          longPressDesc: "पाठ चुनें या अतिरिक्त विकल्प खोलें",
        },
        readingNav: "पढ़ना और नेविगेशन",
        navigation: "पृष्ठ नेविगेशन",
        navigationDesc: "किसी भी पृष्ठ पर जाने के लिए पृष्ठ इनपुट फ़ील्ड या थंबनेल का उपयोग करें",
        zoomControls: "ज़ूम नियंत्रण",
        zoomControlsDesc: "ज़ूम स्तर को समायोजित करें या चौड़ाई/पृष्ठ मोड को फिट करने के लिए चुनें",
        search: "खोजें",
        searchDesc: "दस्तावेज़ में पाठ खोजें और नेविगेट करें",
        displayDesc: "पठन दिखावट और पृष्ठ लेआउट विकल्प बदलें",
        publicationDesc: "वर्तमान प्रकाशन के बारे में विवरण देखें",
        organization: "संगठन",
        bookmarks: "बुकमार्क",
        bookmarksDesc: "तेज़ पहुंच के लिए महत्वपूर्ण पृष्ठ सहेजें",
        notes: "नोट्स",
        notesDesc: "विशिष्ट पृष्ठों में पाठ नोट्स जोड़ें",
        annotationTools: "एनोटेशन उपकरण",
        highlights: "हाइलाइट्स",
        highlightsDesc: "महत्वपूर्ण पाठ को हाइलाइट करें",
        underlineDesc: "मुख्य अंश चिह्नित करने के लिए पाठ को रेखांकित करें",
        drawing: "ड्राइंग",
        drawingDesc: "पृष्ठों पर सीधे हाथ से खींचे गए एनोटेशन बनाएं",
        undoRedo: "पूर्ववत करें और दोहराएं",
        undoRedoDesc: "अपने एनोटेशन को पूर्ववत या दोहराएं",
        comingSoon: "जल्द आ रहा है",
        audioReading: "ऑडियो पढ़ना",
        audioReadingDesc: "पाठ-से-भाषण के साथ दस्तावेज़ सामग्री सुनें",
        aiAssistant: "एआई सहायक",
        aiAssistantDesc: "बुद्धिमान अंतर्दृष्टि और सारांश प्राप्त करें",
        shortcuts: {
          navigationAccessibility: "नेविगेशन और पहुंच",
          browseForward: "इंटरैक्टिव तत्वों के माध्यम से आगे ब्राउज़ करें",
          browseBackward: "इंटरैक्टिव तत्वों के माध्यम से पीछे ब्राउज़ करें",
          activateButton: "फोकस बटन या लिंक को सक्रिय करें",
          selectToggle: "फोकस किए गए तत्व का चयन करें या टॉगल करें",
          closeDialogs: "खुले संवाद और मेनू बंद करें",
          nextPrevPage: "अगला या पिछला पृष्ठ",
          jumpTop: "दस्तावेज़ की शुरुआत पर जाएं",
          jumpBottom: "दस्तावेज़ के अंत में जाएं",
          zoomViewControls: "ज़ूम और दृश्य नियंत्रण",
          zoomIn: "ज़ूम इन करें",
          zoomOut: "ज़ूम आउट करें",
          fitWidth: "चौड़ाई में फिट करें",
          fitPage: "पृष्ठ में फिट करें",
          editingAnnotations: "संपादन और एनोटेशन",
          undo: "अंतिम कार्रवाई को पूर्ववत करें",
          redo: "अंतिम कार्रवाई दोहराएं",
          toggleHighlight: "हाइलाइट मोड को टॉगल करें",
          drawingBrush: "ड्राइंग ब्रश को टॉगल करें",
          toggleNotes: "नोट्स साइडबार को टॉगल करें",
          toggleBookmarks: "बुकमार्क साइडबार को टॉगल करें",
          openToc: "विषय सूची खोलें",
          saveBookmark: "बुकमार्क सहेजें",
          searchContent: "खोज और सामग्री",
          searchWithin: "दस्तावेज़ में खोजें",
          copyText: "चयनित पाठ की प्रतिलिपि बनाएं",
          selectAll: "वर्तमान पृष्ठ या दृश्य में सभी पाठ चुनें",
        },
        translateDesc: "चयनित पाठ का AI से अनुवाद करें",
      },
      loading: {
        initializing: "प्रारंभ हो रहा है...",
        restoringSession: "सत्र पुनर्स्थापित हो रहा है...",
        fetchingAccessToken: "एक्सेस टोकन प्राप्त हो रहा है...",
        loadingDocument: "दस्तावेज़ लोड हो रहा है...",
        ariaLabel: "लोड हो रहा है",
        authenticating: "प्रमाणित हो रहा है...",
        finalizing: "पूरा किया जा रहा है...",
      },
      landingPage: {
        uploadTitle: "दस्तावेज़ अपलोड करें",
        uploadSubtitle: "यहाँ PDF या EPUB फ़ाइल को ड्रैग और ड्रॉप करें, या अपलोड करने के लिए क्लिक करें",
        supportedFormats: "समर्थित प्रारूप: PDF, EPUB",
        uploadAriaLabel: "PDF या EPUB फ़ाइल अपलोड करें",
      },
      errors: {
        failedToLoadPdf: "PDF लोड नहीं हो सका",
        failedToLoadEpub: "EPUB लोड नहीं हो सका",
        unsupportedFileType: "समर्थित नहीं फ़ाइल प्रकार। कृपया PDF या EPUB अपलोड करें।",
        errorReadingFile: "फ़ाइल पढ़ने में त्रुटि।",
        searchFailed: "खोज विफल रही",
        failedToRestoreSession: "सत्र पुनर्स्थापित नहीं हो सका।",
        failedToInitializeReader: "टोकन से रीडर प्रारंभ नहीं हो सका।",
      },
      readingAssistant: {
        title: "रीडिंग असिस्टेंट",
        close: "रीडिंग असिस्टेंट बंद करें",
        resize: "रीडिंग असिस्टेंट का आकार बदलें",
        resizeHint: "आकार बदलने के लिए खींचें। रीसेट के लिए डबल-क्लिक करें।",
        tabsLabel: "रीडिंग असिस्टेंट टैब",
        tabs: {
          summary: "सारांश",
          askAi: "AI से पूछें",
          quiz: "क्विज़",
        },
        status: {
          loading: "जाँच हो रही है…",
          processing: "यह दस्तावेज़ अभी भी AI के लिए तैयार हो रहा है। कृपया थोड़ी देर बाद फिर कोशिश करें।",
          unavailable: "इस दस्तावेज़ के लिए AI सुविधाएँ उपलब्ध नहीं हैं।",
          failed: "दस्तावेज़ प्रोसेसिंग विफल। AI सुविधाएँ उपलब्ध नहीं हैं।",
          error: "AI सुविधाएँ लोड नहीं हो सकीं। {{message}}",
        },
        summary: {
          typesLabel: "सारांश प्रकार",
          types: {
            quick: "संक्षिप्त सारांश",
            detailed: "विस्तृत सारांश",
            chapter: "अध्याय-वार सारांश",
          },
          cardTitles: {
            quick: "संक्षिप्त सारांश",
            detailed: "विस्तृत सारांश",
            chapter: "अध्याय-वार सारांश",
          },
          welcomeTitle: "रीडिंग असिस्टेंट",
          welcome: "AI पढ़ने के अनुभव में आपका स्वागत है। तैयार होने पर नीचे सारांश विकल्प चुनें।",
          loading: "सारांश बनाया जा रहा है",
          error: "सारांश नहीं बना सके। {{message}}",
          empty: "बनाने के लिए सारांश प्रकार चुनें।",
          chooseChapter: "सारांश बनाने के लिए नीचे अध्याय चुनें।",
          chapterListLabel: "अध्याय",
          noChapters: "इस दस्तावेज़ के लिए कोई अध्याय उपलब्ध नहीं है।",
          backToTypes: "वापस",
          regenerate: "फिर बनाएँ",
        },
        askAi: {
          placeholder: "इस पुस्तक के बारे में कुछ भी पूछें...",
          submit: "प्रश्न भेजें",
          empty: "बातचीत शुरू करने के लिए प्रश्न पूछें।",
          sending: "सोच रहा है",
          error: "जवाब नहीं मिल सका। {{message}}",
          export: "एक्सपोर्ट",
          newChat: "नई चैट",
        },
        quiz: {
          title: "क्विज़ लें",
          subtitle: "चुनें कि आप किस पर परीक्षा देना चाहते हैं।",
          cta: "क्विज़ शुरू करें",
          loading: "क्विज़ बनाया जा रहा है",
          error: "क्विज़ नहीं बना सके। {{message}}",
          modalTitle: "AI क्विज़",
          disclaimer: "AI-जनित सामग्री, केवल संदर्भ के लिए।",
          close: "क्विज़ बंद करें",
          checkAnswer: "उत्तर जाँचें",
          explanation: "व्याख्या",
          previous: "पिछला",
          next: "अगला प्रश्न",
          finish: "समाप्त",
          progress: "प्रश्न {{current}} / {{total}}",
          answerRequired: "जारी रखने के लिए इस प्रश्न का उत्तर दें।",
          completedTitle: "क्विज़ पूरा!",
          yourScore: "आपका स्कोर",
          completedMessage: "आपने क्विज़ सफलतापूर्वक पूरा कर लिया है।",
          reattempt: "क्विज़ फिर से लें",
          save: "सहेजें",
          saving: "सहेजा जा रहा है…",
          saved: "सहेजा गया",
          saveError: "परिणाम सहेज नहीं सके। {{message}}",
          deleteError: "परिणाम हटा नहीं सके। {{message}}",
          deleteResult: "सहेजी गई क्विज़ हटाएँ",
          deletedToast: "क्विज़ हटाई गई",
          recentQuizzes: "हाल की क्विज़",
          seeDetails: "विवरण देखें",
          showDetails: "विवरण दिखाएँ",
          hideDetails: "विवरण छिपाएँ",
          correct: "सही",
          incorrect: "गलत",
          multipleChoice: "बहुविकल्पी",
          questionStatusAria: "प्रश्न {{number}}: {{status}}",
          backToDashboard: "क्विज़ डैशबोर्ड",
          scopeLabel: "क्विज़ दायरा",
          scopeBook: "पुस्तक के अनुसार",
          scopeChapter: "अध्याय के अनुसार",
          scopePage: "पृष्ठ के अनुसार",
          scopePageTitle: "पृष्ठ {{page}}",
          scoreAria: "स्कोर {{correct}} / {{total}}",
          answerOptions: "उत्तर विकल्प",
          navigationAria: "क्विज़ नेविगेशन",
          noQuestions: "कोई क्विज़ प्रश्न नहीं मिला",
          feedback: {
            greatJob: "शाबाश!",
            goodEffort: "अच्छा प्रयास!",
            keepPracticing: "अभ्यास जारी रखें!",
          },
        },
        menu: {
          preferences: "AI प्राथमिकताएँ",
          citation: "AI उद्धरण",
          copy: "AI कॉपी",
          quizzes: "AI क्विज़",
          notes: "नोट्स",
          prefs: {
            aiLanguage: "पसंदीदा भाषा",
            citationEnabled: "उद्धरण दिखाएँ",
            contextInclusionEnabled: "पठन संदर्भ शामिल करें",
          },
        },
      },
      pullouts: {
        fallbackTitle: "पॉपआउट",
        hintLabel: "संकेत:",
        hintAvailable: "संकेत उपलब्ध",
        expandHint: "संकेत विस्तृत करें",
        collapseHint: "संकेत संक्षिप्त करें",
      },
      publicationDetails: {
        title: "प्रकाशन विवरण",
        close: "प्रकाशन विवरण बंद करें",
        copy: "प्रकाशन विवरण कॉपी करें",
        copied: "क्लिपबोर्ड पर कॉपी किया गया",
        description: "विवरण",
        noData: "कोई डेटा उपलब्ध नहीं",
        empty: "इस दस्तावेज़ के लिए प्रकाशन विवरण उपलब्ध नहीं हैं।",

        fields: {
          title: "शीर्षक",
          author: "लेखक",
          code: "कोड",
          type: "प्रकार",
          language: "भाषा",
          original_publisher: "मूल प्रकाशक",
          series: "श्रृंखला",
          edition: "संस्करण",
          pages: "पृष्ठ",
          pisbn13: "PISBN13",
          publication_year: "प्रकाशन वर्ष",
          copyright_year: "कॉपीराइट वर्ष",
          read_direction: "पढ़ने की दिशा",
          content_type: "सामग्री प्रकार",
        },
      },
    },
  },
  vi: {
    translation: {
      common: {
        cancel: "Hủy",
        close: "Đóng",
        menu: "Menu",
        search: "Tìm kiếm",
        bookmarks: "Dấu trang",
        notes: "Ghi chú",
        pages: "Trang",
        tableOfContents: "Mục lục",
        page: "Trang",
        section: "Mục",
        loading: "Đang tải...",
        submit: "Gửi",
        apply: "Áp dụng",
        remove: "Xóa",
        error: "Lỗi",
        language: "Ngôn ngữ",
        theme: "Chủ đề",
        light: "Sáng",
        dark: "Tối",
        on: "Bật",
        off: "Tắt",
        showMore: "Xem thêm",
        showLess: "Thu gọn",
        undo: "Hoàn tác",
        redo: "Làm lại",
        underline: "Gạch chân",
        highlight: "Tô sáng",
        textbox: "Hộp văn bản",
        document: "Tài liệu",
        back: "Quay lại",
      },
      toolbar: {
        expand: "Mở rộng thanh công cụ",
        collapse: "Thu gọn thanh công cụ",
        aiAssistant: "Hỏi trợ lý AI",
        aiAssistantComingSoon: "Hỏi trợ lý AI (Sắp ra mắt)",
        searchNotAllowed: "Không cho phép tìm kiếm",
        textToSpeechComingSoon: "Chuyển văn bản thành giọng nói (Sắp ra mắt)",
        addBookmark: "Thêm dấu trang",
        removeBookmark: "Xóa dấu trang",
        bookmarked: "Đã đánh dấu",
        bookmarksNotAllowed: "Không cho phép dấu trang",
        moreOptions: "Tùy chọn khác",
        display: "Hiển thị",
        lightHint: "Nền sáng với chữ tối",
        darkHint: "Nền tối với chữ sáng",
        pageView: "Chế độ xem trang",
        singlePage: "Một trang",
        singlePageHint: "Cuộn từng trang một",
        doublePage: "Hai trang",
        doublePageHint: "Xem các trang cạnh nhau",
        view: "Chế độ màu",
        share: "Chia sẻ",
        download: "Tải xuống",
        citation: "Trích dẫn",
        print: "In",
        displayMenu: "Menu hiển thị",
        displayMenuItems: {
          colorMode: "Chế độ màu",
          fontSize: "Cỡ chữ",
          fontFamily: "Phông chữ",
          lineHeight: "Chiều cao dòng",
          increaseLineHeight: "Tăng chiều cao dòng",
          decreaseLineHeight: "Giảm chiều cao dòng",
          layout: "Bố cục",
          rotate: "Xoay",
          readingDirection: "Hướng đọc",
          rotateLeft: "Xoay trái",
          rotateRight: "Xoay phải",
          ltr: "Trái sang phải",
          rtl: "Phải sang trái",
          fonts: {
            original: "Gốc",
            sans: "Sans",
            serif: "Serif",
          },
          colors: {
            light: "Sáng",
            dark: "Tối",
            mint: "Bạc hà",
            sepia: "Nâu cổ",
          },
        },
      },
      mobile: {
        searchPlaceholder: "Tìm kiếm từ khóa...",
        cancelSearch: "Hủy tìm kiếm",
        faq: "Câu hỏi thường gặp",
      },
      menu: {
        close: "Đóng menu",
        documentPageCount: "Trang {{current}} / {{total}}",
      },
      rightToolbar: {
        showToc: "Hiển thị mục lục",
        hideToc: "Ẩn mục lục",
        showPagesThumbnails: "Hiển thị hình thu nhỏ trang",
        hidePagesThumbnails: "Ẩn hình thu nhỏ trang",
        showBookmarks: "Hiển thị dấu trang",
        hideBookmarks: "Ẩn dấu trang",
        info: "Thông tin ấn phẩm",
        showPublicationDetails: "Hiển thị chi tiết ấn phẩm",
        hidePublicationDetails: "Ẩn chi tiết ấn phẩm",
        askAi: "Hỏi AI",
        readingGroup: "Nhóm đọc",
        showNotes: "Hiển thị ghi chú",
        hideNotes: "Ẩn ghi chú",
        myNotebook: "Sổ tay của tôi",
        clickToEnterPage: "Nhấp để nhập số trang",
        currentPageLabel: "Trang hiện tại {{current}}. Nhấp để thay đổi.",
        previousPage: "Trang trước",
        nextPage: "Trang sau",
        zoomOut: "Thu nhỏ",
        zoomIn: "Phóng to",
        resetZoom: "Đặt lại thu phóng",
        resetZoomTitle: "Đặt lại thu phóng về 100%",
        decreaseFontSize: "Giảm cỡ chữ",
        increaseFontSize: "Tăng cỡ chữ",
        resetFontSize: "Đặt lại cỡ chữ",
        resetFontSizeTitle: "Đặt lại cỡ chữ thành 100%",
        viewModeOptions: "Tùy chọn hiển thị",
        fitToWidth: "Vừa chiều rộng",
        fitToPage: "Vừa trang",
        enterFullscreen: "Toàn màn hình",
        exitFullscreen: "Thoát toàn màn hình",
        enterPageNumber: "Nhập số trang",
        pageInputPlaceholder: "{{min}}-{{max}}",
        pageInputTitle: "Nhập số trang ({{min}}-{{max}})",
        pageInputInvalid: "Vui lòng nhập số trang hợp lệ",
        pageInputOutOfRange: "Trang phải nằm trong khoảng 1 đến {{total}}",
        showReadingAssistant: "Hiện trợ lý đọc",
        hideReadingAssistant: "Ẩn trợ lý đọc",
      },
      floatingToolbar: {
        ariaLabel: "Thanh công cụ nổi",
        dragToMove: "Kéo để di chuyển",
        dragToolbar: "Kéo thanh công cụ",
        notesOn: "Bật ghi chú",
        notesOff: "Tắt ghi chú",
        notesNotAllowed: "Ghi chú không khả dụng",
        notesOnLabel: "Ghi chú: Bật",
        notesOffLabel: "Ghi chú: Tắt",
        drawingOn: "Bật vẽ",
        drawingOff: "Tắt vẽ",
        drawingNotAllowed: "Vẽ không khả dụng",
        drawingOnLabel: "Vẽ: Bật",
        drawingOffLabel: "Vẽ: Tắt",
        textBoxComingSoon: "Hộp văn bản (Sắp ra mắt)",
        textboxNotAllowed: "Text box not allowed",
        textboxOn: "Bật hộp văn bản",
        textboxOff: "Tắt hộp văn bản",
        textboxOnLabel: "Hộp văn bản: Bật",
        textboxOffLabel: "Hộp văn bản: Tắt",
        highlightOn: "Bật tô sáng",
        highlightOff: "Tắt tô sáng",
        highlightsNotAllowed: "Tô sáng không khả dụng",
        highlightOnLabel: "Tô sáng: Bật",
        highlightOffLabel: "Tô sáng: Tắt",
        underlineOn: "Bật gạch chân",
        underlineOff: "Tắt gạch chân",
        underlineOnLabel: "Gạch chân: Bật",
        underlineOffLabel: "Gạch chân: Tắt",
        highlightColorLabel: "Màu tô sáng",
        colorRed: "Đỏ",
        colorOrange: "Cam",
        colorYellow: "Vàng",
        colorGreen: "Xanh lá",
        colorLightBlue: "Xanh nhạt",
        colorPurple: "Tím",
        underlinesNotAllowed: "Gạch chân không khả dụng",
        undo: "Hoàn tác ({{ctrl}}+Z)",
        redo: "Làm lại ({{ctrl}}+Y)",
        undoCooldown: "Hoàn tác (vui lòng đợi)",
        redoCooldown: "Làm lại (vui lòng đợi)",
      },
      contextMenu: {
        addNote: "Thêm ghi chú",
        highlight: "Tô sáng",
        underline: "Gạch chân",
        copy: "Sao chép",
        removeHighlight: "Xóa tô sáng",
        removeUnderline: "Xóa gạch chân",
        searchSelected: "Tìm từ đã chọn",
        selectionToolbar: "Menu chọn",
        askAi: "Hỏi AI",
        share: "Chia sẻ",
        translate: "Dịch",
        comingSoon: "Sắp ra mắt",
        translationTitle: "Bản dịch",
        translating: "Đang dịch…",
        translationFailed: "Dịch thất bại",
      },
      readerShell: {
        loadingDocument: "Đang tải tài liệu...",
        documentControls: "Cũng cấp cấp điều khiển tài liệu",
      },
      emptyState: {
        errorAlt: "Lỗi",
        documentAlt: "Tài liệu",
        unableToLoad: "Không thể tải tài liệu",
        noDocument: "Chưa tải tài liệu",
        requestDoc: "Yêu cầu một tài liệu từ thư viện của bạn để bắt đầu",
      },
      search: {
        ariaLabel: "Kết quả tìm kiếm",
        searchResults: "Kết Quả Tìm Kiếm",
        close: "Đóng tìm kiếm",
        placeholder: "Tìm trong tài liệu...",
        clear: "Xóa tìm kiếm",
        searching: "Đang tìm kiếm...",
        enterQuery: "Nhập truy vấn để tìm văn bản trong tài liệu",
        noResults: "Không tìm thấy kết quả cho \"{{query}}\"",
        resultsCount_one: "Tìm thấy {{count}} kết quả",
        resultsCount_other: "Tìm thấy {{count}} kết quả",
        matchCount_one: "{{count}} khớp",
        matchCount_other: "{{count}} khớp",
        navigateToResult: "Nhấp để chuyển đến kết quả này",
      },
      bookmarks: {
        title: "Dấu trang",
        close: "Đóng dấu trang",
        loading: "Đang tải dấu trang...",
        error: "Lỗi tải dấu trang: {{error}}",
        noItems: "Chưa có dấu trang",
        navigate: "Nhấp để chuyển đến dấu trang này",
        remove: "Xóa dấu trang",
        removeLabel: "Xóa dấu trang {{label}}",
        deleteError: "Xóa dấu trang thất bại",
        navigateLabel: "Đến {{label}}",
        defaultLabel: "Dấu trang {{page}}",
      },
      notes: {
        title: "Sổ tay của tôi",
        close: "Đóng sổ tay của tôi",
        navigate: "Nhấp để chuyển đến ghi chú này",
        ariaLabel: "Ghi chú: {{preview}} Trang {{page}} {{created}}",
        createdOn: "Tạo ngày {{date}}",
        pageTitle: "Trang {{page}}",
        remove: "Xóa ghi chú",
        removeLabel: "Xóa ghi chú khỏi trang {{page}}",
        none: "Chưa có ghi chú",
        noItems: "Chưa có mục nào",
        share: "Chia sẻ sổ tay",
        searchPlaceholder: "Nhập tại đây",
        clearSearch: "Xóa tìm kiếm",
        tabsLabel: "Bộ lọc sổ tay",
        tabs: {
          all: "Tất cả",
          highlight: "Đánh dấu",
          underline: "Gạch chân",
          note: "Ghi chú",
        },
        resultsFound_one: "Tìm thấy {{count}} kết quả",
        resultsFound_other: "Tìm thấy {{count}} kết quả",
        copyItem: "Sao chép mục",
        shareItem: "Chia sẻ mục",
      },
      toc: {
        title: "Mục lục",
        close: "Đóng mục lục",
        untitled: "Mục không có tiêu đề",
        empty: "Không có mục lục",
        noItems: "Không có mục lục",
        chapter: "Chương",
      },
      pages: {
        title: "Trang",
        count_one: "{{count}} trang",
        count_other: "{{count}} trang",
        empty: "Không có trang",
        thumbnailAlt: "Trang {{page}}",
        ariaLabel: "Hình thu nhỏ trang",
      },
      epub: {
        loading: "Đang tải EPUB...",
        errorTitle: "Lỗi tải EPUB",
        reload: "Tải lại trang",
        noteIndicatorTitle: "Ghi chú {{current}} / {{total}}: {{text}}{{suffix}}",
        noteSelectedSuffix: " (Ghi chú văn bản đã chọn)",
        noteTitleEdit: "Chỉnh sửa ghi chú",
        noteTitleAdd: "Thêm ghi chú",
        noteCounter: "({{current}} / {{total}})",
        selectedTextLabel: "Văn bản đã chọn:",
        notePlaceholderSelected: "Thêm ghi chú về văn bản đã chọn...",
        notePlaceholder: "Nhập ghi chú",
        noteActionSave: "Lưu",
        noteActionCreate: "Tạo",
        contextAddNote: "Thêm ghi chú",
        contextHighlight: "Tô sáng",
        contextSearch: "Tìm từ đã chọn",
        imageAlt: "Hình ảnh",
        imageLightboxAria: "Hình ảnh phóng to",
        closeImagePreview: "Đóng xem trước hình ảnh",
      },
      notifications: {
        featureNotAllowed: "Tính năng này không khả dụng.",
        featureComingSoon: "Tính năng này sắp ra mắt.",
        highlightsNotAvailable: "Không thể tô sáng cho tài liệu này.",
        underlinesNotAvailable: "Tính năng gạch chân không khả dụng cho tài liệu này.",
        notesNotAvailable: "Ghi chú không khả dụng cho tài liệu này.",
        drawingNotAvailable: "Vẽ không khả dụng cho tài liệu này.",
        bookmarksNotAvailable: "Dấu trang không khả dụng cho tài liệu này.",
        searchNotAvailable: "Tìm kiếm không khả dụng cho tài liệu này.",
        commentsNotAvailable: "Bình luận không khả dụng cho tài liệu này.",
        pageOutOfRange: "Trang này không khả dụng.",
        aiAssistantComingSoon: "Trợ lý AI sắp ra mắt.",
        textBoxComingSoon: "Hộp văn bản sắp ra mắt.",
        textToSpeechComingSoon: "Chuyển văn bản thành giọng nói sắp ra mắt.",
        sessionExpired: "Phiên đã hết hạn. Vui lòng làm mới và thử lại.",
        operationFailed: "Không thể {{operation}}. Vui lòng thử lại.",
        copyLimitExceeded: "Vượt quá giới hạn sao chép. Chỉ {{limit}} ký tự được sao chép.",
        copyNotAllowed: "Không được phép sao chép tài liệu này.",
        operations: {
          saveAiPreferences: "lưu tùy chọn AI",
          copyText: "sao chép văn bản",
          completeAction: "hoàn thành thao tác này",
          saveBookmark: "lưu dấu trang",
          deleteBookmark: "xóa dấu trang",
          saveNote: "lưu ghi chú",
          updateNote: "cập nhật ghi chú",
          deleteNote: "xóa ghi chú",
          saveHighlight: "lưu tô sáng",
          updateHighlight: "cập nhật tô sáng",
          deleteHighlight: "xóa tô sáng",
          saveUnderline: "lưu gạch chân",
          deleteUnderline: "xóa gạch chân",
          saveDrawing: "lưu bản vẽ",
          deleteDrawing: "xóa bản vẽ",
          updateTextbox: "cập nhật hộp văn bản",
          deleteTextbox: "xóa hộp văn bản",
        },
      },
      faq: {
        open: "Mở FAQ",
        title: "Cách sử dụng E-Reader",
      },
      help: {
        close: "Đóng trợ giúp",
        title: "Hướng dẫn sử dụng E-Reader",
        featuresTab: "Tính năng",
        shortcutsTab: "Phím tắt bàn phím",
        gesturesTab: "Cử chỉ cảm ứng",
        gestures: {
          title: "Cử chỉ cảm ứng",
          tap: "Chạm",
          tapDesc: "Chọn một mục hoặc mở liên kết",
          doubleTap: "Chạm hai lần",
          doubleTapDesc: "Phóng to hoặc thu nhỏ",
          swipeLeft: "Vuốt sang trái",
          swipeLeftDesc: "Đi đến trang tiếp theo",
          swipeRight: "Vuốt sang phải",
          swipeRightDesc: "Đi đến trang trước",
          swipeUpDown: "Vuốt lên/xuống",
          swipeUpDownDesc: "Cuộn trang",
          pinchOut: "Dùng hai ngón tay tách ra",
          pinchIn: "Dùng hai ngón tay chụm lại",
          longPress: "Nhấn và giữ",
          longPressDesc: "Chọn văn bản hoặc mở tùy chọn bổ sung",
        },
        readingNav: "Đọc và Điều hướng",
        navigation: "Điều hướng trang",
        navigationDesc: "Sử dụng trường nhập trang hoặc hình thu nhỏ để đi đến bất kỳ trang nào",
        zoomControls: "Điều khiển phóng to",
        zoomControlsDesc: "Điều chỉnh mức phóng to hoặc chọn chế độ vừa chiều rộng/trang",
        search: "Tìm kiếm",
        searchDesc: "Tìm và điều hướng qua văn bản trong tài liệu",
        displayDesc: "Thay đổi giao diện đọc và tùy chọn bố cục trang",
        publicationDesc: "Xem chi tiết về ấn phẩm hiện tại",
        organization: "Tổ chức",
        bookmarks: "Dấu trang",
        bookmarksDesc: "Lưu các trang quan trọng để truy cập nhanh",
        notes: "Ghi chú",
        notesDesc: "Thêm ghi chú văn bản vào các trang cụ thể",
        annotationTools: "Công cụ chú thích",
        highlights: "Đánh dấu",
        highlightsDesc: "Đánh dấu văn bản quan trọng",
        underlineDesc: "Gạch dưới văn bản để đánh dấu các đoạn quan trọng",
        drawing: "Vẽ",
        drawingDesc: "Vẽ chú thích tự do trực tiếp trên các trang",
        undoRedo: "Hoàn tác và Làm lại",
        undoRedoDesc: "Hoàn tác hoặc làm lại chú thích của bạn",
        comingSoon: "Sắp ra mắt",
        audioReading: "Đọc bằng giọng nói",
        audioReadingDesc: "Nghe nội dung tài liệu với chức năng chuyển đổi văn bản thành giọng nói",
        aiAssistant: "Trợ lý AI",
        aiAssistantDesc: "Nhận thông tin chi tiết thông minh và tóm tắt",
        shortcuts: {
          navigationAccessibility: "Điều hướng và Khả năng truy cập",
          browseForward: "Duyệt qua các phần tử tương tác",
          browseBackward: "Duyệt lùi qua các phần tử tương tác",
          activateButton: "Kích hoạt nút hoặc liên kết được lấy nét",
          selectToggle: "Chọn hoặc bật tắt phần tử được lấy nét",
          closeDialogs: "Đóng các hộp thoại và menu mở",
          nextPrevPage: "Trang tiếp theo hoặc trước",
          jumpTop: "Nhảy đến phần đầu của tài liệu",
          jumpBottom: "Nhảy đến cuối tài liệu",
          zoomViewControls: "Điều khiển phóng to và xem",
          zoomIn: "Phóng to",
          zoomOut: "Thu nhỏ",
          fitWidth: "Vừa chiều rộng",
          fitPage: "Vừa trang",
          editingAnnotations: "Chỉnh sửa và Chú thích",
          undo: "Hoàn tác hành động cuối cùng",
          redo: "Làm lại hành động cuối cùng",
          toggleHighlight: "Chuyển đổi chế độ đánh dấu",
          drawingBrush: "Chuyển đổi cây lăn vẽ",
          toggleNotes: "Chuyển đổi thanh bên ghi chú",
          toggleBookmarks: "Chuyển đổi thanh bên dấu trang",
          openToc: "Mở mục lục",
          saveBookmark: "Lưu dấu trang",
          searchContent: "Tìm kiếm và Nội dung",
          searchWithin: "Tìm kiếm trong tài liệu",
          copyText: "Sao chép văn bản được chọn",
          selectAll: "Chọn tất cả văn bản trong trang hoặc chế độ xem hiện tại",
        },
        translateDesc: "Dịch văn bản đã chọn bằng AI",
      },
      loading: {
        initializing: "Đang khởi tạo...",
        restoringSession: "Đang khôi phục phiên...",
        fetchingAccessToken: "Đang lấy mã truy cập...",
        loadingDocument: "Đang tải tài liệu...",
        ariaLabel: "Đang tải",
        authenticating: "Đang xác thực...",
        finalizing: "Đang hoàn tất...",
      },
      landingPage: {
        uploadTitle: "Tải lên Tài liệu",
        uploadSubtitle: "Kéo và thả tệp PDF hoặc EPUB vào đây, hoặc nhấp để tải lên",
        supportedFormats: "Định dạng được hỗ trợ: PDF, EPUB",
        uploadAriaLabel: "Tải lên tệp PDF hoặc EPUB",
      },
      errors: {
        failedToLoadPdf: "Tải PDF thất bại",
        failedToLoadEpub: "Tải EPUB thất bại",
        unsupportedFileType: "Loại tệp không được hỗ trợ. Vui lòng tải lên PDF hoặc EPUB.",
        errorReadingFile: "Lỗi đọc tệp.",
        searchFailed: "Tìm kiếm thất bại",
        failedToRestoreSession: "Không thể khôi phục phiên.",
        failedToInitializeReader: "Không thể khởi tạo trình đọc từ token.",
      },
      readingAssistant: {
        title: "Trợ lý đọc",
        close: "Đóng trợ lý đọc",
        resize: "Đổi kích thước trợ lý đọc",
        resizeHint: "Kéo để đổi kích thước. Nhấp đúp để đặt lại.",
        tabsLabel: "Tab trợ lý đọc",
        tabs: {
          summary: "Tóm tắt",
          askAi: "Hỏi AI",
          quiz: "Câu đố",
        },
        status: {
          loading: "Đang kiểm tra…",
          processing: "Tài liệu vẫn đang được chuẩn bị cho AI. Vui lòng thử lại sau.",
          unavailable: "Tính năng AI không khả dụng cho tài liệu này.",
          failed: "Xử lý tài liệu thất bại. Tính năng AI không khả dụng.",
          error: "Không thể tải tính năng AI. {{message}}",
        },
        summary: {
          typesLabel: "Loại tóm tắt",
          types: {
            quick: "Tóm tắt nhanh",
            detailed: "Tóm tắt chi tiết",
            chapter: "Tóm tắt theo chương",
          },
          cardTitles: {
            quick: "Tóm tắt nhanh",
            detailed: "Tóm tắt chi tiết",
            chapter: "Tóm tắt theo chương",
          },
          welcomeTitle: "Trợ lý đọc",
          welcome: "Chào mừng đến trải nghiệm đọc bằng AI. Chọn tùy chọn tóm tắt khi sẵn sàng.",
          loading: "Đang tạo tóm tắt",
          error: "Không thể tạo tóm tắt. {{message}}",
          empty: "Chọn loại tóm tắt để tạo.",
          chooseChapter: "Chọn một chương bên dưới để tạo tóm tắt.",
          chapterListLabel: "Chương",
          noChapters: "Không có chương nào cho tài liệu này.",
          backToTypes: "Quay lại",
          regenerate: "Tạo lại",
        },
        askAi: {
          placeholder: "Hỏi bất cứ điều gì về cuốn sách này...",
          submit: "Gửi câu hỏi",
          empty: "Đặt câu hỏi để bắt đầu cuộc trò chuyện.",
          sending: "Đang suy nghĩ",
          error: "Không nhận được phản hồi. {{message}}",
          export: "Xuất",
          newChat: "Trò chuyện mới",
        },
        quiz: {
          title: "Làm bài kiểm tra",
          subtitle: "Chọn nội dung bạn muốn được kiểm tra.",
          cta: "Bắt đầu quiz",
          loading: "Đang tạo quiz",
          error: "Không thể tạo quiz. {{message}}",
          modalTitle: "Quiz AI",
          disclaimer: "Nội dung AI, chỉ để tham khảo.",
          close: "Đóng quiz",
          checkAnswer: "Kiểm tra đáp án",
          explanation: "Giải thích",
          previous: "Trước",
          next: "Câu tiếp",
          finish: "Hoàn thành",
          progress: "Câu {{current}} / {{total}}",
          answerRequired: "Trả lời câu này để tiếp tục.",
          completedTitle: "Hoàn thành quiz!",
          yourScore: "Điểm của bạn",
          completedMessage: "Bạn đã hoàn thành quiz thành công.",
          reattempt: "Làm lại quiz",
          save: "Lưu",
          saving: "Đang lưu…",
          saved: "Đã lưu",
          saveError: "Không thể lưu kết quả. {{message}}",
          deleteError: "Không thể xóa kết quả. {{message}}",
          deleteResult: "Xóa quiz đã lưu",
          deletedToast: "Đã xóa quiz",
          recentQuizzes: "Quiz gần đây",
          seeDetails: "Xem chi tiết",
          showDetails: "Hiện chi tiết",
          hideDetails: "Ẩn chi tiết",
          correct: "Đúng",
          incorrect: "Sai",
          multipleChoice: "Trắc nghiệm",
          questionStatusAria: "Câu {{number}}: {{status}}",
          backToDashboard: "Bảng quiz",
          scopeLabel: "Phạm vi quiz",
          scopeBook: "Theo sách",
          scopeChapter: "Theo chương",
          scopePage: "Theo trang",
          scopePageTitle: "Trang {{page}}",
          scoreAria: "Điểm {{correct}} / {{total}}",
          answerOptions: "Lựa chọn đáp án",
          navigationAria: "Điều hướng quiz",
          noQuestions: "Không có câu hỏi quiz nào",
          feedback: {
            greatJob: "Làm tốt lắm!",
            goodEffort: "Cố gắng tốt!",
            keepPracticing: "Hãy tiếp tục luyện tập!",
          },
        },
        menu: {
          preferences: "Tùy chọn AI",
          citation: "Trích dẫn AI",
          copy: "Sao chép AI",
          quizzes: "Quiz AI",
          notes: "Ghi chú",
          prefs: {
            aiLanguage: "Ngôn ngữ ưa thích",
            citationEnabled: "Hiện trích dẫn",
            contextInclusionEnabled: "Bao gồm ngữ cảnh đọc",
          },
        },
      },
      pullouts: {
        fallbackTitle: "Nội dung nổi",
        hintLabel: "Gợi ý:",
        hintAvailable: "Có gợi ý",
        expandHint: "Mở rộng gợi ý",
        collapseHint: "Thu gọn gợi ý",
      },
      publicationDetails: {
        title: "Chi tiết ấn phẩm",
        close: "Đóng chi tiết ấn phẩm",
        copy: "Sao chép chi tiết ấn phẩm",
        copied: "Đã sao chép vào clipboard",
        description: "Mô tả",
        noData: "Không có dữ liệu",
        empty: "Không có chi tiết ấn phẩm cho tài liệu này.",

        fields: {
          title: "Tiêu đề",
          author: "Tác giả",
          code: "Mã",
          type: "Loại",
          language: "Ngôn ngữ",
          original_publisher: "Nhà xuất bản gốc",
          series: "Bộ sách",
          edition: "Lần xuất bản",
          pages: "Số trang",
          pisbn13: "PISBN13",
          publication_year: "Năm xuất bản",
          copyright_year: "Năm bản quyền",
          read_direction: "Hướng đọc",
          content_type: "Loại nội dung",
        },
      },
    },
  },
  fil: {
    translation: {
      common: {
        cancel: "Kanselahin",
        close: "Isara",
        menu: "Menu",
        search: "Maghanap",
        bookmarks: "Mga Bookmark",
        notes: "Mga Tala",
        pages: "Mga Pahina",
        tableOfContents: "Talaan ng Nilalaman",
        page: "Pahina",
        section: "Seksyon",
        loading: "Naglo-load...",
        submit: "Isumite",
        apply: "Ilapat",
        remove: "Alisin",
        error: "Mali",
        language: "Wika",
        theme: "Tema",
        light: "Maliwanag",
        dark: "Madilim",
        on: "Bukas",
        off: "Sarado",
        showMore: "Ipakita pa",
        showLess: "Ipakita nang mas kaunti",
        undo: "I-undo",
        redo: "I-redo",
        underline: "Salungguhit",
        highlight: "I-highlight",
        textbox: "Kahon ng teksto",
        document: "Dokumento",
        back: "Bumalik",
      },
      toolbar: {
        expand: "Palawakin ang toolbar",
        collapse: "I-collapse ang toolbar",
        aiAssistant: "Tanungin ang AI Assistant",
        aiAssistantComingSoon: "Tanungin ang AI Assistant (Malapit na)",
        searchNotAllowed: "Hindi pinapayagan ang paghahanap",
        textToSpeechComingSoon: "Text-to-speech (Malapit na)",
        addBookmark: "Magdagdag ng bookmark",
        removeBookmark: "Alisin ang bookmark",
        bookmarked: "Naka-bookmark",
        bookmarksNotAllowed: "Hindi pinapayagan ang bookmarks",
        moreOptions: "Higit pang opsyon",
        display: "Pagpapakita",
        lightHint: "Maliwanag na background at madilim na teksto",
        darkHint: "Madilim na background at maliwanag na teksto",
        pageView: "View ng pahina",
        singlePage: "Isang pahina",
        singlePageHint: "Mag-scroll ng isang pahina sa isang pagkakataon",
        doublePage: "Dalawang pahina",
        doublePageHint: "Tingnan ang mga pahina nang magkatabi",
        view: "Color Mode",
        share: "Ibahagi",
        download: "I-download",
        citation: "Sipi",
        print: "I-print",
        displayMenu: "Menu ng display",
        displayMenuItems: {
          colorMode: "Color mode",
          fontSize: "Laki ng font",
          fontFamily: "Font",
          lineHeight: "Line height",
          increaseLineHeight: "Dagdagan ang line height",
          decreaseLineHeight: "Bawasan ang line height",
          layout: "Layout",
          rotate: "I-rotate",
          readingDirection: "Direksyon ng pagbabasa",
          rotateLeft: "I-rotate pakaliwa",
          rotateRight: "I-rotate pakanan",
          ltr: "Kaliwa pakanan",
          rtl: "Kanan pakaliwa",
          fonts: {
            original: "Orihinal",
            sans: "Sans",
            serif: "Serif",
          },
          colors: {
            light: "Light",
            dark: "Dark",
            mint: "Mint",
            sepia: "Sepia",
          },
        },
      },
      mobile: {
        searchPlaceholder: "Maghanap ng keyword...",
        cancelSearch: "Kanselahin ang paghahanap",
        faq: "FAQ",
      },
      menu: {
        close: "Isara ang menu",
        documentPageCount: "Pahina {{current}} ng {{total}}",
      },
      rightToolbar: {
        showToc: "Ipakita ang talaan ng nilalaman",
        hideToc: "Itago ang talaan ng nilalaman",
        showPagesThumbnails: "Ipakita ang thumbnails ng pahina",
        hidePagesThumbnails: "Itago ang thumbnails ng pahina",
        showBookmarks: "Ipakita ang bookmarks",
        hideBookmarks: "Itago ang bookmarks",
        info: "Impormasyon ng publikasyon",
        showPublicationDetails: "Ipakita ang mga detalye ng publikasyon",
        hidePublicationDetails: "Itago ang mga detalye ng publikasyon",
        askAi: "Magtanong sa AI",
        readingGroup: "Reading Group",
        showNotes: "Ipakita ang mga tala",
        hideNotes: "Itago ang mga tala",
        myNotebook: "Aking Notebook",
        clickToEnterPage: "I-click para maglagay ng numero ng pahina",
        currentPageLabel: "Kasalukuyang pahina {{current}}. I-click para baguhin.",
        previousPage: "Nakaraang pahina",
        nextPage: "Susunod na pahina",
        zoomOut: "I-zoom out",
        zoomIn: "I-zoom in",
        resetZoom: "I-reset ang zoom",
        resetZoomTitle: "I-reset ang zoom sa 100%",
        decreaseFontSize: "Bawasan ang laki ng font",
        increaseFontSize: "Dagdagan ang laki ng font",
        resetFontSize: "I-reset ang laki ng font",
        resetFontSizeTitle: "I-reset ang laki ng font sa 100%",
        viewModeOptions: "Mga opsyon sa view",
        fitToWidth: "I-fit sa lapad",
        fitToPage: "I-fit sa pahina",
        enterFullscreen: "Pumunta sa fullscreen",
        exitFullscreen: "Lumabas sa fullscreen",
        enterPageNumber: "Maglagay ng numero ng pahina",
        pageInputPlaceholder: "{{min}}-{{max}}",
        pageInputTitle: "Maglagay ng numero ng pahina ({{min}}-{{max}})",
        pageInputInvalid: "Maglagay ng wastong numero ng pahina",
        pageInputOutOfRange: "Ang pahina ay dapat nasa pagitan ng 1 at {{total}}",
        showReadingAssistant: "Ipakita ang Reading Assistant",
        hideReadingAssistant: "Itago ang Reading Assistant",
      },
      floatingToolbar: {
        ariaLabel: "Lumulutang na toolbar",
        dragToMove: "I-drag para ilipat",
        dragToolbar: "I-drag ang toolbar",
        notesOn: "I-on ang mga tala",
        notesOff: "I-off ang mga tala",
        notesNotAllowed: "Hindi available ang mga tala",
        notesOnLabel: "Mga Tala: Bukas",
        notesOffLabel: "Mga Tala: Sarado",
        drawingOn: "I-on ang pagguhit",
        drawingOff: "I-off ang pagguhit",
        drawingNotAllowed: "Hindi available ang pagguhit",
        drawingOnLabel: "Pagguhit: Bukas",
        drawingOffLabel: "Pagguhit: Sarado",
        textBoxComingSoon: "Text box (Malapit na)",
        textboxNotAllowed: "Hindi pinapayagan ang text box",
        textboxOn: "I-on ang text box",
        textboxOff: "I-off ang text box",
        textboxOnLabel: "Text Box: Bukas",
        textboxOffLabel: "Text Box: Sarado",
        highlightOn: "I-on ang highlight",
        highlightOff: "I-off ang highlight",
        highlightsNotAllowed: "Hindi available ang highlight",
        highlightOnLabel: "Highlight: Bukas",
        highlightOffLabel: "Highlight: Sarado",
        underlineOn: "I-on ang salungguhit",
        underlineOff: "I-off ang salungguhit",
        underlineOnLabel: "Salungguhit: Bukas",
        underlineOffLabel: "Salungguhit: Sarado",
        highlightColorLabel: "Kulay ng highlight",
        colorRed: "Pula",
        colorOrange: "Kahel",
        colorYellow: "Dilaw",
        colorGreen: "Berde",
        colorLightBlue: "Malinaw na asul",
        colorPurple: "Lila",
        underlinesNotAllowed: "Hindi available ang salungguhit",
        undo: "I-undo ({{ctrl}}+Z)",
        redo: "I-redo ({{ctrl}}+Y)",
        undoCooldown: "I-undo (pakihintay)",
        redoCooldown: "I-redo (pakihintay)",
      },
      contextMenu: {
        addNote: "Magdagdag ng tala",
        highlight: "I-highlight",
        underline: "Salungguhit",
        copy: "Kopyahin",
        removeHighlight: "Alisin ang highlight",
        removeUnderline: "Alisin ang salungguhit",
        searchSelected: "Hanapin ang napiling salita",
        selectionToolbar: "Menu ng pagpili",
        askAi: "Magtanong sa AI",
        share: "Ibahagi",
        translate: "Isalin",
        comingSoon: "Paparating na",
        translationTitle: "Pagsasalin",
        translating: "Isinasalin…",
        translationFailed: "Hindi na-translate",
      },
      readerShell: {
        loadingDocument: "Nilo-load ang dokumento...",
        documentControls: "Mga kontrol ng dokumento",
      },
      emptyState: {
        errorAlt: "Mali",
        documentAlt: "Dokumento",
        unableToLoad: "Hindi ma-load ang dokumento",
        noDocument: "Walang dokumentong naka-load",
        requestDoc: "Humiling ng dokumento mula sa iyong library para magsimula",
      },
      search: {
        ariaLabel: "Mga resulta ng paghahanap",
        searchResults: "Mga Resulta ng Paghahanap",
        close: "Isara ang paghahanap",
        placeholder: "Maghanap sa dokumento...",
        clear: "I-clear ang paghahanap",
        searching: "Naghahanap...",
        enterQuery: "Maglagay ng query para maghanap ng teksto sa dokumento",
        noResults: "Walang resulta para sa \"{{query}}\"",
        resultsCount_one: "Nakita ang {{count}} resulta",
        resultsCount_other: "Nakita ang {{count}} resulta",
        matchCount_one: "{{count}} tugma",
        matchCount_other: "{{count}} tugma",
        navigateToResult: "I-click para pumunta sa resultang ito",
      },
      bookmarks: {
        title: "Mga Bookmark",
        close: "Isara ang mga bookmark",
        loading: "Nilo-load ang mga bookmark...",
        error: "Error sa pag-load ng bookmarks: {{error}}",
        noItems: "Wala pang bookmarks",
        navigate: "I-click para pumunta sa bookmark na ito",
        remove: "Alisin ang bookmark",
        removeLabel: "Alisin ang bookmark {{label}}",
        deleteError: "Nabigo ang pagtanggal ng bookmark",
        navigateLabel: "Pumunta sa {{label}}",
        defaultLabel: "Bookmark sa pahina {{page}}",
      },
      notes: {
        title: "Aking Notebook",
        close: "Isara ang aking notebook",
        navigate: "I-click para pumunta sa tala na ito",
        ariaLabel: "Tala: {{preview}} Pahina {{page}} {{created}}",
        createdOn: "Nilikha noong {{date}}",
        pageTitle: "Pahina {{page}}",
        remove: "Alisin ang tala",
        removeLabel: "Alisin ang tala mula sa pahina {{page}}",
        none: "Wala pang tala",
        noItems: "Wala pang mga item",
        share: "Ibahagi ang notebook",
        searchPlaceholder: "Mag-type dito",
        clearSearch: "I-clear ang paghahanap",
        tabsLabel: "Mga filter ng notebook",
        tabs: {
          all: "Lahat",
          highlight: "Highlight",
          underline: "Underline",
          note: "Tala",
        },
        resultsFound_one: "{{count}} Resulta ang nahanap",
        resultsFound_other: "{{count}} Resulta ang nahanap",
        copyItem: "Kopyahin ang item",
        shareItem: "Ibahagi ang item",
      },
      toc: {
        title: "Talaan ng Nilalaman",
        close: "Isara ang talaan ng nilalaman",
        untitled: "Walang pamagat na seksyon",
        empty: "Walang talaan ng nilalaman",
        noItems: "Walang talaan ng nilalaman",
        chapter: "Kabanata",
      },
      pages: {
        title: "Mga Pahina",
        count_one: "{{count}} pahina",
        count_other: "{{count}} pahina",
        empty: "Walang available na pahina",
        thumbnailAlt: "Pahina {{page}}",
        ariaLabel: "Thumbnails ng pahina",
      },
      epub: {
        loading: "Nilo-load ang EPUB...",
        errorTitle: "Error sa pag-load ng EPUB",
        reload: "I-reload ang pahina",
        noteIndicatorTitle: "Tala {{current}} / {{total}}: {{text}}{{suffix}}",
        noteSelectedSuffix: " (Tala sa napiling teksto)",
        noteTitleEdit: "I-edit ang tala",
        noteTitleAdd: "Magdagdag ng tala",
        noteCounter: "({{current}} / {{total}})",
        selectedTextLabel: "Napiling teksto:",
        notePlaceholderSelected: "Magdagdag ng tala tungkol sa napiling teksto...",
        notePlaceholder: "Mag-type ng tala",
        noteActionSave: "I-save",
        noteActionCreate: "Gumawa",
        contextAddNote: "Magdagdag ng tala",
        contextHighlight: "I-highlight",
        contextSearch: "Hanapin ang napiling salita",
        imageAlt: "Larawan",
        imageLightboxAria: "Pinalaking larawan",
        closeImagePreview: "Isara ang preview ng larawan",
      },
      notifications: {
        featureNotAllowed: "Hindi available ang feature na ito.",
        featureComingSoon: "Ang feature na ito ay paparating na.",
        highlightsNotAvailable: "Hindi available ang highlight para sa dokumentong ito.",
        underlinesNotAvailable: "Hindi magagamit ang pag-underline para sa dokumentong ito.",
        notesNotAvailable: "Hindi available ang mga tala para sa dokumentong ito.",
        drawingNotAvailable: "Hindi available ang pagguhit para sa dokumentong ito.",
        bookmarksNotAvailable: "Hindi available ang bookmarks para sa dokumentong ito.",
        searchNotAvailable: "Hindi available ang paghahanap para sa dokumentong ito.",
        commentsNotAvailable: "Hindi available ang mga komento para sa dokumentong ito.",
        pageOutOfRange: "Hindi available ang pahinang ito.",
        aiAssistantComingSoon: "Malapit na ang AI Assistant.",
        textBoxComingSoon: "Malapit na ang mga text box.",
        textboxNotAllowed: "Hindi pinapayagan ang text box",
        textToSpeechComingSoon: "Malapit na ang text-to-speech.",
        sessionExpired: "Nag-expire ang session. Paki-refresh at subukan muli.",
        operationFailed: "Hindi magawa ang {{operation}}. Subukan muli.",
        copyLimitExceeded: "Lumampas sa limitasyon ng pagkopya. {{limit}} na character lang ang nakopya.",
        copyNotAllowed: "Hindi pinapayagan ang pagkopya sa dokumentong ito.",
        operations: {
          saveAiPreferences: "i-save ang AI preferences",
          copyText: "kopyahin ang text",
          completeAction: "tapusin ang aksyong ito",
          saveBookmark: "i-save ang bookmark",
          deleteBookmark: "tanggalin ang bookmark",
          saveNote: "i-save ang tala",
          updateNote: "i-update ang tala",
          deleteNote: "tanggalin ang tala",
          saveHighlight: "i-save ang highlight",
          updateHighlight: "i-update ang highlight",
          deleteHighlight: "tanggalin ang highlight",
          saveUnderline: "i-save ang underline",
          deleteUnderline: "tanggalin ang underline",
          saveDrawing: "i-save ang drawing",
          deleteDrawing: "tanggalin ang drawing",
          updateTextbox: "i-update ang text box",
          deleteTextbox: "tanggalin ang text box",
        },
      },
      faq: {
        open: "Buksan ang FAQ",
        title: "Paano gamitin ang E-Reader",
      },
      help: {
        close: "Isara ang tulong",
        title: "Gabay ng Gumagamit ng E-Reader",
        featuresTab: "Mga Tampok",
        shortcutsTab: "Mga Shortcut sa Keyboard",
        gesturesTab: "Mga Gesture sa Touch",
        gestures: {
          title: "Mga Gesture sa Touch",
          tap: "I-tap",
          tapDesc: "Pumili ng item o buksan ang isang link",
          doubleTap: "I-double-tap",
          doubleTapDesc: "Mag-zoom in o zoom out",
          swipeLeft: "I-swipe pakaliwa",
          swipeLeftDesc: "Pumunta sa susunod na pahina",
          swipeRight: "I-swipe pakanan",
          swipeRightDesc: "Pumunta sa nakaraang pahina",
          swipeUpDown: "I-swipe pataas/pababa",
          swipeUpDownDesc: "Mag-scroll sa pahina",
          pinchOut: "I-pinch out (dalawang daliri palabas)",
          pinchIn: "I-pinch in (dalawang daliri papasok)",
          longPress: "Pindutin nang matagal",
          longPressDesc: "Piliin ang teksto o buksan ang karagdagang mga pagpipilian",
        },
        readingNav: "Pagbabasa at Navigation",
        navigation: "Pag-navigate sa Pahina",
        navigationDesc: "Gamitin ang page input field o thumbnails upang lumipat sa anumang pahina",
        zoomControls: "Kontrol sa Pag-zoom",
        zoomControlsDesc: "Ayusin ang zoom level o piliin ang fit-to-width/page mode",
        search: "Maghanap",
        searchDesc: "Maghanap at mag-navigate sa pamamagitan ng text sa dokumento",
        displayDesc: "Baguhin ang hitsura ng pagbabasa at mga opsyon sa layout ng pahina",
        publicationDesc: "Tingnan ang mga detalye tungkol sa kasalukuyang publikasyon",
        organization: "Organisasyon",
        bookmarks: "Mga Bookmark",
        bookmarksDesc: "Magsave ng mahalagang pahina para sa mabilis na access",
        notes: "Mga Tala",
        notesDesc: "Magdagdag ng text notes sa mga specific na pahina",
        annotationTools: "Mga Tool para sa Anotasyon",
        highlights: "Mga Highlight",
        highlightsDesc: "I-highlight ang mahalagang text upang tumayo",
        underlineDesc: "I-underline ang teksto upang markahan ang mahahalagang bahagi",
        drawing: "Pagguhit",
        drawingDesc: "Gumuhit ng freehand annotation direkta sa mga pahina",
        undoRedo: "Undo at Redo",
        undoRedoDesc: "Ibalik o ulitin ang iyong mga anotasyon",
        comingSoon: "Paparating Na",
        audioReading: "Basahin ng Audio",
        audioReadingDesc: "Pakinggan ang nilalaman ng dokumento gamit ang text-to-speech",
        aiAssistant: "Katulong na AI",
        aiAssistantDesc: "Makatanggap ng matalinong mga insight at buod",
        shortcuts: {
          navigationAccessibility: "Pag-navigate at Accessibility",
          browseForward: "Mag-browse ng pasulong sa pamamagitan ng interactive na elemento",
          browseBackward: "Mag-browse ng pabalik sa pamamagitan ng interactive na elemento",
          activateButton: "I-activate ang focused button o link",
          selectToggle: "Pumili o i-toggle ang focused element",
          closeDialogs: "Sarado ang mga bukas na dialog at menu",
          nextPrevPage: "Susunod o nakaraang pahina",
          jumpTop: "Lumipat sa simula ng dokumento",
          jumpBottom: "Lumipat sa dulo ng dokumento",
          zoomViewControls: "Zoom at View Controls",
          zoomIn: "Palakasin ang zoom",
          zoomOut: "Bawasan ang zoom",
          fitWidth: "I-fit sa lapad",
          fitPage: "I-fit sa pahina",
          editingAnnotations: "Pag-edit at Anotasyon",
          undo: "Ibalik ang nakaraang aksyon",
          redo: "Ulitin ang nakaraang aksyon",
          toggleHighlight: "Ilipat ang highlight mode",
          drawingBrush: "Ilipat ang drawing brush",
          toggleNotes: "Ilipat ang notes sidebar",
          toggleBookmarks: "Ilipat ang bookmarks sidebar",
          openToc: "Buksan ang table of contents",
          saveBookmark: "Magsave ng bookmark",
          searchContent: "Maghanap & Nilalaman",
          searchWithin: "Maghanap sa loob ng dokumento",
          copyText: "Kopyahin ang napiling text",
          selectAll: "Piliin ang lahat ng text sa kasalukuyang pahina o view",
        },
        translateDesc: "Isalin ang napiling teksto gamit ang AI",
      },
      loading: {
        initializing: "Nagsisimula...",
        restoringSession: "Ibinabalik ang session...",
        fetchingAccessToken: "Kinukuha ang access token...",
        loadingDocument: "Nilo-load ang dokumento...",
        ariaLabel: "Naglo-load",
        authenticating: "Nag-a-authenticate...",
        finalizing: "Tinatapos...",
      },
      landingPage: {
        uploadTitle: "I-upload ang Dokumento",
        uploadSubtitle: "I-drag at i-drop ang PDF o EPUB file dito, o i-click para i-upload",
        supportedFormats: "Suportadong format: PDF, EPUB",
        uploadAriaLabel: "I-upload ang PDF o EPUB file",
      },
      errors: {
        failedToLoadPdf: "Nabigong i-load ang PDF",
        failedToLoadEpub: "Nabigong i-load ang EPUB",
        unsupportedFileType: "Hindi suportadong uri ng file. Mag-upload ng PDF o EPUB.",
        errorReadingFile: "Error sa pagbasa ng file.",
        searchFailed: "Nabigo ang paghahanap",
        failedToRestoreSession: "Hindi maibalik ang session.",
        failedToInitializeReader: "Hindi masimulan ang reader mula sa token.",
      },
      readingAssistant: {
        title: "Reading Assistant",
        close: "Isara ang Reading Assistant",
        resize: "Baguhin ang laki ng Reading Assistant",
        resizeHint: "I-drag para baguhin ang laki. I-double-click para i-reset.",
        tabsLabel: "Mga tab ng Reading Assistant",
        tabs: {
          summary: "Buod",
          askAi: "Magtanong sa AI",
          quiz: "Quiz",
        },
        status: {
          loading: "Sinusuri…",
          processing: "Inihanda pa ang dokumentong ito para sa AI. Subukan ulit sa ilang sandali.",
          unavailable: "Hindi available ang AI features para sa dokumentong ito.",
          failed: "Nabigo ang pagproseso ng dokumento. Hindi available ang AI features.",
          error: "Hindi ma-load ang AI features. {{message}}",
        },
        summary: {
          typesLabel: "Uri ng buod",
          types: {
            quick: "Mabilis na buod",
            detailed: "Detalyadong buod",
            chapter: "Buod ayon sa kabanata",
          },
          cardTitles: {
            quick: "Mabilis na buod",
            detailed: "Detalyadong buod",
            chapter: "Buod ayon sa kabanata",
          },
          welcomeTitle: "Reading Assistant",
          welcome: "Maligayang pagdating sa AI reading experience. Pumili ng buod kapag handa ka na.",
          loading: "Gumagawa ng buod",
          error: "Hindi magawa ang buod. {{message}}",
          empty: "Pumili ng uri ng buod para gumawa.",
          chooseChapter: "Pumili ng kabanata sa ibaba para gumawa ng buod.",
          chapterListLabel: "Mga kabanata",
          noChapters: "Walang available na kabanata para sa dokumentong ito.",
          backToTypes: "Bumalik",
          regenerate: "Gawing muli",
        },
        askAi: {
          placeholder: "Magtanong ng kahit ano tungkol sa librong ito...",
          submit: "Ipadala ang tanong",
          empty: "Magtanong para simulan ang usapan.",
          sending: "Nag-iisip",
          error: "Walang nakuha na sagot. {{message}}",
          export: "I-export",
          newChat: "Bagong chat",
        },
        quiz: {
          title: "Mag-quiz",
          subtitle: "Piliin kung ano ang gusto mong i-test.",
          cta: "Simulan ang quiz",
          loading: "Gumagawa ng quiz",
          error: "Hindi magawa ang quiz. {{message}}",
          modalTitle: "AI Quiz",
          disclaimer: "Nilalaman mula sa AI, para sa sanggunian lamang.",
          close: "Isara ang quiz",
          checkAnswer: "Suriin ang sagot",
          explanation: "Paliwanag",
          previous: "Nakaraan",
          next: "Susunod na tanong",
          finish: "Tapos",
          progress: "Tanong {{current}} ng {{total}}",
          answerRequired: "Sagutin ang tanong na ito para magpatuloy.",
          completedTitle: "Tapos na ang quiz!",
          yourScore: "Iyong score",
          completedMessage: "Matagumpay mong natapos ang quiz.",
          reattempt: "Uliting ang quiz",
          save: "I-save",
          saving: "Sineseve…",
          saved: "Nai-save",
          saveError: "Hindi ma-save ang resulta. {{message}}",
          deleteError: "Hindi matanggal ang resulta. {{message}}",
          deleteResult: "Tanggalin ang naka-save na quiz",
          deletedToast: "Natanggal ang quiz",
          recentQuizzes: "Mga kamakailang quiz",
          seeDetails: "Tingnan ang detalye",
          showDetails: "Ipakita ang detalye",
          hideDetails: "Itago ang detalye",
          correct: "Tama",
          incorrect: "Mali",
          multipleChoice: "Multiple choice",
          questionStatusAria: "Tanong {{number}}: {{status}}",
          backToDashboard: "Quiz dashboard",
          scopeLabel: "Saklaw ng quiz",
          scopeBook: "Ayon sa libro",
          scopeChapter: "Ayon sa kabanata",
          scopePage: "Ayon sa pahina",
          scopePageTitle: "Pahina {{page}}",
          scoreAria: "Score {{correct}} sa {{total}}",
          answerOptions: "Mga pagpipilian sa sagot",
          navigationAria: "Nabigasyon ng quiz",
          noQuestions: "Walang ibinalik na tanong sa quiz",
          feedback: {
            greatJob: "Magaling!",
            goodEffort: "Magandang pagsisikap!",
            keepPracticing: "Magpatuloy sa pag-eehersisyo!",
          },
        },
        menu: {
          preferences: "Mga setting ng AI",
          citation: "Sipi ng AI",
          copy: "Kopya ng AI",
          quizzes: "Mga quiz ng AI",
          notes: "Mga tala",
          prefs: {
            aiLanguage: "Gustong wika",
            citationEnabled: "Ipakita ang mga sipi",
            contextInclusionEnabled: "Isama ang konteksto ng pagbabasa",
          },
        },
      },
      pullouts: {
        fallbackTitle: "Pullout",
        hintLabel: "Hint:",
        hintAvailable: "May available na hint",
        expandHint: "Palawakin ang hint",
        collapseHint: "I-collapse ang hint",
      },
      publicationDetails: {
        title: "Mga detalye ng publikasyon",
        close: "Isara ang mga detalye ng publikasyon",
        copy: "Kopyahin ang mga detalye ng publikasyon",
        copied: "Nakopya sa clipboard",
        description: "Paglalarawan",
        noData: "Walang available na data",
        empty: "Walang available na detalye ng publikasyon para sa dokumentong ito.",

        fields: {
          title: "Pamagat",
          author: "May-akda",
          code: "Code",
          type: "Uri",
          language: "Wika",
          original_publisher: "Orihinal na publisher",
          series: "Serye",
          edition: "Edisyon",
          pages: "Mga pahina",
          pisbn13: "PISBN13",
          publication_year: "Taon ng publikasyon",
          copyright_year: "Taon ng copyright",
          read_direction: "Direksyon ng pagbasa",
          content_type: "Uri ng nilalaman",
        },
      },
    },
  },
};

export default resources;
